webpackJsonp([1],{

/***/ "+/dO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("soUz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa726af2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Dm4n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa726af2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+105":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/suppliers');
    }
});
'filehash uPcIglmobivnXBjCz8OkPY8ib9s=';

/***/ }),

/***/ "+VlW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_validation__ = __webpack_require__("6OHK");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        model: {
            type: Object,
            required: true,
            default: {}
        },
        list: {
            type: Array,
            required: false,
            default: []
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        isSub: {
            type: Boolean,
            required: false,
            default: false
        },
        office: {
            type: Number,
            required: true
        },
        msgAlt: {
            type: String,
            required: false,
            default: ""
        }
    },

    data: function data() {
        var _this = this;

        return {
            type: this.model.type.id,
            person: this.model.person.id,

            rules: {
                type: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__helpers_validation__["a" /* default */].required), [function () {
                    return _this.list.filter(function (item) {
                        return item.uuid !== _this.model.uuid && item.type.id === _this.type && !_this.isSub && !item.isSub;
                    }).length === 0 || _this.$t("message.validation.unique");
                }]),
                person: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__helpers_validation__["a" /* default */].required))
            }
        };
    },


    computed: {
        types: function types() {
            var _this2 = this;

            var tFilter = this.$store.getters.approverTypes.filter(function (type) {
                return type.officeId === _this2.office;
            });

            var tFormat = tFilter.map(function (_ref) {
                var id = _ref.id,
                    name = _ref.name,
                    isActive = _ref.isActive;
                return {
                    value: id,
                    text: name,
                    isActive: isActive
                };
            });

            return __WEBPACK_IMPORTED_MODULE_1__helpers_utilities__["a" /* default */].combobox(tFormat, this.type);
        },
        persons: function persons() {
            return this.getPersonHiredAndOffice();
        },
        backgroundAlteracao: function backgroundAlteracao() {
            if (this.msgAlt !== '' && this.msgAlt.indexOf('todos') > -1) {
                return { color: 'red' };
            } else if (this.msgAlt !== '') {
                return { color: 'green' };
            }

            return { color: 'black' };
        }
    },

    watch: {
        type: "update",
        person: "update"
    },

    methods: {
        update: function update() {
            this.$emit("change", {
                id: this.model.id,
                type: { id: this.type },
                person: { id: this.person },
                uuid: this.model.uuid,
                isSub: this.model.isSub
            });
        },
        remove: function remove() {
            this.$emit("remove", this.model.uuid);
        },
        addSub: function addSub() {
            this.$emit("sub", this.model);
        },
        getPersonHiredAndOffice: function getPersonHiredAndOffice() {
            var _this3 = this;

            if (this.$store.getters.profile.person.isHired) {
                var p = this.$store.getters.persons;
                var pFilter = p.filter(function (person) {
                    return person.isActive && (!!person.office && person.office.id === _this3.office || person.isHired);
                });
                return pFilter.map(function (_ref2) {
                    var id = _ref2.id,
                        username = _ref2.username,
                        name = _ref2.name;
                    return {
                        value: id,
                        text: username + " - " + name
                    };
                });
            }
            return this.$store.getters.personsNotHiredSomeOfficeProfileValueText;
        }
    }
});
"filehash ENYG5s9+Q+L/mXxP/k0W1yRyeRw=";

/***/ }),

/***/ "+Xmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/areas');
    },
    get: function get(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/areas/' + id);
    },
    save: function save(form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/areas', form);
    },
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/areas/' + id, form);
    }
});
'filehash iTjow1YtKqpYnxmhJfltalCzQg4=';

/***/ }),

/***/ "/Aav":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialogue_vue__ = __webpack_require__("tJgB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4b9000_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDialogue_vue__ = __webpack_require__("ENGY");
function injectStyle (ssrContext) {
  __webpack_require__("LgBd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f4b9000"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialogue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4b9000_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDialogue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/uTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");




var state = {
    connString: ''
};

var mutations = {
    setconnString: function setconnString(state, connString) {
        state.connString = connString;
    }
};

var actions = {
    fetchConnString: function fetchConnString(_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].admin.serverData();

                        case 2:
                            response = _context.sent;

                            // console.log(response.data.db.sF9527);
                            commit('setconnString', response.data.db.sF9527);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
};

var getters = {
    connString: function connString() {
        return state.connString || '';
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash TA9w4X5wHNoNLAlk1QQ9QS/yQy4=';

/***/ }),

/***/ "0IqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',[_c('v-card-text',[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.$t("label.basicInfo")))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.demandPlanningBasicInfo'))}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.estimatedQuantity"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{staticClass:"estimated-quantity",attrs:{"disabled":_vm.disabled || _vm.isInternalSupplier,"suffix":_vm.unit,"rules":_vm.validation.requiredNumeric,"maxlength":_vm.constants.LENGTH_ESTIMATED_TIME},model:{value:(_vm.form.estimatedTime),callback:function ($$v) {_vm.$set(_vm.form, "estimatedTime", $$v)},expression:"form.estimatedTime"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-2",attrs:{"xs7":"","lg8":""}},[(_vm.form.estimatedTime)?_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.cost))]):_vm._e()])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.estimatedDeliveryDate")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('app-menu-date-picker',{attrs:{"model":_vm.form.estimatedDeliveryDate,"disabled":_vm.disabled,"label":_vm.$t('label.estimatedDeliveryDate')},on:{"update:model":function($event){return _vm.$set(_vm.form, "estimatedDeliveryDate", $event)}}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.deliveryTime")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled || _vm.isInternalSupplier,"suffix":_vm.$t('label.days'),"rules":_vm.validation.biggerThanZero,"mask":_vm.validation.mask.daysToDelivery},model:{value:(_vm.form.daysToDelivery),callback:function ($$v) {_vm.$set(_vm.form, "daysToDelivery", $$v)},expression:"form.daysToDelivery"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(this.demand.status.id <= 4),expression:"this.demand.status.id <= 4"}]},[_c('div',{staticStyle:{"display":"ruby"}},[_c('strong',[_c('v-flex',[_c('label',{staticClass:"form-label",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(_vm.getFormattedDate(_vm.form.maximumApprovalDeliveryDate))+"\n              ")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"subheading mt-3"},[_vm._v(_vm._s(_vm.$t("label.details")))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.demandPlanningDetails'))}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.description"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":_vm.disabled,"rules":_vm.validation.text,"auto-grow":"","counter":_vm.constants.LENGTH_DESCRIPTION,"maxlength":_vm.constants.LENGTH_DESCRIPTION},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.files.length > 0),expression:"form.files.length > 0"}],staticClass:"mt-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs9":"","lg10":"","offset-xs3":"","offset-lg2":""}},[_c('app-files',{attrs:{"files":_vm.form.files,"removedFiles":_vm.form.removedFiles,"removeable":!_vm.disabled},on:{"update:files":function($event){return _vm.$set(_vm.form, "files", $event)},"update:removedFiles":function($event){return _vm.$set(_vm.form, "removedFiles", $event)},"update:removed-files":function($event){return _vm.$set(_vm.form, "removedFiles", $event)}}})],1)],1)],1),_vm._v(" "),(!_vm.disabled)?_c('v-card-actions',[_c('v-btn',{attrs:{"loading":_vm.saving,"color":"primary","disabled":_vm.disableApprovalButton},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t("label.requestApproval")))]),_vm._v(" "),_c('app-file-upload',{attrs:{"disabled":_vm.saving,"model":_vm.form.files},on:{"update:model":function($event){return _vm.$set(_vm.form, "files", $event)}}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning","loading":_vm.rejecting,"disabled":_vm.saving},on:{"click":_vm.reject}},[_vm._v(_vm._s(_vm.$t("label.reject")))])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Rs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__ = __webpack_require__("HUpA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import constants from '@/helpers/constants';



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pagination: {
                descending: true,
                sortBy: 'acronym'
            },
            headers: [{
                text: this.$t('label.code'),
                value: 'acronym',
                align: 'left'
            }, {
                text: this.$t('label.name'),
                value: 'name',
                align: 'left'
            }, {
                text: this.$t('label.description'),
                value: 'description',
                align: 'left',
                sortable: false
            }]
        };
    },


    computed: {
        readonly: function readonly() {
            return !this.$store.getters.profile.isAdmin && !this.$store.getters.profile.isRoot;
        }
    },

    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__["a" /* default */]
    },

    methods: {
        search: function search(filters) {
            var systems = this.$store.getters.systems;

            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(systems, filters, function (system, regex) {
                return regex.test(system.acronym) || regex.test(system.name) || regex.test(system.description);
            });
        },
        refresh: function refresh() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadSystems');

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});
'filehash WDtO49fJf70AgZZ2Pn2TbGbbmXs=';

/***/ }),

/***/ "0iMK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__ = __webpack_require__("ml+B");


/* eslint no-unused-vars: ["error", { "args": "none" }] */




var state = {
    approverType: {},
    approverTypes: []
};

var mutations = {
    setApproverType: function setApproverType(state, approverType) {
        state.approverType = approverType;
    },
    setApproverTypes: function setApproverTypes(state, approverTypes) {
        state.approverTypes = approverTypes;
    }
};

var actions = {
    loadApproverTypes: function loadApproverTypes(_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].approverTypes.list();

                        case 2:
                            response = _context.sent;

                            commit('setApproverTypes', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    fetchApproverType: function fetchApproverType(_ref2, id) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].approverTypes.get(id);

                        case 2:
                            response = _context2.sent;

                            commit('setApproverType', response.data);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    removeApproverType: function removeApproverType(_ref3, form) {
        var _this3 = this;

        var dispatch = _ref3.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].approverTypes.remove(form.id);

                        case 2:
                            _context3.next = 4;
                            return dispatch('loadApproverTypes');

                        case 4:

                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('message.success.approverTypeRemoved'));

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    saveApproverType: function saveApproverType(_ref4, form) {
        var _this4 = this;

        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            state = _ref4.state;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].approverTypes.save(form);

                        case 2:
                            response = _context4.sent;
                            _context4.next = 5;
                            return dispatch('fetchApproverType', response.data.id);

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    saveOrUpdateApproverType: function saveOrUpdateApproverType(_ref5, form) {
        var _this5 = this;

        var dispatch = _ref5.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(form.id)) {
                                _context5.next = 5;
                                break;
                            }

                            _context5.next = 3;
                            return dispatch('saveApproverType', form);

                        case 3:
                            _context5.next = 7;
                            break;

                        case 5:
                            _context5.next = 7;
                            return dispatch('updateApproverType', form);

                        case 7:
                            _context5.next = 9;
                            return dispatch('loadApproverTypes');

                        case 9:
                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('message.success.saved'));

                        case 10:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    updateApproverType: function updateApproverType(_ref6, form) {
        var _this6 = this;

        var dispatch = _ref6.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].approverTypes.update(form.id, form);

                        case 2:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    }
};

var getters = {
    approverType: function approverType(state) {
        return state.approverType;
    },
    approverTypes: function approverTypes(state) {
        var approverTypes = state.approverTypes || [];
        return approverTypes.sort(function (a, b) {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].stringCompare(a.name, b.name);
        }).filter(function (item) {
            return item.id !== 8;
        });
    },
    approverTypesValueText: function approverTypesValueText(_, getters) {
        return getters.approverTypes.map(function (_ref7) {
            var id = _ref7.id,
                name = _ref7.name,
                isActive = _ref7.isActive;
            return {
                value: id,
                text: name,
                isActive: isActive
            };
        });
    },
    approverTypesDictionary: function approverTypesDictionary(_, getters) {
        return getters.approverTypes.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash jGye4W4yK7hNvVWWbK8FleMVWGM=';

/***/ }),

/***/ "1NdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.refresh,"pagination":_vm.pagination},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'personEdit', params: { id: item.id } },"tag":"tr"}},[_c('td',{staticClass:"area-name"},[_vm._v(_vm._s(_vm._f("areaToString")(item.area)))]),_vm._v(" "),_c('td',{staticClass:"person-username"},[_vm._v(_vm._s(item.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.emailAddress))]),_vm._v(" "),_c('td',{staticClass:"is-active"},[_vm._v(_vm._s(item.status))])])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1hy9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('p',{staticClass:"body-1 grey--text text--darken-1 mt-4"},[_vm._v("\n    "+_vm._s(_vm.$t("label.yourApproval"))+"\n  ")]),_vm._v(" "),_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"multi-line":"","auto-grow":"","counter":_vm.constants.LENGTH_COMMENTS,"maxlength":_vm.constants.LENGTH_COMMENTS},model:{value:(_vm.form.comments),callback:function ($$v) {_vm.$set(_vm.form, "comments", $$v)},expression:"form.comments"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.files.length > 0),expression:"form.files.length > 0"}],staticClass:"mt-3",attrs:{"row":""}},[_c('v-flex',[_c('app-files',{attrs:{"files":_vm.form.files,"removedFiles":_vm.form.removedFiles,"removeable":true},on:{"update:files":function($event){return _vm.$set(_vm.form, "files", $event)},"update:removedFiles":function($event){return _vm.$set(_vm.form, "removedFiles", $event)},"update:removed-files":function($event){return _vm.$set(_vm.form, "removedFiles", $event)}}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"success","loading":_vm.approving,"disabled":_vm.rejecting || _vm.disableApprovalButton},on:{"click":_vm.approve}},[_vm._v(_vm._s(_vm.$t("label.approve")))]),_vm._v(" "),_c('app-file-upload',{attrs:{"disabled":_vm.approving || _vm.rejecting,"model":_vm.form.files},on:{"update:model":function($event){return _vm.$set(_vm.form, "files", $event)}}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning","loading":_vm.rejecting,"disabled":_vm.approving || _vm.disableRejectButton},on:{"click":_vm.reject}},[_vm._v(_vm._s(_vm.$t("label.reject")))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1wIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        errorCode: function errorCode() {
            return this.$route.params.id;
        },
        errorCodeLabel: function errorCodeLabel() {
            return this.$t("type.httpError." + this.errorCode);
        },
        message: function message() {
            return this.$store.getters.apiEvent.message;
        },
        profile: function profile() {
            return this.$store.getters.profile;
        }
    }
});
"filehash 18Ywe/d83CJVzFWxR8W+7GHw11M=";

/***/ }),

/***/ "2V8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_entities_DemandBilling__ = __webpack_require__("WiLw");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_4__helpers_validation__["a" /* default */],
            creatingReport: false,
            date: null,
            form: __WEBPACK_IMPORTED_MODULE_5__helpers_entities_DemandBilling__["a" /* default */].build()
        };
    },


    computed: {
        contracts: function contracts() {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].combobox(this.$store.getters.contractsValueText, this.form.contractId);
        },
        contractItems: function contractItems() {
            var _this = this;

            return this.$store.getters.contractItemsValueText.filter(function (item) {
                return item.contractId === _this.form.contractId;
            });
        },
        systems: function systems() {
            var _this2 = this;

            return this.$store.getters.activeSystemsValueText.filter(function (item) {
                return item.contractItemId === _this2.form.contractItemId;
            });
            // return this.$store.getters.activeSystemsValueText;
        }
    },
    watch: {
        date: function date() {
            this.form.reference = this.formatReference(this.date);
        }
    },

    methods: {
        clear: function clear() {
            this.date = null;
            this.form = __WEBPACK_IMPORTED_MODULE_5__helpers_entities_DemandBilling__["a" /* default */].build();
        },
        formatReference: function formatReference(date) {
            if (!date) return null;

            var _date$split = date.split('-'),
                _date$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_date$split, 2),
                year = _date$split2[0],
                month = _date$split2[1];

            return year + month;
        },
        createReport: function createReport() {
            if (!this.$refs.form.validate()) return;
            this.creatingReport = true;
            var reportName = 'RelatorioFaturamento';
            this.ajaxDownload('application/pdf', reportName);
        },
        createCsvReport: function createCsvReport() {
            if (!this.$refs.form.validate()) return;
            this.creatingReport = true;
            var reportName = 'RelatorioFaturamento.csv';
            this.ajaxCsvDownload('application/csv', reportName);
        },
        ajaxDownload: function ajaxDownload(type, name) {
            var xhr = new XMLHttpRequest();
            var url = "https://ngdsapi.prodam.sp.gov.br/api";
            var reportUrl = '/reports/demandBilling';
            var self = this;
            xhr.open('POST', url + reportUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/pdf');
            xhr.responseType = 'arraybuffer';
            xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__helpers_entities_DemandBilling__["a" /* default */].toPayload(this.form)));
            xhr.onprogress = this.callback;
            xhr.onload = function onload() {
                if (this.status === 200) {
                    var blob = new Blob([this.response], { type: type });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = name;
                    link.click();
                    link.remove();
                }
            };
            self.creatingReport = false;
        },
        ajaxCsvDownload: function ajaxCsvDownload(type, name) {
            var xhr = new XMLHttpRequest();
            var url = "https://ngdsapi.prodam.sp.gov.br/api";
            var reportUrl = '/reports/demandBillingCsv';
            xhr.open('POST', url + reportUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/csv');
            xhr.responseType = 'arraybuffer';
            xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__helpers_entities_DemandBilling__["a" /* default */].toPayload(this.form)));
            xhr.onprogress = this.callback;
            xhr.onload = function onload() {
                if (this.status === 200) {
                    var blob = new Blob([this.response], { type: type });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = name;
                    link.click();
                    link.remove();
                }
            };
            this.creatingReport = false;
        }
    }
});
'filehash NpxkhcQ80ZSbXLjqHVjBnRU5eDY=';

/***/ }),

/***/ "2it3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_CardLoader__ = __webpack_require__("JqcZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_entities_DemandType__ = __webpack_require__("3tC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Step__ = __webpack_require__("AHNr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_4__helpers_validation__["a" /* default */],
            valid: true,
            removing: false,
            saving: false,
            loading: true,

            statuses: [__WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_CREATED_APPROVAL, __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_PLANNING_APPROVAL, __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_DELIVERY_APPROVAL, __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_FINALIZING],

            form: __WEBPACK_IMPORTED_MODULE_6__helpers_entities_DemandType__["a" /* default */].build()
        };
    },


    computed: {
        disabled: function disabled() {
            return !this.$store.getters.isAdmin || !this.form.isActive;
        }
    },

    components: {
        appStep: __WEBPACK_IMPORTED_MODULE_7__Step__["a" /* default */],
        appCardLoader: __WEBPACK_IMPORTED_MODULE_5__components_shared_CardLoader__["a" /* default */]
    },

    watch: {
        $route: 'fetch'
    },

    created: function created() {
        this.fetch();
    },


    methods: {
        addStep: function addStep(status) {
            this.form.steps.splice(this.form.steps.length, 0, __WEBPACK_IMPORTED_MODULE_6__helpers_entities_DemandType__["a" /* default */].step.build(status));
        },
        filterSteps: function filterSteps(status) {
            return this.form.steps.filter(function (step) {
                return step.status.id === status;
            });
        },
        removeStep: function removeStep(uuid) {
            var index = this.form.steps.map(function (step) {
                return step.uuid;
            }).indexOf(uuid);
            this.form.steps.splice(index, 1);
        },
        updateStep: function updateStep(obj) {
            var index = this.form.steps.map(function (step) {
                return step.uuid;
            }).indexOf(obj.uuid);
            this.form.steps.splice(index, 1, obj);
        },
        fetch: function fetch() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;

                                if (__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(_this.$route.params.id)) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 4;
                                return _this.$store.dispatch('fetchDemandType', _this.$route.params.id);

                            case 4:
                                _this.form = __WEBPACK_IMPORTED_MODULE_6__helpers_entities_DemandType__["a" /* default */].toForm(_this.$store.getters.demandType);

                            case 5:

                                _this.loading = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        remove: function remove() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.removing = true;
                                _context2.next = 3;
                                return _this2.$store.dispatch('removeDemandType', _this2.form);

                            case 3:
                                _this2.$router.push({ name: 'typeDemandIndex' });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        save: function save() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (_this3.$refs.form.validate()) {
                                    _context3.next = 2;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 2:

                                _this3.saving = true;
                                _context3.next = 5;
                                return _this3.$store.dispatch('saveOrUpdateDemandType', __WEBPACK_IMPORTED_MODULE_6__helpers_entities_DemandType__["a" /* default */].toPayload(_this3.form));

                            case 5:
                                _this3.$router.push({ name: 'typeDemandIndex' });

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    }
});
'filehash N5v2p/nbHvIeV2lJdfaMRvTEWAY=';

/***/ }),

/***/ "2rH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","offset-xs4":""}},[_c('v-card',[_c('v-card-text',[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"title mb-3 mt-1"},[_vm._v("\n                        GDS — Gestão de Demandas e Serviços\n                    ")]),_vm._v(" "),_c('label',{staticClass:"form-label text-xs-left"},[_vm._v(_vm._s(_vm.$t("label.user")))]),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.validation.login,"validate-on-blur":true},model:{value:(_vm.form.username),callback:function ($$v) {_vm.$set(_vm.form, "username", $$v)},expression:"form.username"}}),_vm._v(" "),_c('label',{staticClass:"form-label text-xs-left"},[_vm._v(_vm._s(_vm.$t("label.password")))]),_vm._v(" "),_c('v-text-field',{attrs:{"type":"password","rules":_vm.validation.password,"validate-on-blur":true},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-0",attrs:{"type":"submit","color":"primary","loading":_vm.loading}},[_vm._v(_vm._s(_vm.$t("label.enter")))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2s8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        model: {
            type: String
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        label: {
            type: String,
            required: false
        },
        rules: {
            type: Array,
            required: false,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            picker: this.model,
            formatted: this.model !== null ? this.formatDate(this.model) : "",
            menu: false
        };
    },

    watch: {
        picker: "emit",
        model: "copy"
    },
    methods: {
        copy: function copy() {
            this.picker = this.model;
            this.formatted = this.model !== null ? this.formatDate(this.model) : "";
        },
        emit: function emit(val) {
            if (!val.includes("T00:00")) val += "T00:00";
            this.$emit("update:model", val);
            this.$emit("change", val);
        },
        formatDate: function formatDate(val) {
            if (!val) return "";
            if (!val.includes("T00:00")) val += "T00:00";
            return new Date(val).toLocaleDateString("pt-BR");
        }
    }
});
"filehash zL7WU3Opv/rEyGFxB1r7ticwOWM=";

/***/ }),

/***/ "2wj1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3XN7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__steps_Closure__ = __webpack_require__("kKQe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__steps_Delivery__ = __webpack_require__("3ug0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__steps_Creation__ = __webpack_require__("W8j6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__steps_Planning__ = __webpack_require__("KZDP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_WorkflowHistory__ = __webpack_require__("VWKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_Evaluation__ = __webpack_require__("9QB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_Approve__ = __webpack_require__("jtxW");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    // props, data, computed
    data: function data() {
        return {
            loading: true,
            currentStep: "1"
        };
    },

    computed: {
        demand: function demand() {
            return this.$store.getters.demand;
        },
        dtImplementation: function dtImplementation() {
            return this.demand.dtImplementation;
        },
        qtdDays: function qtdDays() {
            console.log('qtdDays', this.demand.qtdDays);
            return this.demand.qtdDays;
        },
        code: function code() {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(this.demand.id) ? "-" : "D" + this.demand.code;
        },
        owner: function owner() {
            var statusId = (this.demand.status || {}).id;
            var supplierId = (this.demand.supplier || {}).id;
            var currentStep = Number(this.currentStep);
            var shouldShowProdam = supplierId === 1 && [7].includes(statusId) && !(statusId === 7 && this.demand.dtImplementation);
            // [3, 5, 7].includes(statusId)
            // se necessário, adicionar outros status aqui, como no ex acima
            if (shouldShowProdam) {
                return "Prodam";
            }
            return __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(this.demand.id) ? "-" : this.demand.owner.name;
        },
        ownerProdam: function ownerProdam() {
            return "Prodam";
        },
        status: function status() {
            console.log('Status ID:', this.demand.status && this.demand.status.id);
            if (__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(this.demand.id)) {
                return "-";
            }
            if (this.demand.status && !this.demand.dtImplementation && this.demand.status.id === 7 && this.demand.supplier.id === 1) {
                return "Entrega Aprovada - Implantação";
            }
            if (this.demand.status && this.demand.dtImplementation && this.demand.status.id === 7) {
                return "Encerramento - Aguardando conclusão";
            }
            return this.$t("type.status")[this.demand.status.id];
        },
        isDemandEnabled: function isDemandEnabled() {
            return true;
        },
        isApprovalEnabled: function isApprovalEnabled() {
            return this.stepEnabled(__WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_CREATED_APPROVAL);
        },
        isPlanningEnabled: function isPlanningEnabled() {
            return this.stepEnabled(__WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_PLANNING);
        },
        isValidationEnabled: function isValidationEnabled() {
            return this.stepEnabled(__WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_DELIVERY);
        },
        isClosureEnabled: function isClosureEnabled() {
            return this.stepEnabled(__WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_FINALIZING);
        },
        demandIcon: function demandIcon() {
            return this.stepIcon(this.isApprovalEnabled);
        },
        approvalIcon: function approvalIcon() {
            return this.stepIcon(this.isPlanningEnabled);
        },
        planningIcon: function planningIcon() {
            return this.stepIcon(this.isValidationEnabled);
        },
        validationIcon: function validationIcon() {
            return this.stepIcon(this.isClosureEnabled);
        },
        closureIcon: function closureIcon() {
            return this.stepIcon(this.stepEnabled(__WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_DONE));
        },
        showOwner: function showOwner() {
            return this.demand.status.id < __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_REJECTED;
        },
        workFlowHistoryForCurrentStep: function workFlowHistoryForCurrentStep() {
            var history = this.demand.workflowHistory;

            switch (this.currentStep) {
                case "1":
                    return __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].filterByStatus(history, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_CREATED, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_REJECTED, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_CREATED_APPROVAL);
                case "2":
                    return __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].filterByStatus(history, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_PLANNING, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_PLANNING_APPROVAL);
                case "3":
                    return __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].filterByStatus(history, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_DELIVERY, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_DELIVERY_APPROVAL);
                case "4":
                    return __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].filterByStatus(history, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_FINALIZING);
                default:
                    return [];
            }
        },
        canApprove: function canApprove() {
            var _this = this,
                _hash;

            if (this.$store.getters.profile.person.id !== this.demand.owner.id && (!this.demand.subOwners || this.demand.subOwners.filter(function (owner) {
                return owner.id === _this.$store.getters.profile.person.id;
            }).length === 0) && !this.$store.getters.isAdmin) {
                return false;
            }

            var hash = (_hash = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_hash, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_CREATED_APPROVAL, "1"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_hash, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_PLANNING_APPROVAL, "2"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_hash, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_DELIVERY_APPROVAL, "3"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_hash, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_FINALIZING, "4"), _hash);

            return this.currentStep === hash[this.demand.status.id];
        },
        approvalMessage: function approvalMessage() {
            var _hash2;

            var hash = (_hash2 = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_hash2, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_CREATED_APPROVAL, this.$t("message.info.demandCreationApproval")), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_hash2, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_PLANNING_APPROVAL, this.$t("message.info.demandPlanningApproval")), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_hash2, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_DELIVERY_APPROVAL, this.$t("message.info.demandDeliveryApproval")), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_hash2, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].STATUS_FINALIZING, this.$t("message.info.demandFinalizing")), _hash2);

            return hash[this.demand.status.id] || "";
        }
    },

    components: {
        appClosure: __WEBPACK_IMPORTED_MODULE_5__steps_Closure__["a" /* default */],
        appDelivery: __WEBPACK_IMPORTED_MODULE_6__steps_Delivery__["a" /* default */],
        appCreation: __WEBPACK_IMPORTED_MODULE_7__steps_Creation__["a" /* default */],
        appPlanning: __WEBPACK_IMPORTED_MODULE_8__steps_Planning__["a" /* default */],
        appWorkflowHistory: __WEBPACK_IMPORTED_MODULE_9__shared_WorkflowHistory__["a" /* default */],
        appApprove: __WEBPACK_IMPORTED_MODULE_11__shared_Approve__["a" /* default */],
        appEvaluation: __WEBPACK_IMPORTED_MODULE_10__shared_Evaluation__["a" /* default */]
    },

    watch: {
        $route: "fetchDemand"
    },

    created: function created() {
        this.$store.dispatch("resetDemand");
        // consulta a demanda selecionada no Grid tela Demadas.
        this.fetchDemand();
    },


    methods: {
        formatDate: function formatDate(dateString) {
            var date = new Date(dateString);
            var day = date.getDate().toString().padStart(2, '0');
            var month = (date.getMonth() + 1).toString().padStart(2, '0');
            var year = date.getFullYear();
            return day + "/" + month + "/" + year;
        },
        formatDateAndSubtractDays: function formatDateAndSubtractDays(dateString, daysToSubtract) {
            var date = new Date(dateString);
            date.setDate(date.getDate() + daysToSubtract + 1);
            var day = date.getDate().toString().padStart(2, '0');
            var month = (date.getMonth() + 1).toString().padStart(2, '0');
            var year = date.getFullYear();
            return day + "/" + month + "/" + year;
        },
        stepEnabled: function stepEnabled(value) {
            return !this.loading && this.demand.status.id >= value;
        },
        stepIcon: function stepIcon(isNextStepEnabled) {
            return isNextStepEnabled ? "check" : "edit";
        },
        fetchDemand: function fetchDemand() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var id;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this2.currentStep = "1";
                                id = _this2.$route.params.id;

                                if (__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(id)) {
                                    _context.next = 6;
                                    break;
                                }

                                console.log('Fetching demand with ID:', id);
                                _context.next = 6;
                                return _this2.$store.dispatch("fetchDemand", id);

                            case 6:

                                _this2.loading = false;

                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    }
});
"filehash Wulf+S6MSaRiaBuJJeFMONKkJPM=";

/***/ }),

/***/ "3dgQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[(!_vm.loading)?_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[_c('div',{staticClass:"subheading mb-3"},[_vm._v("Atualizar Contrato")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v("Contrato antigo")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","lg8":""}},[_c('v-select',{attrs:{"disabled":"","items":_vm.contracts},model:{value:(_vm.form.id),callback:function ($$v) {_vm.$set(_vm.form, "id", $$v)},expression:"form.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v("Contrato novo*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg8":""}},[_c('v-select',{attrs:{"autocomplete":"","items":_vm.contracts,"clearable":"","rules":_vm.validation.required},on:{"change":_vm.getContractItems},model:{value:(_vm.form.newId),callback:function ($$v) {_vm.$set(_vm.form, "newId", $$v)},expression:"form.newId"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"subheading mt-3"},[_vm._v("Atualizar Cesta")]),_vm._v(" "),_vm._l((_vm.form.items),function(item,i){return _c('v-layout',{key:i,attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v("Cesta")])]),_vm._v(" "),_c('v-flex',{staticClass:"pr-3",attrs:{"xs6":"","lg4":""}},[_c('v-text-field',{attrs:{"disabled":""},model:{value:(item.description),callback:function ($$v) {_vm.$set(item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","lg4":""}},[_c('v-select',{attrs:{"disabled":_vm.itemInUseWarning(item),"autocomplete":"","items":_vm.getContractItems,"rules":_vm.firstItemRule(item.id),"clearable":""},model:{value:(_vm.form.newContractItems[i]),callback:function ($$v) {_vm.$set(_vm.form.newContractItems, i, $$v)},expression:"form.newContractItems[i]"}})],1),_vm._v(" "),(_vm.itemInUseWarning(item))?_c('v-flex',{staticClass:"pl-2 pt-1"},[_c('span',[_vm._v("**")])]):_vm._e()],1)}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v("Situação da demanda*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg8":""}},[_c('v-select',{attrs:{"items":_vm.statesValueText,"item-text":"text","item-value":"value","chips":"","multiple":"","rules":[function (v) { return v.length > 0 || 'Obrigatório'; }],"required":""},on:{"change":_vm.selectAll},model:{value:(_vm.selectedStates),callback:function ($$v) {_vm.selectedStates=$$v},expression:"selectedStates"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Selecione todos","indeterminate":_vm.indeterminateCheckbox()},on:{"change":_vm.toggleCheckbox},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}})],1)],1),_vm._v(" "),(_vm.msgNotUsed === true)?_c('v-layout',{attrs:{"row":""}},[_c('span',[_vm._v("**Cesta não utilizada em nenhum sistema ou demanda")])]):_vm._e()],2),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"loading":_vm.saving,"color":"primary"},on:{"click":_vm.save}},[_vm._v("\n            Atualizar\n          ")])],1)],1):_c('v-card',[_c('app-card-loader')],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v("\n            Pelo menos 1 das cestas em uso não será substituida, deseja mesmo assim inativar o contrato?\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","text":""},on:{"click":function($event){_vm.dialog = false, _vm.form.isActive = true, _vm.sendData()}}},[_vm._v("\n              Não\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green","text":""},on:{"click":function($event){_vm.dialog = false, _vm.form.isActive = false, _vm.sendData()}}},[_vm._v("\n              Sim\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3tC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");


/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build() {
        return {
            id: null,
            name: '',
            description: '',
            isActive: true,
            isInUse: false,
            steps: []
        };
    },
    toForm: function toForm(obj) {
        var clone = __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toForm(obj, this.build());

        // 8 = NO APPROVER
        clone.steps = clone.steps.filter(function (step) {
            return step.approverType.officeId !== 0;
        });

        return clone;
    },
    toPayload: function toPayload(obj) {
        var clone = __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toPayload(obj);
        // if (clone.isInUse) clone.steps = null;

        return clone;
    },


    step: {
        build: function build(status) {
            return {
                id: 0,
                status: { id: status },
                approverType: { id: 0, officeId: 0 },
                costThreshold: '',
                uuid: __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].uuidv4()
            };
        }
    }
});
'filehash 4R/3uWwpFq8VdqSDZshYT99vUfk=';

/***/ }),

/***/ "3ug0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("zJdg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5007c84c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("TUIa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5007c84c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3yes":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");




var state = {
    contractItems: []
};

var mutations = {
    setContractItems: function setContractItems(state, contractItems) {
        state.contractItems = contractItems;
    }
};

var actions = {
    loadContractItems: function loadContractItems(_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].contractItems.list();

                        case 2:
                            response = _context.sent;

                            commit('setContractItems', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
};

var getters = {
    contractItems: function contractItems(state) {
        return state.contractItems || [];
    },
    contractItemsValueText: function contractItemsValueText(_, getters) {
        return getters.contractItems.map(function (item) {
            return {
                value: item.id,
                text: item.description,
                contractId: item.contract.id
            };
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash uRG5ADaGH6DDxMG4hBRwbpG322k=';

/***/ }),

/***/ "47Dw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[(!_vm.loading)?_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[(!_vm.form.isActive)?_c('v-alert',{staticClass:"mb-3",attrs:{"color":"error","icon":"error","value":"true"}},[_vm._v("\n                        "+_vm._s(_vm.$t('message.info.demandTypeInactive'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subheading mb-3"},[_vm._v(_vm._s(_vm.$t('title.demandType')))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.name'))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.text,"counter":_vm.constants.LENGTH_TYPE_DEMAND_NAME,"maxlength":_vm.constants.LENGTH_TYPE_DEMAND_NAME},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.description'))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":_vm.disabled,"rules":_vm.validation.text,"autoGrow":"","counter":_vm.constants.LENGTH_TYPE_DEMAND_DESCRIPTION,"maxlength":_vm.constants.LENGTH_TYPE_DEMAND_DESCRIPTION},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.$t('label.approvalCycle')))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.demandTypeApprovers'))}}),_vm._v(" "),_vm._l((_vm.statuses),function(status){return _c('v-layout',{key:status,attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('type.status')[status]))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},_vm._l((_vm.filterSteps(status)),function(step){return _c('app-step',{key:step.uuid,attrs:{"model":step,"list":_vm.filterSteps(status),"disabled":_vm.disabled || _vm.form.isInUse},on:{"remove":_vm.removeStep,"change":_vm.updateStep}})}),1)],1)})],2),_vm._v(" "),(!_vm.disabled)?_c('v-card-actions',[_c('v-btn',{attrs:{"loading":_vm.saving,"disabled":_vm.removing,"color":"primary"},on:{"click":_vm.save}},[_vm._v("\n                        "+_vm._s(_vm.$t('label.save'))+"\n                    ")]),_vm._v(" "),(!_vm.form.isInUse)?_c('v-menu',[_c('v-btn',{attrs:{"slot":"activator","disabled":_vm.saving || _vm.removing},slot:"activator"},[_c('v-icon',{staticClass:"mr-3"},[_vm._v("supervisor_account")]),_vm._v("\n                            "+_vm._s(_vm.$t('label.addStep'))+"\n                        ")],1),_vm._v(" "),_c('v-list',_vm._l((_vm.statuses),function(status){return _c('v-list-tile',{key:status,on:{"click":function($event){return _vm.addStep(status)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('type.status')[status]))])],1)}),1)],1):_vm._e(),_vm._v(" "),(!!_vm.form.id)?_c('v-btn',{attrs:{"disabled":_vm.saving,"loading":_vm.removing,"color":"error"},on:{"click":_vm.remove}},[_vm._v("\n                        "+_vm._s(_vm.form.isInUse ? _vm.$t('label.inactivate') : _vm.$t('label.remove'))+"\n                    ")]):_vm._e()],1):_vm._e()],1):_c('v-card',[_c('app-card-loader')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4XQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/demand-types');
    },
    get: function get(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/demand-types/' + id);
    },
    remove: function remove(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete('/demand-types/' + id);
    },
    save: function save(form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/demand-types', form);
    },
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/demand-types/' + id, form);
    }
});
'filehash Z5uymMOHBuTQWWywRrGypPHfMz4=';

/***/ }),

/***/ "4eBV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/persons');
    },
    fetch: function fetch(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/persons/' + id);
    },
    save: function save(form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/persons', form);
    },
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/persons/' + id, form);
    }
});
'filehash lilrts5r6ORWGjBh2uL8wJfF4a0=';

/***/ }),

/***/ "4kY7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("0Rs0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d905114c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("G4sW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d905114c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4o7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dialog-loader',{directives:[{name:"show",rawName:"v-show",value:(this.loading),expression:"this.loading"}]}),_vm._v(" "),(!this.loading)?_c('div',[_c('div',{staticClass:"flex xs12 lg10 offset-lg1",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('h2',[_vm._v("Demandas Avaliadas")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Voltar")])],1),_vm._v(" "),_c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"pagination":_vm.pagination,"placeholder":_vm.placeholder},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [(item.evaluationComments.length > 0)?_c('router-link',{attrs:{"to":{ name: 'officeEvaluatedDemandComments', params: { demandId: item.id }},"tag":"tr"}},[_c('td',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.system.acronym))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type.name))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.evaluationAverage))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v("Sim")])])]):_c('router-link',{attrs:{"to":{ name: 'officeEvaluatedDemands', params: { demandId: item.id }},"tag":"tr"}},[_c('td',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.system.acronym))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type.name))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.evaluationAverage))])]),_vm._v(" "),_c('td',[_c('label',[_vm._v("Não")])])])]}}],null,false,3138045578)})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Au0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/contract-items');
    },
    get: function get(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/contract-items/' + id);
    }
});
'filehash mu3JmWeE8t/2ZQbIy9L7KK8sYms=';

/***/ }),

/***/ "5Bfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_File_vue__ = __webpack_require__("XGL4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2fdcf10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_File_vue__ = __webpack_require__("LGxs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_File_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2fdcf10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_File_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5NyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[(!_vm.loading)?_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[(!_vm.form.isActive)?_c('v-alert',{staticClass:"mb-3",attrs:{"color":"error","icon":"error","value":"true"}},[_vm._v("\n            "+_vm._s(_vm.$t("message.info.contractInactive"))+"\n          ")]):(_vm.form.isInUse)?_c('v-alert',{staticClass:"mb-3",attrs:{"color":"warning","icon":"warning","value":"true"}},[_vm._v("\n            "+_vm._s(_vm.$t("message.info.contractInUse"))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subheading mb-3"},[_vm._v(_vm._s(_vm.$t("label.basicInfo")))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.contractNumber"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"placeholder":"NNNNNN/AA","mask":_vm.validation.mask.contract,"return-masked-value":"","rules":_vm.validation.required,"maxlength":_vm.constants.LENGTH_CONTRACT},model:{value:(_vm.form.number),callback:function ($$v) {_vm.$set(_vm.form, "number", $$v)},expression:"form.number"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.description"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","lg4":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.text,"maxlength":_vm.constants.LENGTH_CONTRACT_DESCRIPTION},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.contractObject")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":_vm.disabled,"auto-grow":"","counter":_vm.constants.LENGTH_CONTRACT_OBJECT,"maxlength":_vm.constants.LENGTH_CONTRACT_OBJECT},model:{value:(_vm.form.subjectMatter),callback:function ($$v) {_vm.$set(_vm.form, "subjectMatter", $$v)},expression:"form.subjectMatter"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.office"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled,"items":_vm.offices,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.office.id),callback:function ($$v) {_vm.$set(_vm.form.office, "id", $$v)},expression:"form.office.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.warranty")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"mask":_vm.validation.mask.warrantyDays,"suffix":_vm.$t('label.days')},on:{"change":_vm.clearWarrantyDate},model:{value:(_vm.form.warrantyDays),callback:function ($$v) {_vm.$set(_vm.form, "warrantyDays", _vm._n($$v))},expression:"form.warrantyDays"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-3",attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.warrantyValidity")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('app-menu-date-picker',{attrs:{"disabled":_vm.disabled,"model":_vm.form.warrantyValidityTerm.start,"rules":_vm.warrantValidityTermStartRule},on:{"update:model":function($event){return _vm.$set(_vm.form.warrantyValidityTerm, "start", $event)},"change":_vm.clearWarrantyDays}})],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-3",attrs:{"xs2":"","lg2":""}},[_c('app-menu-date-picker',{attrs:{"disabled":_vm.disabled,"model":_vm.form.warrantyValidityTerm.finish,"rules":_vm.warrantvalidityTermFinishRule},on:{"update:model":function($event){return _vm.$set(_vm.form.warrantyValidityTerm, "finish", $event)},"change":_vm.clearWarrantyDays}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-2 pl-2",attrs:{"xs1":""}},[_c('v-icon',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.clearWarrantyDaysAndDate}},[_vm._v("cancel")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.validity"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('app-menu-date-picker',{attrs:{"disabled":_vm.disabled,"model":_vm.form.validityTerm.start,"rules":_vm.validation.required},on:{"update:model":function($event){return _vm.$set(_vm.form.validityTerm, "start", $event)}}})],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-3",attrs:{"xs2":"","lg2":""}},[_c('app-menu-date-picker',{attrs:{"disabled":_vm.disabled,"model":_vm.form.validityTerm.finish,"rules":_vm.validityTermFinishRule},on:{"update:model":function($event){return _vm.$set(_vm.form.validityTerm, "finish", $event)}}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.unit"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","lg3":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled,"items":_vm.units,"rules":_vm.validation.required,"maxlength":_vm.constants.LENGTH_UNIT,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.unit.id),callback:function ($$v) {_vm.$set(_vm.form.unit, "id", $$v)},expression:"form.unit.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.unitCost"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.requiredBiggerThanZero,"maxlength":_vm.constants.LENGTH_UNIT_COST,"prefix":"R$"},model:{value:(_vm.form.unitCost),callback:function ($$v) {_vm.$set(_vm.form, "unitCost", $$v)},expression:"form.unitCost"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.hiredAmount")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"mask":_vm.validation.mask.hiredAmount,"suffix":_vm.unit},model:{value:(_vm.form.hiredAmount),callback:function ($$v) {_vm.$set(_vm.form, "hiredAmount", _vm._n($$v))},expression:"form.hiredAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.estimatedQuantity")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":true,"suffix":_vm.unit},model:{value:(_vm.form.estimatedTime),callback:function ($$v) {_vm.$set(_vm.form, "estimatedTime", _vm._n($$v))},expression:"form.estimatedTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.executedQuantity")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":true,"suffix":_vm.unit},model:{value:(_vm.form.executedTime),callback:function ($$v) {_vm.$set(_vm.form, "executedTime", _vm._n($$v))},expression:"form.executedTime"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"subheading mt-3"},[_vm._v(_vm._s(_vm.$t("label.contractItem")))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.contractItems', { unit: _vm.unit }))}}),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs1":"","lg1":""}},[_c('label',{staticClass:"form-label center"},[_vm._v("Item")])]),_vm._v(" "),_c('v-flex',{staticClass:"mr-2",attrs:{"xs3":"","lg3":""}},[_c('label',{staticClass:"form-label center"},[_vm._v("Nome da cesta")])]),_vm._v(" "),_c('v-flex',{staticClass:"mr-2",attrs:{"xs2":"","lg2":""}},[_c('label',{staticClass:"form-label center"},[_vm._v(_vm._s(_vm.unit.charAt(0).toUpperCase() + _vm.unit.slice(1))+" contratadas")])]),_vm._v(" "),_c('v-flex',{staticClass:"mr-2",attrs:{"xs2":"","lg2":""}},[_c('label',{staticClass:"form-label center"},[_vm._v(_vm._s(_vm.unit.charAt(0).toUpperCase() + _vm.unit.slice(1))+" orçadas")])]),_vm._v(" "),_c('v-flex',{staticClass:"mr-2",attrs:{"xs2":"","lg2":""}},[_c('label',{staticClass:"form-label center"},[_vm._v(_vm._s(_vm.unit.charAt(0).toUpperCase() + _vm.unit.slice(1))+" executadas")])])],1),_vm._v(" "),_vm._l((_vm.form.items),function(item,index){return _c('app-contract-item',{key:item.uuid,attrs:{"model":item,"index":index,"suffix":_vm.unit,"isInUse":_vm.form.isInUse,"disabled":_vm.disabled},on:{"remove":_vm.removeItem,"change":_vm.updateItem}})}),_vm._v(" "),(_vm.form.isInUse && !_vm.contractCopy)?_c('v-layout',{attrs:{"row":""}},[_c('span',[_vm._v("**Cesta em uso")])]):_vm._e()],2),_vm._v(" "),(!_vm.disabled)?_c('v-card-actions',[_c('v-btn',{attrs:{"disabled":_vm.removing,"loading":_vm.saving,"color":"primary"},on:{"click":_vm.save}},[_vm._v("\n            "+_vm._s(_vm.$t("label.save"))+"\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.saving || _vm.removing},on:{"click":_vm.addItem}},[_c('v-icon',{staticClass:"mr-3"},[_vm._v("account_balance_wallet")]),_vm._v("\n            "+_vm._s(_vm.$t("label.addContractItem"))+"\n          ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.contractExists && this.form.isInUse === true && this.form.office.controlContract === true)?_c('v-btn',{on:{"click":_vm.copyContractButton}},[_c('v-icon',{staticClass:"mr-3"},[_vm._v("content_copy")]),_vm._v("\n            "+_vm._s(_vm.$t("label.contractCopy"))+"\n          ")],1):_vm._e(),_vm._v(" "),(_vm.contractExists && this.form.isInUse === true && this.form.office.controlContract === true)?_c('v-btn',{on:{"click":_vm.updateContractButton}},[_c('v-icon',{staticClass:"mr-3"},[_vm._v("cached")]),_vm._v("\n            "+_vm._s(_vm.$t("label.contractUpdate"))+"\n          ")],1):_vm._e(),_vm._v(" "),(!!_vm.form.id && !_vm.contractCopy)?_c('v-btn',{attrs:{"disabled":_vm.saving,"loading":_vm.removing,"color":"error"},on:{"click":_vm.remove}},[_vm._v("\n            "+_vm._s(_vm.form.isInUse ? _vm.$t("label.inactivate") : _vm.$t("label.remove"))+"\n          ")]):_vm._e()],1):_vm._e()],1):_c('v-card',[_c('app-card-loader')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5eyz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/admin');
    },
    expireSubstitutes: function expireSubstitutes() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/admin/expireSubstitutes');
    },
    syncGdp: function syncGdp() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/admin/syncGdp');
    },
    report: function report() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/admin/report');
    },
    serverData: function serverData() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/admin/serverData');
    }
});
'filehash hHCpAk26oj1UL2Nfo58s/tZtvtA=';

/***/ }),

/***/ "5zE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utilities__ = __webpack_require__("ml+B");








var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: "https://ngdsapicore.prodam.sp.gov.br/api"
});

http.interceptors.request.use(function (config) {
    // Insert the authentication header
    if (!__WEBPACK_IMPORTED_MODULE_5__helpers_utilities__["a" /* default */].isEmpty(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.profile)) {
        var token = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.profile.token;
        config.headers.Authorization = 'Bearer ' + token;
    }

    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

http.interceptors.response.use(function (response) {
    return response;
}, function (_ref) {
    var response = _ref.response;

    // Server didn't answer
    if (__WEBPACK_IMPORTED_MODULE_5__helpers_utilities__["a" /* default */].isEmpty(response)) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('setApiEvent', __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.error.networkError'));
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'httpError', params: { id: 404 } });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }

    // Token expired or the credentials are invalid
    if (response.status === 401) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('showError', response.data.message);
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: response.data.code === 'cac_login_expired' ? 'expiredPassword' : 'login' });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }

    // Custom Application error
    if (!__WEBPACK_IMPORTED_MODULE_5__helpers_utilities__["a" /* default */].isEmpty(response.data) && !__WEBPACK_IMPORTED_MODULE_5__helpers_utilities__["a" /* default */].isEmpty(response.data.message)) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('setApiEvent', response.data.developerMessage || response.data.message);
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'httpError', params: { id: response.status } });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }

    // Something went very wrong
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('setApiEvent', __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.error.fatalError'));
    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'httpError', params: { id: 500 } });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
});

/* harmony default export */ __webpack_exports__["a"] = (http);
'filehash x7Cc/MIOfIvLsiWHi1wPI9jWAQw=';

/***/ }),

/***/ "6ODB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("3XN7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73075f53_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("ziJ/");
function injectStyle (ssrContext) {
  __webpack_require__("yqtT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73075f53"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73075f53_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6OHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("eHeZ");




/* harmony default export */ __webpack_exports__["a"] = ({

    biggerThanZero: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].isNumeric(v) || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.numeric');
    }, function (v) {
        return !v || Number(v.toString().replace(',', '.')) > 0 || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.notZero');
    }],

    email: [function (v) {
        return !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.invalid');
    }],

    login: [function (v) {
        return !!v || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.required');
    }, function (v) {
        return !v || v.length >= 7 || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.loginTooShort');
    }],

    numeric: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].isNumeric(v) || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.numeric');
    }],

    password: [function (v) {
        return !!v || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.required');
    }, function (v) {
        return !v || v.length >= 6 || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.passwordTooShort');
    }],

    required: [function (v) {
        return !!v || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.required');
    }],

    requiredEmail: [function (v) {
        return !!v || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.required');
    }, function (v) {
        return !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.invalid');
    }],

    requiredNumeric: [function (v) {
        return !!v || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.required');
    }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].isNumeric(v) || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.numeric');
    }],

    requiredBiggerThanZero: [function (v) {
        return !!v || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.required');
    }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].isNumeric(v) || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.numeric');
    }, function (v) {
        return !v || Number(v.toString().replace(',', '.')) > 0 || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.notZero');
    }],

    text: [function (v) {
        return !!v || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.required');
    }, function (v) {
        return !v || v.length >= 3 || __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('message.validation.tooShort');
    }],

    mask: {
        contract: '######/##',
        daysToDelivery: __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].padStart('', __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].LENGTH_DAYS_TO_DELIVERY, '#'),
        demandCode: __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].padStart('', __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].LENGTH_DEMAND_CODE, '#'),
        estimatedTime: __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].padStart('', __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].LENGTH_ESTIMATED_TIME, '#'),
        plannedTime: __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].padStart('', __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].LENGTH_PLANNED_TIME, '#'),
        executedTime: __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].padStart('', __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].LENGTH_EXECUTED_TIME, '#'),
        warrantyDays: __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].padStart('', __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].LENGTH_CONTRACT_WARRANTY, '#'),
        unitCost: __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].padStart('', __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].LENGTH_CONTRACT_UNIT_VALUE, '#'),
        hiredAmount: __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].padStart('', __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].LENGTH_CONTRACT_HIRED_AMOUNT, '#'),
        timeAmount: __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].padStart('', __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].LENGTH_CONTRACT_ITEM_QUANTITY, '#')
    }

});
'filehash 2tsTXXYm/kcW9ldLZizUhpd52tw=';

/***/ }),

/***/ "6Tz/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("yeq2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff21eff6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("oCru");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff21eff6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7XVm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__("mWYR");






var state = {
    areas: [],
    area: {}
};

var mutations = {
    setAreas: function setAreas(state, areas) {
        state.areas = areas;
    },
    setArea: function setArea(state, area) {
        state.area = area;
    }
};

var actions = {
    loadAreas: function loadAreas(_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].areas.list();

                        case 2:
                            response = _context.sent;

                            commit('setAreas', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    fetchArea: function fetchArea(_ref2, id) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].areas.get(id);

                        case 2:
                            response = _context2.sent;

                            commit('setArea', response.data);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    saveOrUpdateArea: function saveOrUpdateArea(_ref3, form) {
        var _this3 = this;

        var dispatch = _ref3.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(form.id)) {
                                _context3.next = 5;
                                break;
                            }

                            _context3.next = 3;
                            return dispatch('saveArea', form);

                        case 3:
                            _context3.next = 7;
                            break;

                        case 5:
                            _context3.next = 7;
                            return dispatch('updateArea', form);

                        case 7:
                            _context3.next = 9;
                            return dispatch('loadAreas');

                        case 9:
                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.success.saved'));

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    saveArea: function saveArea(_ref4, form) {
        var _this4 = this;

        var dispatch = _ref4.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].areas.save(form);

                        case 2:
                            response = _context4.sent;
                            _context4.next = 5;
                            return dispatch('fetchArea', response.data.id);

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    updateArea: function updateArea(_ref5, form) {
        var _this5 = this;

        var dispatch = _ref5.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].areas.update(form.id, form);

                        case 2:
                            _context5.next = 4;
                            return dispatch('fetchArea', form.id);

                        case 4:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    }
};

var getters = {
    area: function area() {
        return state.area || [];
    },
    areas: function areas() {
        var areas = state.areas || [];
        return areas.sort(function (a, b) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].stringCompare(a.acronym, b.acronym);
        });
    },
    areasValueText: function areasValueText(_, getters) {
        return getters.areas.map(function (_ref6) {
            var id = _ref6.id,
                acronym = _ref6.acronym,
                name = _ref6.name;
            return { value: id, text: acronym + ' - ' + name };
        });
    },
    areasDictionary: function areasDictionary(_, getters) {
        return getters.areas.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash gWBh68nJH2CmvsdBBuzO1HRoUf4=';

/***/ }),

/***/ "82R3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({

    // CRUD
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/deliverables/' + id + '/', form);
    }
});
'filehash qwivyXSRud+9GwSx6Z7qTY99cUI=';

/***/ }),

/***/ "85nN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluatedDemands_vue__ = __webpack_require__("UFPt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef1e81ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluatedDemands_vue__ = __webpack_require__("4o7U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluatedDemands_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef1e81ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluatedDemands_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9QB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Evaluation_vue__ = __webpack_require__("MOJt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b16ea5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Evaluation_vue__ = __webpack_require__("OszP");
function injectStyle (ssrContext) {
  __webpack_require__("PfPb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Evaluation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b16ea5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Evaluation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9bAG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HttpError_vue__ = __webpack_require__("1wIv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34169766_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HttpError_vue__ = __webpack_require__("CFBN");
function injectStyle (ssrContext) {
  __webpack_require__("KqbE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HttpError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34169766_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HttpError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9bIQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("u5xo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_344e9612_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("sIiZ");
function injectStyle (ssrContext) {
  __webpack_require__("Qcjb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_344e9612_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9otY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    // When the bound element is inserted into the DOM...
    inserted: function inserted(el) {
        // Focus the element
        el.focus();
    }
});
"filehash n7j0dHRS3VlKJ/hVVOLJga9n8uM=";

/***/ }),

/***/ "AHNr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step_vue__ = __webpack_require__("sgZV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c18e5b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Step_vue__ = __webpack_require__("KYDV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c18e5b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Step_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AMVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"card__loader"},[_c('v-progress-circular',{staticClass:"secondary--text",attrs:{"size":50,"indeterminate":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AUsU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Files_vue__ = __webpack_require__("OTdA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cdcb69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Files_vue__ = __webpack_require__("uZj0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Files_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cdcb69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Files_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AYtm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_validation__ = __webpack_require__("6OHK");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this;

        return {
            validation: __WEBPACK_IMPORTED_MODULE_3__helpers_validation__["a" /* default */],
            loading: false,
            form: {
                username: '',
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },

            rules: {
                confirmPassword: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__helpers_validation__["a" /* default */].required), [function () {
                    return _this.form.newPassword === _this.form.confirmPassword || _this.$t('message.error.passwordNoMatch');
                }])
            }
        };
    },

    methods: {
        submit: function submit() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this2.$refs.form.validate()) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _context.prev = 2;

                                _this2.loading = true;
                                _context.next = 6;
                                return _this2.$store.dispatch('changePassword', _this2.form);

                            case 6:
                                _this2.$router.push({ name: 'login' });
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](2);

                                _this2.loading = false;

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[2, 9]]);
            }))();
        }
    }
});
'filehash 1DT6tkhn1jMQWR7u6PQ9811aYs4=';

/***/ }),

/***/ "BaNo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_MenuDatePicker__ = __webpack_require__("Z1KI");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this;

        return {
            constants: __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_8__helpers_validation__["a" /* default */],
            valid: true,
            searching: false,
            exporting: false,
            paginating: false,

            systems: this.$store.getters.systemsValueText,
            persons: this.$store.getters.personsValueText,
            types: this.$store.getters.demandTypesValueText,
            contracts: this.$store.getters.contractsValueText,

            form: {
                system: null,
                creator: null,
                owner: null,
                requester: null,
                type: null,
                contract: null,
                statuses: [],
                rejections: null,
                fromDate: null,
                toDate: null
            },
            formFinishRule: [function () {
                return _this.form.toDate >= _this.form.fromDate || _this.$t('message.error.period');
            }],

            pagination: {},
            totalItems: 0,
            items: [],
            headers: [{
                text: this.$t('label.code'),
                value: 'code',
                align: 'left'
            }, {
                text: this.$t('label.system'),
                value: 'system.acronym',
                align: 'left',
                sortable: false
            }, {
                text: this.$t('label.status'),
                value: 'status.id',
                align: 'left',
                sortable: false
            }, {
                text: this.$t('label.name'),
                value: 'title',
                align: 'left',
                sortable: false
            }, {
                text: this.$t('label.estimatedQuantity'),
                value: 'deliveries[0].plannedTime',
                align: 'left'
            }, {
                text: this.$t('label.executedQuantity'),
                value: 'deliveries[0].executedTime',
                align: 'left'
            }]

        };
    },


    watch: {
        pagination: {
            handler: function handler(newValue, oldValue) {
                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.form, newValue);
                if (oldValue.page !== undefined) this.searchWorker();
            },

            deep: true
        }
    },

    computed: {
        processing: function processing() {
            return this.searching || this.exporting;
        }
    },

    methods: {
        clear: function clear() {
            this.form = {
                system: null,
                creator: null,
                owner: null,
                requester: null,
                type: null,
                contract: null,
                statuses: [],
                fromDate: null,
                toDate: null
            };
        },
        search: function search() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var pagination;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this2.$refs.form.validate()) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                pagination = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this2.pagination);

                                pagination.page = 1;
                                pagination.descending = true;
                                _this2.pagination = pagination; // Don't call searchWorker. The Watcher will handle it

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        searchWorker: function searchWorker() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.searching = true;
                                _context2.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].demands.searchByFilter(_this3.form);

                            case 3:
                                response = _context2.sent;

                                _this3.searching = false;
                                _this3.totalItems = response.data.output.total;
                                _this3.items = response.data.output.result;

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        createReport: function createReport(reportType) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var params, reportName;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (_this4.$refs.form.validate()) {
                                    _context3.next = 2;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 2:
                                _this4.exporting = true;
                                params = {
                                    system: _this4.form.system,
                                    creator: _this4.form.creator,
                                    owner: _this4.form.owner,
                                    requester: _this4.form.requester,
                                    type: _this4.form.type,
                                    contract: _this4.form.contract,
                                    statuses: _this4.form.statuses.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this4.form.statuses) : null,
                                    fromDate: _this4.form.fromDate,
                                    toDate: _this4.form.toDate,
                                    rejections: _this4.form.rejections,
                                    reportType: reportType
                                };
                                reportName = 'RelatorioDemandas_' + __WEBPACK_IMPORTED_MODULE_7__helpers_utilities__["a" /* default */].toDateTime(Date.now()) + '.' + reportType;

                                _this4.ajaxDownload('application/' + reportType, reportName, params);

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        ajaxDownload: function ajaxDownload(type, name, params) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var xhr, url, reportUrl, token, self;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                xhr = new XMLHttpRequest();
                                url = "https://ngdsapi.prodam.sp.gov.br/api";
                                reportUrl = '/reports/demands';
                                token = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.profile.token;
                                self = _this5;


                                xhr.open('POST', url + reportUrl, true);
                                xhr.setRequestHeader('Content-Type', 'application/json');
                                xhr.setRequestHeader('Accept', type);
                                xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                                xhr.responseType = 'arraybuffer';

                                xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_7__helpers_utilities__["a" /* default */].toPayload(params)));
                                xhr.onprogress = _this5.callback;
                                xhr.onload = function onload() {
                                    if (this.status === 200) {
                                        var blob = new Blob([this.response], { type: type });
                                        var link = document.createElement('a');
                                        link.href = window.URL.createObjectURL(blob);
                                        link.download = name;
                                        link.click();
                                        link.remove();
                                    }
                                };
                                xhr.onloadend = function onloadend() {
                                    self.exporting = false;
                                };

                            case 14:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        }
    },
    components: {
        appMenuDatePicker: __WEBPACK_IMPORTED_MODULE_9__components_shared_MenuDatePicker__["a" /* default */]
    }

});
'filehash keFQKkF4RC3sPBzqSU8qPD+K9J0=';

/***/ }),

/***/ "BmfM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.disabled || _vm.readonly)?_c('v-text-field',{staticClass:"input-group--date-text-field",attrs:{"disabled":_vm.disabled},model:{value:(_vm.formatted),callback:function ($$v) {_vm.formatted=$$v},expression:"formatted"}}):_vm._e(),_vm._v(" "),(!_vm.disabled && !_vm.readonly)?_c('v-menu',{ref:"menu",staticStyle:{"cursor":"arrow"},attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-top":20,"max-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{staticStyle:{"pointer-events":"none"},attrs:{"slot":"activator","placeholder":"DD/MM/AAAA","name":_vm.label,"readonly":"","rules":_vm.rules},slot:"activator",model:{value:(_vm.formatted),callback:function ($$v) {_vm.formatted=$$v},expression:"formatted"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},on:{"input":function($event){_vm.formatted = _vm.formatDate($event);
                _vm.menu = false;}},model:{value:(_vm.picker),callback:function ($$v) {_vm.picker=$$v},expression:"picker"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C0Va":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zenscroll__ = __webpack_require__("k9Ba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zenscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_zenscroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_Files__ = __webpack_require__("AUsU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkflowItem__ = __webpack_require__("GO74");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WorkflowItemDetail__ = __webpack_require__("JpZ8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import utilities from '@/helpers/utilities';




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_1__helpers_constants__["a" /* default */],
            rowsPerPageItems: __WEBPACK_IMPORTED_MODULE_1__helpers_constants__["a" /* default */].componentOptions.rowsPerPageItems,
            pagination: {
                descending: false,
                sortBy: 'dateApproved'
            },

            isDetailing: false,
            detail: {}
        };
    },

    watch: {
        items: 'hideDetail'
    },
    methods: {
        toggleDetail: function toggleDetail(detail) {
            // if (!utilities.isApprovalOrRejectionStatus(detail.status.id)) return;

            if (this.detail !== null && this.detail.id === detail.id) {
                this.hideDetail();
                return;
            }
            this.showDetail(detail);
        },
        showDetail: function showDetail(detail) {
            this.detail = detail;
            this.isDetailing = true;
            __WEBPACK_IMPORTED_MODULE_0_zenscroll___default.a.to(document.getElementById('detail'), 0);
        },
        hideDetail: function hideDetail() {
            this.isDetailing = false;
            this.detail = null;
        }
    },
    components: {
        appFiles: __WEBPACK_IMPORTED_MODULE_2__shared_Files__["a" /* default */],
        appWorkflowItem: __WEBPACK_IMPORTED_MODULE_3__WorkflowItem__["a" /* default */],
        appWorkflowItemDetail: __WEBPACK_IMPORTED_MODULE_4__WorkflowItemDetail__["a" /* default */]
    }
});
'filehash yABa0ZVvG0fBqPoK7glOEhOktgc=';

/***/ }),

/***/ "CFBN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","id":"httpError"}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('p',{staticClass:"body-1 grey--text text--darken-1 mt-4"},[_vm._v(_vm._s((_vm.errorCode + " - " + _vm.errorCodeLabel)))]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-form',[_c('v-layout',{staticClass:"row--short",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.message')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_c('pre',[_vm._v(_vm._s(_vm.message))])])])],1),_vm._v(" "),_c('v-layout',{staticClass:"row--short",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v("Login")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_c('pre',[_vm._v(_vm._s(_vm.profile.login))])])])],1),_vm._v(" "),_c('v-layout',{staticClass:"row--short",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.auditSession')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_c('pre',[_vm._v(_vm._s(_vm.profile.auditId))])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.token')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_c('pre',[_vm._v(_vm._s(_vm.profile.token))])])])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CaJI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.shouldDisplayLoader)?_c('div',[_c('app-dialogLoader')],1):_c('div',[_c('transition',{attrs:{"name":"slide-x-transition","mode":"out-in"}},[_c('router-view',{attrs:{"name":"header"}})],1),_vm._v(" "),_c('v-content',[_c('v-container',{staticClass:"pt-5",attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"slide-x-transition","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('app-Event')],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cwv1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex xs12 lg10 offset-lg1",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('h2',[_vm._v("Comentários de avaliação")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Voltar")])],1),_vm._v(" "),_c('div',{staticClass:"flex xs12 lg10 offset-lg1"},[_c('v-card',[_c('v-card-text',[_c('div',{staticClass:"subheading mb-3"},[_vm._v("Informações da Demanda")]),_vm._v(" "),_c('v-layout',{staticClass:"pa-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.code")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.demand.code))])])],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.system")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.demand.system.acronym)+" - "+_vm._s(_vm.demand.system.name))])])],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.title")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.demand.title))])])],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.description")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.demand.description))])])],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.averageEvaluationDemands")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_c('strong',[_vm._v(_vm._s(_vm.demand.evaluationAverage))])])])],1),_vm._v(" "),_vm._l((_vm.demand.evaluationComments),function(comment,index){return _c('v-layout',{key:index,staticClass:"pa-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.comment') + ' ' + parseInt(index + 1))+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"value":comment,"multi-line":"","auto-grow":""}})],1)],1)})],2)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utilities__ = __webpack_require__("ml+B");







var state = {
    isLoggedIn: !!localStorage.getItem('gds_prodam'),
    profile: JSON.parse(localStorage.getItem('gds_prodam')) || {}
};

var mutations = {
    login: function login(state, profile) {
        if (__WEBPACK_IMPORTED_MODULE_5__helpers_utilities__["a" /* default */].isEmpty(profile.person)) profile.person = { id: 0 };

        // Copy CAC data to profile
        profile.person.name = profile.name;
        profile.person.username = profile.login;
        state.isLoggedIn = true;
        state.profile = profile;
        state.profile.isAdmin = profile.person.isAdmin;
        state.profile.isRoot = profile.person.isRoot;
        state.profile.isHired = profile.person.isHired;
        localStorage.setItem('gds_prodam', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(profile));
    },
    logout: function logout(state) {
        state.isLoggedIn = false;
        state.profile = {};
        localStorage.removeItem('gds_prodam');
    },
    updateProfile: function updateProfile(state, person) {
        state.profile.isNew = false;
        state.profile.person = person;
    }
};

var actions = {
    login: function login(_ref, credentials) {
        var _this = this;

        var commit = _ref.commit,
            dispatch = _ref.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].auth.authenticate(credentials);

                        case 2:
                            response = _context.sent;

                            commit('login', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    changePassword: function changePassword(_ref2, credentials) {
        var _this2 = this;

        var dispatch = _ref2.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].auth.changePassword(credentials);

                        case 2:
                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.success.passwordUpdated'));

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    logout: function logout(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        dispatch('reset');
        commit('logout');
    },
    updateProfile: function updateProfile(_ref4, person) {
        var commit = _ref4.commit;

        commit('updateProfile', person);
    }
};

var getters = {
    isAdmin: function isAdmin(state) {
        return state.profile.isAdmin;
    },
    isFirstLogin: function isFirstLogin(state) {
        return state.profile.isNew;
    },
    isLoggedIn: function isLoggedIn(state) {
        return state.isLoggedIn;
    },
    isPersonUpdateRequired: function isPersonUpdateRequired(state, getters) {
        return !getters.isFirstLogin && state.profile.person.isUpdateRequired;
    },
    profile: function profile(state) {
        return state.profile;
    },
    roles: function roles(state) {
        if (!state.profile) return [];
        var roles = state.profile.roles || [];

        return roles.reduce(function (map, obj) {
            map[obj] = true;
            return map;
        }, {});
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash 0qtUKVimK8L9CC+aCj9Mq+jbphU=';

/***/ }),

/***/ "DBrU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-3",attrs:{"xs3":""}},[_c('v-card',[_c('v-card-text',[_c('v-form',{ref:"form",staticClass:"form--filters",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"filter-label"},[_vm._v(_vm._s(_vm.$t('label.system')))]),_vm._v(" "),_c('v-select',{attrs:{"autocomplete":"","items":_vm.systems,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.system),callback:function ($$v) {_vm.$set(_vm.form, "system", $$v)},expression:"form.system"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"filter-label"},[_vm._v(_vm._s(_vm.$t('label.status')))]),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"secondary","label":_vm.$t('type.status')[_vm.constants.STATUS_CREATED],"value":_vm.constants.STATUS_CREATED},model:{value:(_vm.form.statuses),callback:function ($$v) {_vm.$set(_vm.form, "statuses", $$v)},expression:"form.statuses"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"secondary","label":_vm.$t('type.status')[_vm.constants.STATUS_CREATED_APPROVAL],"value":_vm.constants.STATUS_CREATED_APPROVAL},model:{value:(_vm.form.statuses),callback:function ($$v) {_vm.$set(_vm.form, "statuses", $$v)},expression:"form.statuses"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"secondary","label":_vm.$t('type.status')[_vm.constants.STATUS_PLANNING],"value":_vm.constants.STATUS_PLANNING},model:{value:(_vm.form.statuses),callback:function ($$v) {_vm.$set(_vm.form, "statuses", $$v)},expression:"form.statuses"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"secondary","label":_vm.$t('type.status')[_vm.constants.STATUS_PLANNING_APPROVAL],"value":_vm.constants.STATUS_PLANNING_APPROVAL},model:{value:(_vm.form.statuses),callback:function ($$v) {_vm.$set(_vm.form, "statuses", $$v)},expression:"form.statuses"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"secondary","label":_vm.$t('type.status')[_vm.constants.STATUS_DELIVERY],"value":_vm.constants.STATUS_DELIVERY},model:{value:(_vm.form.statuses),callback:function ($$v) {_vm.$set(_vm.form, "statuses", $$v)},expression:"form.statuses"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"secondary","label":_vm.$t('type.status')[_vm.constants.STATUS_DELIVERY_APPROVAL],"value":_vm.constants.STATUS_DELIVERY_APPROVAL},model:{value:(_vm.form.statuses),callback:function ($$v) {_vm.$set(_vm.form, "statuses", $$v)},expression:"form.statuses"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"secondary","label":_vm.$t('type.status')[_vm.constants.STATUS_FINALIZING],"value":_vm.constants.STATUS_FINALIZING},model:{value:(_vm.form.statuses),callback:function ($$v) {_vm.$set(_vm.form, "statuses", $$v)},expression:"form.statuses"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"secondary","label":_vm.$t('type.status')[_vm.constants.STATUS_DONE],"value":_vm.constants.STATUS_DONE},model:{value:(_vm.form.statuses),callback:function ($$v) {_vm.$set(_vm.form, "statuses", $$v)},expression:"form.statuses"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"secondary","label":_vm.$t('type.status')[_vm.constants.STATUS_REJECTED],"value":_vm.constants.STATUS_REJECTED},model:{value:(_vm.form.statuses),callback:function ($$v) {_vm.$set(_vm.form, "statuses", $$v)},expression:"form.statuses"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"filter-label"},[_vm._v(_vm._s(_vm.$t('label.flow')))]),_vm._v(" "),_c('v-select',{attrs:{"autocomplete":"","items":_vm.types,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"filter-label"},[_vm._v(_vm._s(_vm.$t('label.creator')))]),_vm._v(" "),_c('v-select',{attrs:{"autocomplete":"","items":_vm.persons,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.creator),callback:function ($$v) {_vm.$set(_vm.form, "creator", $$v)},expression:"form.creator"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"filter-label"},[_vm._v(_vm._s(_vm.$t('label.requester')))]),_vm._v(" "),_c('v-select',{attrs:{"autocomplete":"","items":_vm.persons,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.requester),callback:function ($$v) {_vm.$set(_vm.form, "requester", $$v)},expression:"form.requester"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"filter-label"},[_vm._v(_vm._s(_vm.$t('label.owner')))]),_vm._v(" "),_c('v-select',{attrs:{"autocomplete":"","items":_vm.persons,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.owner),callback:function ($$v) {_vm.$set(_vm.form, "owner", $$v)},expression:"form.owner"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"filter-label"},[_vm._v(_vm._s(_vm.$t('label.contract')))]),_vm._v(" "),_c('v-select',{attrs:{"autocomplete":"","items":_vm.contracts,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.contract),callback:function ($$v) {_vm.$set(_vm.form, "contract", $$v)},expression:"form.contract"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","xs12":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('label',{staticClass:"filter-label"},[_vm._v(_vm._s(_vm.$t('label.from')))]),_vm._v(" "),_c('app-menu-date-picker',{attrs:{"model":_vm.form.fromDate},on:{"update:model":function($event){return _vm.$set(_vm.form, "fromDate", $event)}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","offset-xs1":""}},[_c('label',{staticClass:"filter-label"},[_vm._v(_vm._s(_vm.$t('label.to')))]),_vm._v(" "),_c('app-menu-date-picker',{attrs:{"model":_vm.form.toDate,"rules":_vm.formFinishRule},on:{"update:model":function($event){return _vm.$set(_vm.form, "toDate", $event)}}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"color":"secondary","label":_vm.$t('label.houveDevolucoes')},model:{value:(_vm.form.rejections),callback:function ($$v) {_vm.$set(_vm.form, "rejections", $$v)},expression:"form.rejections"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"disabled":_vm.paginating,"loading":_vm.processing,"color":"primary"},on:{"click":_vm.search}},[_vm._v("\n                                "+_vm._s(_vm.$t('label.search'))+"\n                            ")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-0",attrs:{"disabled":_vm.searching || _vm.paginating},on:{"click":_vm.clear}},[_vm._v("\n                                "+_vm._s(_vm.$t('label.clear'))+"\n                            ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-menu',{staticClass:"ma-0",attrs:{"close-on-content-click":false,"offset-x":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                                    "+_vm._s(_vm.$t('label.export'))+"\n                                ")]),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-btn',{staticClass:"ma-0",attrs:{"disabled":_vm.searching || _vm.paginating,"loading":_vm.processing,"color":"primary"},on:{"click":function($event){return _vm.createReport('pdf')}}},[_vm._v("\n                                                            PDF\n                                                        ")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-btn',{staticClass:"ma-0",attrs:{"disabled":_vm.searching || _vm.paginating,"loading":_vm.processing,"color":"primary"},on:{"click":function($event){return _vm.createReport('csv')}}},[_vm._v("\n                                                            CSV\n                                                        ")])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"total-items":_vm.totalItems,"loading":_vm.paginating,"no-data-text":_vm.$t('message.warning.noData'),"rows-per-page-items":_vm.constants.componentOptions.rowsPerPageItems,"rows-per-page-text":_vm.$t('label.pagination')},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'demandEdit', params: { id: item.id } },"tag":"tr"}},[_c('td',{staticClass:"demand-code"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',{staticClass:"system-acronym"},[_vm._v(_vm._s(item.system.acronym))]),_vm._v(" "),_c('td',{staticClass:"situation-name"},[_vm._v(_vm._s(item.status.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.estimatedTime))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.executedTime))])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dm4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!this.loading)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg3":"","offset-xs1":"","offset-lg1":""}},[_c('v-card',{staticClass:"pa-2",staticStyle:{"text-align":"center"}},[_c('v-card-text',[_c('p',{staticClass:"subheading",staticStyle:{"font-weight":"500"}},[_vm._v("Demandas Avaliadas")]),_vm._v(" "),_c('p',{staticClass:"subheading",staticStyle:{"font-weight":"600"}},[_c('strong',[_vm._v(_vm._s(this.summary.totalEvaluated))])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg3":"","offset-xs1":"","offset-lg1":""}},[_c('v-card',{staticClass:"pa-2",staticStyle:{"text-align":"center"}},[_c('v-card-text',[_c('p',{staticClass:"subheading",staticStyle:{"font-weight":"500"}},[_vm._v("Demandas em Avaliação")]),_vm._v(" "),_c('p',{staticClass:"subheading",staticStyle:{"font-weight":"600"}},[_c('strong',[_vm._v(_vm._s(this.summary.totalNotEvaluated))])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg2":"","offset-xs1":"","offset-lg1":""}},[_c('v-card',{staticClass:"pa-2",staticStyle:{"text-align":"center"}},[_c('v-card-text',[_c('p',{staticClass:"subheading",staticStyle:{"font-weight":"500"}},[_vm._v("Score Médio")]),_vm._v(" "),_c('p',{staticClass:"subheading",staticStyle:{"font-weight":"600"}},[(this.summary.totalAverageValue < 3)?_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(this.summary.totalAverage))]):_vm._e(),_vm._v(" "),(this.summary.totalAverageValue == 3)?_c('strong',{staticStyle:{"color":"orange"}},[_vm._v(_vm._s(this.summary.totalAverage))]):_vm._e(),_vm._v(" "),(this.summary.totalAverageValue > 3)?_c('strong',{staticStyle:{"color":"green"}},[_vm._v(_vm._s(this.summary.totalAverage))]):_vm._e()])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(!this.loading)?_c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.loadEvaluateOffices,"placeholder":_vm.placeholder,"pagination":_vm.pagination},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'officeEvaluatedDemands', params: { officeId: item.id }},"tag":"tr"}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.acronym))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.average))])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":"","tag":"td"}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(item.notEvaluatedDemands))]),_vm._v(" "),_c('span',[_vm._v("As demandas que estão sendo consideradas no cálculo são as que estão na situação  'Aprovação de Entrega'")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.evaluatedDemands))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.dtStartEvaluation))])],1)]}}],null,false,4108234215)}):_vm._e(),_vm._v(" "),_c('dialog-loader',{directives:[{name:"show",rawName:"v-show",value:(this.loading),expression:"this.loading"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EJX4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.refresh,"pagination":_vm.pagination},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{
                name: 'demandOwnerSubstitutionEdit',
                params: {
                    id: item.id,
                    demandCode: item.demand.code,
                    demandId: item.demand.id
                }
            },"tag":"tr"}},[_c('td',[_vm._v(_vm._s(item.demand.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("personToString")(item.originalOwner)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("personToString")(item.substituteOwner)))])])]}}])},[(!_vm.readonly)?_c('template',{slot:"afterReloadButton"},[_c('v-btn',{attrs:{"to":{ name: 'demandOwnerSubstitutionCreate' },"color":"primary"}},[_vm._v(_vm._s(_vm.$t("label.createDemandOwnerSubstitutions")))])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ENGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-modal',{ref:"popup"},[_c('h2',{staticStyle:{"margin-top":"0"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('v-btn',{attrs:{"color":"error"},on:{"click":_vm._cancel}},[_vm._v("\n                        "+_vm._s(_vm.cancelButton)+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm._confirm}},[_vm._v("\n                        "+_vm._s(_vm.okButton)+"\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EYvS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


var state = {
    searchFilter: []
};

var mutations = {
    setSearchFilter: function setSearchFilter(state, searchFilter) {
        state.searchFilter = searchFilter;
    }
};

var actions = {
    setSearchFilter: function setSearchFilter(_ref, searchFilter) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            commit('setSearchFilter', searchFilter);

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    clearSearchFilter: function clearSearchFilter(_ref2) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            commit('setSearchFilter', '');

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }
};

var getters = {
    searchFilter: function searchFilter(state) {
        return state.searchFilter || '';
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash fV46iN4s3FIghKMVUqFR6CxXh2o=';

/***/ }),

/***/ "FBVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("2it3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e93b4d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("47Dw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e93b4d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FL3z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("Mlmj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15f710f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("EJX4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15f710f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FPVa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"body-1 grey--text text--darken-1 mt-4"},[_vm._v(_vm._s(_vm.$t('label.approvalDetails')))]),_vm._v(" "),_c('form',[_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.person')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg5":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.item.responsible.name))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.dateLabel))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg5":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.dateApproved))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.comments')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.item.comments))])])],1),_vm._v(" "),(_vm.item.files !== undefined && _vm.item.files.length > 0)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.files')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('app-files',{attrs:{"files":_vm.item.files}})],1)],1):_vm._e()],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G4sW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.refresh,"pagination":_vm.pagination},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'systemEdit', params: { id: item.id }},"tag":"tr"}},[_c('td',{staticClass:"system-acronym"},[_vm._v(_vm._s(item.acronym))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.description))])])]}}])},[(!_vm.readonly)?_c('template',{slot:"afterReloadButton"},[_c('v-btn',{attrs:{"to":{ name: 'systemCreate' },"color":"primary"}},[_vm._v(_vm._s(_vm.$t('label.createSystem')))])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GC4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","lg8":"","offset-xs1":"","offset-lg2":""}},[_c('v-card',{staticClass:"pa-2"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('p',{staticClass:"subheading ma-0",staticStyle:{"font-weight":"500"}},[_vm._v("DB")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":""},model:{value:(_vm.connString),callback:function ($$v) {_vm.connString=$$v},expression:"connString"}})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GO74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkflowItem_vue__ = __webpack_require__("hiVW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8d4f50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkflowItem_vue__ = __webpack_require__("eqmm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkflowItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8d4f50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkflowItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gf8v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_entities_Contract__ = __webpack_require__("Q1Hv");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      validation: __WEBPACK_IMPORTED_MODULE_3__helpers_validation__["a" /* default */],
      valid: true,

      saving: false,
      loading: true,
      removing: false,

      dialog: false,

      form: __WEBPACK_IMPORTED_MODULE_4__helpers_entities_Contract__["a" /* default */].build(),

      selectedStates: [],
      statesValueText: [{ value: 1, text: "Aberta" }, { value: 2, text: "Aprovação da Solicitação" }, { value: 3, text: "Planejamento" }, { value: 4, text: "Aprovação do Planejamento" }, { value: 5, text: "Em Execução" }, { value: 6, text: "Aprovação da Entrega" }, { value: 7, text: "Encerramento" }],
      checkbox: false,
      msgNotUsed: false,
      updateObj: {},

      inUseNewEmpty: false
    };
  },


  computed: {
    contracts: function contracts() {
      var contracts = this.$store.getters.contractsValueText;
      var contracts2 = contracts.filter(function (item) {
        return item.isActive === true;
      });
      return contracts2;
    },
    getContractItems: function getContractItems() {
      var _this = this;

      var items = this.$store.getters.contractItemsValueText;
      var items2 = items.filter(function (item) {
        return item.contractId === _this.form.newId;
      });
      items2 = items2.sort(function (a, b) {
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });

      return items2;
    }
  },

  watch: {
    $route: "fetch"
  },

  created: function created() {
    this.fetch();
  },


  methods: {
    fetch: function fetch() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;

                id = _this2.$route.params.id;

                if (__WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].isEmptyOrZero(id)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return _this2.$store.dispatch("fetchContract", id);

              case 5:
                _this2.form = __WEBPACK_IMPORTED_MODULE_4__helpers_entities_Contract__["a" /* default */].toForm(_this2.$store.getters.contract);

              case 6:

                _this2.loading = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    itemInUseWarning: function itemInUseWarning(item) {
      if (item.isContractItemInUse === false) {
        this.msgNotUsed = true;
        return true;
      }
      return false;
    },
    selectAll: function selectAll() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.selectedStates.length === _this3.statesValueText.length) {
          _this3.checkbox = true;
        } else {
          _this3.checkbox = false;
        }
      });
    },
    toggleCheckbox: function toggleCheckbox() {
      if (this.checkbox === true) {
        this.selectedStates = [1, 2, 3, 4, 5, 6, 7];
      } else {
        this.selectedStates = [];
      }
    },
    indeterminateCheckbox: function indeterminateCheckbox() {
      if (this.selectedStates.length > 0 && this.selectedStates.length < this.statesValueText.length) {
        return true;
      }

      return false;
    },
    firstInUseItem: function firstInUseItem() {
      var firstInUseItemId = void 0;
      for (var i = 0; i < this.form.items.length; i++) {
        if (this.form.items[i].isContractItemInUse === true) {
          firstInUseItemId = this.form.items[i].id;
          break;
        }
      }

      return firstInUseItemId;
    },
    firstItemRule: function firstItemRule(id) {
      var _this4 = this;

      for (var i = 0; i < this.form.items.length; i++) {
        if (this.form.newContractItems[i]) {
          return [];
        }
      }

      return [function (v) {
        return !(id === _this4.firstInUseItem() && !v) || 'Obrigatório';
      }];
    },
    sendData: function sendData() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.$store.dispatch("updateContract", _this5.form);

              case 2:

                _this5.$router.push({ name: "contractIndex" });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    save: function save() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this6.$refs.form.validate()) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:

                _this6.inUseNewEmpty = false;
                for (i = 0; i < _this6.form.items.length; i++) {
                  if (_this6.form.items[i].isContractItemInUse === true && !_this6.form.newContractItems[i]) {
                    _this6.form.newContractItems[i] = 0;
                    _this6.inUseNewEmpty = true;
                  } else if (!_this6.form.newContractItems[i]) {
                    _this6.form.newContractItems[i] = 0;
                  }

                  _this6.form.itemsOldToNew[i] = {
                    oldId: _this6.form.items[i].id,
                    newId: _this6.form.newContractItems[i]
                  };
                }

                _this6.form.demandStates = _this6.selectedStates;

                if (_this6.inUseNewEmpty === true) {
                  _this6.dialog = true;
                } else {
                  _this6.form.isActive = false;
                  _this6.sendData();
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    }
  }
});
"filehash uwdgRFthPvkdwJJ0zHYnVXzT3Fg=";

/***/ }),

/***/ "GjwJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"slide-y-reverse-transition","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H137":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("O9Vu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbde1002_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("UcNA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbde1002_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HCJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("UIue");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2933684_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("kuha");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2933684_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HTuS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__("mWYR");






var state = {
    persons: [],
    person: {}
};

var mutations = {
    setPersons: function setPersons(state, persons) {
        state.persons = persons;
    },
    setPerson: function setPerson(state, person) {
        state.person = person;
    }
};

var actions = {
    fetchPerson: function fetchPerson(_ref, id) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].persons.fetch(id);

                        case 2:
                            response = _context.sent;

                            commit("setPerson", response.data);

                        case 4:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    loadPersons: function loadPersons(_ref2) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].persons.list();

                        case 2:
                            response = _context2.sent;

                            commit("setPersons", response.data);

                        case 4:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    savePerson: function savePerson(_ref3, form) {
        var _this3 = this;

        var dispatch = _ref3.dispatch,
            state = _ref3.state;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].persons.save(form);

                        case 2:
                            response = _context3.sent;
                            _context3.next = 5;
                            return dispatch("fetchPerson", response.data.id);

                        case 5:
                            _context3.next = 7;
                            return dispatch("updateProfile", state.person);

                        case 7:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    saveOrUpdatePerson: function saveOrUpdatePerson(_ref4, form) {
        var _this4 = this;

        var dispatch = _ref4.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(form.id)) {
                                _context4.next = 5;
                                break;
                            }

                            _context4.next = 3;
                            return dispatch("savePerson", form);

                        case 3:
                            _context4.next = 7;
                            break;

                        case 5:
                            _context4.next = 7;
                            return dispatch("updatePerson", form);

                        case 7:
                            _context4.next = 9;
                            return dispatch("loadPersons");

                        case 9:
                            dispatch("showSuccess", __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("message.success.saved"));

                        case 10:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    updatePerson: function updatePerson(_ref5, form) {
        var _this5 = this;

        var dispatch = _ref5.dispatch,
            getters = _ref5.getters;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].persons.update(form.id, form);

                        case 2:
                            if (!(getters.profile.person.id === form.id)) {
                                _context5.next = 7;
                                break;
                            }

                            _context5.next = 5;
                            return dispatch("fetchPerson", form.id);

                        case 5:
                            _context5.next = 7;
                            return dispatch("updateProfile", getters.person);

                        case 7:
                            _context5.next = 9;
                            return dispatch("loadDemands");

                        case 9:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    }
};

var getters = {
    person: function person(state) {
        return state.person;
    },
    persons: function persons(state) {
        var persons = state.persons || [];
        return persons.sort(function (a, b) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].stringCompare(a.name, b.name);
        });
    },
    personsHired: function personsHired(_, getters) {
        return getters.persons.filter(function (person) {
            return person.isHired;
        });
    },
    personsNotHired: function personsNotHired(_, getters) {
        return getters.persons.filter(function (person) {
            return !person.isHired;
        });
    },
    personsValueText: function personsValueText(_, getters) {
        return getters.persons.filter(function (person) {
            if (!getters.profile.office) return person.isActive;
            return person.isActive && !!person.area && person.office.id === getters.profile.office;
        }).map(function (_ref6) {
            var id = _ref6.id,
                username = _ref6.username,
                name = _ref6.name;
            return {
                value: id,
                text: username + " - " + name
            };
        });
    },
    personsHiredValueText: function personsHiredValueText(_, getters) {
        return getters.personsHired.filter(function (person) {
            return person.isActive;
        }).map(function (_ref7) {
            var id = _ref7.id,
                username = _ref7.username,
                name = _ref7.name;
            return {
                value: id,
                text: username + " - " + name
            };
        });
    },
    personsNotHiredValueText: function personsNotHiredValueText(_, getters) {
        return getters.personsNotHired.filter(function (person) {
            return person.isActive;
        }).map(function (_ref8) {
            var id = _ref8.id,
                username = _ref8.username,
                name = _ref8.name;
            return {
                value: id,
                text: username + " - " + name
            };
        });
    },
    personsNotHiredSomeOfficeProfileValueText: function personsNotHiredSomeOfficeProfileValueText(_, getters) {
        return getters.personsNotHired.filter(function (person) {
            return person.isActive && !!person.office && person.office.id === getters.profile.office;
        }).map(function (_ref9) {
            var id = _ref9.id,
                username = _ref9.username,
                name = _ref9.name;
            return {
                value: id,
                text: username + " - " + name
            };
        });
    },
    personsDictionary: function personsDictionary(_, getters) {
        return getters.persons.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
"filehash rUZWg4u4treCj6k+5q+/ff0RO9U=";

/***/ }),

/***/ "HUpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SercheableDataTable_vue__ = __webpack_require__("PawD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56d3ac66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SercheableDataTable_vue__ = __webpack_require__("LQ7p");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SercheableDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56d3ac66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SercheableDataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HXzR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


var state = {
    route: {}
};

var mutations = {
    setRoute: function setRoute(state, route) {
        state.route = route;
    },
    clearRoute: function clearRoute(state) {
        state.route = '';
    }
};

var actions = {
    setRoute: function setRoute(_ref, route) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            commit('setRoute', route);

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
};

var getters = {
    route: function route(state) {
        return state.route || '';
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash OxM4n5SU5RFeYZUMaT2b54Kun60=';

/***/ }),

/***/ "HcLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Office__ = __webpack_require__("ljCp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_MenuDatePicker__ = __webpack_require__("Z1KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_CardLoader__ = __webpack_require__("JqcZ");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_4__helpers_validation__["a" /* default */],
            valid: true,
            saving: false,
            loading: true,

            form: __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Office__["a" /* default */].build()
        };
    },

    computed: {
        isAdmin: function isAdmin() {
            var ok = this.$store.getters.isAdmin;
            return ok;
        },
        disabled: function disabled() {
            return !this.$store.getters.isAdmin;
        }
    },

    components: {
        appCardLoader: __WEBPACK_IMPORTED_MODULE_7__components_shared_CardLoader__["a" /* default */],
        appMenuDatePicker: __WEBPACK_IMPORTED_MODULE_6__components_shared_MenuDatePicker__["a" /* default */]
    },

    watch: {
        $route: 'fetch'
    },

    created: function created() {
        this.fetch();
    },


    methods: {
        onChange: function onChange() {
            if (!this.form.controlEvaluation) {
                this.form.evaluationStartDate = '';
            }
        },
        fetch: function fetch() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var id;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;

                                id = _this.$route.params.id;

                                if (__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(id)) {
                                    _context.next = 6;
                                    break;
                                }

                                _context.next = 5;
                                return _this.$store.dispatch('fetchOffice', _this.$route.params.id);

                            case 5:
                                _this.form = __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Office__["a" /* default */].toForm(_this.$store.getters.office);

                            case 6:

                                _this.loading = false;

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        save: function save() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.$refs.form.validate()) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:

                                _this2.saving = true;
                                _context2.next = 5;
                                return _this2.$store.dispatch('saveOrUpdateOffice', __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Office__["a" /* default */].toPayload(_this2.form));

                            case 5:
                                _this2.$router.push({ name: 'officeIndex' });

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }
});
'filehash ZtS8HQDg7ArjzphlUKvctr/c9FA=';

/***/ }),

/***/ "IUS0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_recaptcha_v3__ = __webpack_require__("oHEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_recaptcha_v3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_recaptcha_v3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_admin__ = __webpack_require__("/uTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_approverTypes__ = __webpack_require__("0iMK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_areas__ = __webpack_require__("7XVm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_contractItems__ = __webpack_require__("3yes");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_contracts__ = __webpack_require__("gmY0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_demands__ = __webpack_require__("uK4Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_demandOwnerSubstitutions__ = __webpack_require__("RSEO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_demandTypes__ = __webpack_require__("R/7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_evaluations__ = __webpack_require__("gsp3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_events__ = __webpack_require__("Y5KQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_offices__ = __webpack_require__("ebpj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_persons__ = __webpack_require__("HTuS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_route__ = __webpack_require__("HXzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_searchFilter__ = __webpack_require__("EYvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_suppliers__ = __webpack_require__("PDC8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_systems__ = __webpack_require__("YRnO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_units__ = __webpack_require__("faRb");



























__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_recaptcha_v3__["VueReCaptcha"], {
    siteKey: "6LeDDpolAAAAAP8qzwRwK0j59EZp2mnUrFhT_aDr",
    loaderOptions: {
        useRecaptchaNet: false,
        autoHideBadge: true
    },
    explicitRenderParameters: {
        size: "invisible"
    }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* default */].Store({
    state: {
        status: __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["a" /* default */].STORE_EMPTY
    },
    mutations: {
        setStatus: function setStatus(state, value) {
            state.status = value;
        }
    },
    actions: {
        initialize: function initialize(_ref) {
            var _this = this;

            var commit = _ref.commit,
                dispatch = _ref.dispatch;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                commit("setStatus", __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["a" /* default */].STORE_INITIALIZING);

                                _context.prev = 1;
                                _context.next = 4;
                                return dispatch("warmCache");

                            case 4:
                                commit("setStatus", __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["a" /* default */].STORE_READY);
                                _context.next = 10;
                                break;

                            case 7:
                                _context.prev = 7;
                                _context.t0 = _context["catch"](1);

                                commit("setStatus", __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["a" /* default */].STORE_EMPTY);

                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[1, 7]]);
            }))();
        },
        reset: function reset(_ref2) {
            var _this2 = this;

            var commit = _ref2.commit;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                commit("setStatus", __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["a" /* default */].STORE_EMPTY);

                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        warmCache: function warmCache(_ref3) {
            var _this3 = this;

            var dispatch = _ref3.dispatch;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var timeout;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!__WEBPACK_IMPORTED_MODULE_10__modules_auth__["a" /* default */].getters.isLoggedIn) {
                                    _context3.next = 4;
                                    break;
                                }

                                _context3.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([dispatch("loadApproverTypes"), dispatch("loadAreas"), dispatch("loadContractItems"), dispatch("loadContracts"), dispatch("loadDemands"), dispatch("loadDemandOwnerSubstitutions"), dispatch("loadDemandTypes"), dispatch("loadOffices"), dispatch("loadPersons"), dispatch("loadSuppliers"), dispatch("loadSystems"), dispatch("loadUnits")]);

                            case 3:
                                timeout = setTimeout(function () {
                                    clearTimeout(timeout);
                                    dispatch("warmCache");
                                }, 1000 * 60 * 5);

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    },
    getters: {
        isStoreEmpty: function isStoreEmpty(state) {
            return state.status === __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["a" /* default */].STORE_EMPTY;
        },
        isStoreInitializing: function isStoreInitializing(state) {
            return state.status === __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["a" /* default */].STORE_INITIALIZING;
        }
    },
    modules: {
        admin: __WEBPACK_IMPORTED_MODULE_7__modules_admin__["a" /* default */],
        approverTypes: __WEBPACK_IMPORTED_MODULE_8__modules_approverTypes__["a" /* default */],
        areas: __WEBPACK_IMPORTED_MODULE_9__modules_areas__["a" /* default */],
        auth: __WEBPACK_IMPORTED_MODULE_10__modules_auth__["a" /* default */],
        contractItems: __WEBPACK_IMPORTED_MODULE_11__modules_contractItems__["a" /* default */],
        contracts: __WEBPACK_IMPORTED_MODULE_12__modules_contracts__["a" /* default */],
        demands: __WEBPACK_IMPORTED_MODULE_13__modules_demands__["a" /* default */],
        demandOwnerSubstitutions: __WEBPACK_IMPORTED_MODULE_14__modules_demandOwnerSubstitutions__["a" /* default */],
        demandTypes: __WEBPACK_IMPORTED_MODULE_15__modules_demandTypes__["a" /* default */],
        evaluations: __WEBPACK_IMPORTED_MODULE_16__modules_evaluations__["a" /* default */],
        events: __WEBPACK_IMPORTED_MODULE_17__modules_events__["a" /* default */],
        offices: __WEBPACK_IMPORTED_MODULE_18__modules_offices__["a" /* default */],
        persons: __WEBPACK_IMPORTED_MODULE_19__modules_persons__["a" /* default */],
        route: __WEBPACK_IMPORTED_MODULE_20__modules_route__["a" /* default */],
        searchFilter: __WEBPACK_IMPORTED_MODULE_21__modules_searchFilter__["a" /* default */],
        suppliers: __WEBPACK_IMPORTED_MODULE_22__modules_suppliers__["a" /* default */],
        systems: __WEBPACK_IMPORTED_MODULE_23__modules_systems__["a" /* default */],
        units: __WEBPACK_IMPORTED_MODULE_24__modules_units__["a" /* default */]
    }
}));
"filehash E68NC0WhfizVnVLcmh1uwerodiM=";

/***/ }),

/***/ "JPEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("ew0L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_022a9d9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("L2oF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_022a9d9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JShu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__ = __webpack_require__("Palw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ca1b5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__ = __webpack_require__("MMvB");
function injectStyle (ssrContext) {
  __webpack_require__("p7Jl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ca1b5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JpZ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkflowItemDetail_vue__ = __webpack_require__("dZeg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba806784_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkflowItemDetail_vue__ = __webpack_require__("FPVa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkflowItemDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba806784_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkflowItemDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JqcZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6488abbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardLoader_vue__ = __webpack_require__("AMVv");
function injectStyle (ssrContext) {
  __webpack_require__("2wj1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6488abbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K1U4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KYDV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-3",attrs:{"xs7":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled,"placeholder":_vm.$t('label.approverType'),"items":_vm.types,"rules":_vm.rules.type,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"prefix":"R$","rules":_vm.validation.numeric,"maxlength":_vm.constants.LENGTH_UNIT_COST},model:{value:(_vm.costThreshold),callback:function ($$v) {_vm.costThreshold=$$v},expression:"costThreshold"}})],1),_vm._v(" "),(!_vm.disabled)?_c('v-flex',{staticClass:"pa-2",attrs:{"xs1":""}},[_c('v-icon',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.remove}},[_vm._v("delete")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KZDP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Planning_vue__ = __webpack_require__("NBkV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc0a913e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Planning_vue__ = __webpack_require__("0IqK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Planning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc0a913e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Planning_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ko1i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");


/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build() {
        return {
            id: 0,
            acronym: '',
            name: '',
            office: { id: 0 },
            isActive: true,
            isOutsourced: false
        };
    },
    toForm: function toForm(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toForm(obj, this.build());
    },
    toPayload: function toPayload(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toPayload(obj);
    }
});
'filehash XqbhPnzTRsQShCAFCpCiMv8l/X4=';

/***/ }),

/***/ "KqbE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L2oF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isHired)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","lg8":"","offset-xs1":"","offset-lg2":""}},[_c('v-card',{staticClass:"pa-2"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('p',{staticClass:"subheading ma-0",staticStyle:{"font-weight":"500"}},[_vm._v("Avaliação das Demandas")]),_vm._v(" "),_c('p',{staticClass:"grey--text text--darken-1 ma-0"},[_vm._v("Visualiza as informações sobre a avaliação das demandas das Secretarias.")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{staticStyle:{"margin-top":"15px"},on:{"click":_vm.manageScoreOffices}},[_vm._v("\n                            Acessar\n                        ")])],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L9D/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractItem_vue__ = __webpack_require__("giH9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14bae3ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractItem_vue__ = __webpack_require__("x1c9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14bae3ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LGxs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"attachment",on:{"click":_vm.download}},[_c('div',{staticClass:"file-icon"},[_c('v-icon',{class:_vm.color,attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v(_vm._s(_vm.identification)+" • "+_vm._s(_vm.size)+" • "+_vm._s(_vm.extension))])]),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[(_vm.canRemove)?_c('div',{staticClass:"actions",attrs:{"slot":"activator"},on:{"click":function($event){$event.stopPropagation();return _vm.remove($event)}},slot:"activator"},[_c('v-icon',[_vm._v("fa-times")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('tooltip.remove')))])]),_vm._v(" "),_c('v-progress-linear',{attrs:{"height":"3","value":_vm.progress,"background-color":"grey lighten-3"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LQ7p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg10":"","offset-lg1":""}},[_c('v-card',[_c('v-card-title',{staticClass:"search"},[_c('v-btn',{staticClass:"ma-0",attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('label',{staticClass:"grey--text lighten-1",on:{"click":_vm.openSearch}},[_vm._v(_vm._s(_vm.filterPlaceholder))]),_vm._v(" "),_vm._t("beforeReloadButton"),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[(this.refresh != null)?_c('v-btn',{staticClass:"ma-0",attrs:{"slot":"activator","icon":""},on:{"click":_vm.reload},slot:"activator"},[_c('v-icon',{on:{"click":_vm.reload}},[_vm._v("refresh")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('tooltip.refresh')))])],1),_vm._v(" "),_vm._t("afterReloadButton")],2),_vm._v(" "),(_vm.searching)?_c('v-card-title',{staticClass:"search-input"},[_c('v-btn',{staticClass:"ma-0",attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"},{name:"on-click-outside",rawName:"v-on-click-outside",value:(_vm.closeSearch),expression:"closeSearch"},{name:"focus",rawName:"v-focus"}],attrs:{"type":"text","placeholder":_vm.filterPlaceholder},domProps:{"value":(_vm.filter)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.closeSearch($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancelSearch($event)}],"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})],1):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"pa-0"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"rows-per-page-text":_vm.$t('label.pagination'),"loading":_vm.loading,"rows-per-page-items":_vm.rowsPerPageItems,"no-data-text":_vm.$t('message.warning.noData'),"pagination":_vm.customPagination},on:{"update:pagination":function($event){_vm.customPagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_vm._t("items",null,{"item":item})]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n                        "+_vm._s(pageStart)+"-"+_vm._s(pageStop)+" of "+_vm._s(_vm.items.length)+"\n                    ")]}}],null,true)})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LgBd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lgro":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lpxf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/units');
    }
});
'filehash Jxv8UmXB9c9NFwylmTE3EFm9GwQ=';

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdfd2a3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("CaJI");
function injectStyle (ssrContext) {
  __webpack_require__("K1U4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdfd2a3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MMvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{class:_vm.color,attrs:{"timeout":_vm.timeout},model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},[_vm._v("\n   "+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MOJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Evaluation__ = __webpack_require__("VdIX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_rate_it__ = __webpack_require__("al64");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_rate_it__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_4__helpers_validation__["a" /* default */],
            utilities: __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */],
            evaluationForm: __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Evaluation__["a" /* default */].build(),
            oldScoreValue: 0,
            displayEvaluationComment: true
        };
    },


    computed: {
        showEvaluation: function showEvaluation() {
            if (this.$store.getters.demand.owner.id === this.$store.getters.profile.person.id && this.$store.getters.demand.status.id === 6 && this.$store.getters.demand.office.controlEvaluation === true && this.$store.getters.demand.allowedEvaluationSupplier === true) {
                this.loadEvaluation();
                return true;
            }
            return false;
        }
    },
    components: {
        StarRating: __WEBPACK_IMPORTED_MODULE_6_vue_rate_it__["StarRating"]
    },
    methods: {
        saveEvaluation: function saveEvaluation() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var model;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                model = __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Evaluation__["a" /* default */].build();

                                model.demand.id = _this.$store.getters.demand.id;
                                model.person.id = _this.$store.getters.profile.person.id;
                                model.score = _this.evaluationForm.score;
                                model.isActive = true;
                                model.comment = _this.evaluationForm.comment;
                                model.id = _this.evaluationForm.id;
                                console.log(model, "model");
                                _context.next = 10;
                                return _this.$store.dispatch("saveOrUpdateEvaluation", __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Evaluation__["a" /* default */].toPayload(model));

                            case 10:
                                _context.next = 12;
                                return _this.loadEvaluation();

                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        removeEvaluation: function removeEvaluation() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.$store.dispatch("removeEvaluation", __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Evaluation__["a" /* default */].toPayload(_this2.evaluationForm));

                            case 2:
                                _context2.next = 4;
                                return _this2.loadEvaluation();

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        loadEvaluation: function loadEvaluation() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                data = {
                                    demandId: _this3.$store.getters.demand.id,
                                    personId: _this3.$store.getters.profile.person.id
                                };
                                _context3.next = 3;
                                return _this3.$store.dispatch("getEvaluation", data);

                            case 3:
                                _this3.evaluationForm = _this3.$store.getters.evaluation;

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        scoreValue: function scoreValue() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (_this4.oldScoreValue === _this4.evaluationForm.score) {
                                    _this4.evaluationForm.score = 0;
                                }
                                _this4.oldScoreValue = _this4.evaluationForm.score;

                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        toggleEvaluationComment: function toggleEvaluationComment() {
            if (this.displayEvaluationComment === false) {
                this.displayEvaluationComment = true;
            } else {
                this.displayEvaluationComment = false;
            }
        }
    }
});
"filehash B349dI3zN6Xw6NAktX8etEM6qvc=";

/***/ }),

/***/ "MTBT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_CardLoader__ = __webpack_require__("JqcZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_entities_System__ = __webpack_require__("r55f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_ConfirmDialogue__ = __webpack_require__("/Aav");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Approver__ = __webpack_require__("eyBe");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_5__helpers_validation__["a" /* default */],
            currentApprovers: [],
            saving: false,
            loading: true,
            removing: false,

            areas: this.$store.getters.areasValueText,
            offices: this.$store.getters.officesValueText,
            // persons: this.$store.getters.personsHiredValueText,
            suppliers: this.$store.getters.suppliersValueText,

            form: __WEBPACK_IMPORTED_MODULE_7__helpers_entities_System__["a" /* default */].build()
        };
    },


    computed: {
        contracts: function contracts() {
            var _this = this;

            var cFilter = this.$store.getters.contracts.filter(function (contract) {
                return contract.office.id === _this.form.office.id;
            });

            var cFormat = cFilter.map(function (_ref) {
                var id = _ref.id,
                    number = _ref.number,
                    description = _ref.description,
                    isActive = _ref.isActive,
                    validityTerm = _ref.validityTerm;
                return {
                    value: id,
                    text: number + " - " + __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].toDate(validityTerm.finish) + " - " + description,
                    isActive: isActive
                };
            });
            return __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].combobox(cFormat, this.form.contract.id);
        },
        contractItems: function contractItems() {
            var _this2 = this;

            return this.$store.getters.contractItemsValueText.filter(function (item) {
                return item.contractId === _this2.form.contract.id;
            });
        },
        disabled: function disabled() {
            return !this.$store.getters.profile.isAdmin && !this.$store.getters.profile.isRoot || !this.form.isActive;
        },
        noOfficeDisabled: function noOfficeDisabled() {
            return !this.form.office.id;
        },
        persons: function persons() {
            var _this3 = this;

            if (!this.form.supplier.id || this.form.supplier.id === 1) {
                return this.$store.getters.personsHiredValueText;
            }

            var filteredPersons = this.$store.getters.persons.filter(function (item) {
                return !!item.office && item.office.id === _this3.form.office.id;
            });

            return this.$store.getters.personsValueText.filter(function (person) {
                return filteredPersons.find(function (el) {
                    return el.id === person.value;
                });
            });
        },
        contractorManagers: function contractorManagers() {
            return [{ value: null, text: "Sem gerente Relacionado" }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.persons));
        }
    },

    components: {
        appApprover: __WEBPACK_IMPORTED_MODULE_9__Approver__["a" /* default */],
        appCardLoader: __WEBPACK_IMPORTED_MODULE_6__components_shared_CardLoader__["a" /* default */],
        confirmDialogue: __WEBPACK_IMPORTED_MODULE_8__components_shared_ConfirmDialogue__["a" /* default */]
    },

    watch: {
        $route: "fetch"
    },
    mounted: function mounted() {
        var _this4 = this;

        setTimeout(function () {
            _this4.currentApprovers = _this4.form.approvers.slice(0, _this4.form.approvers.length);
        }, 1000);
    },
    created: function created() {
        this.fetch();
    },


    methods: {
        addApprover: function addApprover() {
            this.form.approvers.splice(this.form.approvers.length, 0, __WEBPACK_IMPORTED_MODULE_7__helpers_entities_System__["a" /* default */].approver.build());
        },
        removeApprover: function removeApprover(uuid) {
            var index = this.form.approvers.map(function (approver) {
                return approver.uuid;
            }).indexOf(uuid);
            this.form.approvers.splice(index, 1);
        },
        updateApprover: function updateApprover(value) {
            if (this.currentApprovers.length > 0 && !this.disabled) {
                var cIndex = this.currentApprovers.map(function (approver) {
                    return approver.uuid;
                }).indexOf(value.uuid);

                if (cIndex > -1) {
                    value.msgAlt = "";
                    value.IsAlteraTodosSecretaria = false;
                    if (this.currentApprovers[cIndex].person.id !== value.person.id && !this.currentApprovers[cIndex].isSub) {
                        this.$refs.confirmDialogue.show({
                            title: 'Confirmação',
                            message: 'Deseja alterar o aprovador em todos os sistemas cadastrados?',
                            okButton: 'Sim',
                            cancelButton: 'Não'
                        }).then(function (ok) {
                            if (ok) {
                                value.msgAlt = "a alteração será realizada em todos os sistemas cadastrados";
                                value.IsAlteraTodosSecretaria = true;
                            } else {
                                value.msgAlt = "a alteração será realizada apenas neste sistema";
                            }
                        });
                    }
                }
            }
            var index = this.form.approvers.map(function (approver) {
                return approver.uuid;
            }).indexOf(value.uuid);
            this.form.approvers.splice(index, 1, value);
        },
        addSub: function addSub(base) {
            var index = this.form.approvers.map(function (approver) {
                return approver.uuid;
            }).indexOf(base.uuid);
            var sub = __WEBPACK_IMPORTED_MODULE_7__helpers_entities_System__["a" /* default */].approver.build();
            sub.type = base.type;
            sub.isSub = true;
            this.form.approvers.splice(index + 1, 0, sub);
        },
        clearContractor: function clearContractor() {
            this.form.contractor.id = null;
            this.form.contractorManager.id = null;
        },
        fetch: function fetch() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var id;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this5.loading = true;
                                _this5.form.office.id = _this5.$store.getters.profile.office || null;
                                id = _this5.$route.params.id;

                                if (__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(id)) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 6;
                                return _this5.$store.dispatch("fetchSystem", id);

                            case 6:
                                _this5.form = __WEBPACK_IMPORTED_MODULE_7__helpers_entities_System__["a" /* default */].toForm(_this5.$store.getters.system);
                                if (!_this5.form.contractorManager) {
                                    _this5.form.contractorManager = {
                                        id: null
                                    };
                                }
                                if (__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(_this5.form.contractorManager.id)) {
                                    _this5.form.contractorManager.id = null;
                                }

                            case 9:

                                _this5.loading = false;

                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this5);
            }))();
        },
        remove: function remove() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this6.removing = true;
                                _context2.next = 3;
                                return _this6.$store.dispatch("removeSystem", __WEBPACK_IMPORTED_MODULE_7__helpers_entities_System__["a" /* default */].toPayload(_this6.form));

                            case 3:
                                _this6.$router.push({ name: "systemIndex" });

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this6);
            }))();
        },
        save: function save() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (_this7.$refs.form.validate()) {
                                    _context3.next = 2;
                                    break;
                                }

                                return _context3.abrupt("return");

                            case 2:
                                _context3.prev = 2;

                                _this7.saving = true;
                                _context3.next = 6;
                                return _this7.$store.dispatch("saveOrUpdateSystem", __WEBPACK_IMPORTED_MODULE_7__helpers_entities_System__["a" /* default */].toPayload(_this7.form));

                            case 6:
                                _this7.$router.push({ name: "systemIndex" });
                                _context3.next = 16;
                                break;

                            case 9:
                                _context3.prev = 9;
                                _context3.t0 = _context3["catch"](2);

                                if (!(_context3.t0.data && _context3.t0.data.code === "generic_error")) {
                                    _context3.next = 15;
                                    break;
                                }

                                _this7.saving = false;
                                _context3.next = 16;
                                break;

                            case 15:
                                throw _context3.t0;

                            case 16:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this7, [[2, 9]]);
            }))();
        }
    }
});
"filehash QDr5O2C3qB+vbRxZQW2X6WV3tDo=";

/***/ }),

/***/ "Mlmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__ = __webpack_require__("HUpA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import constants from '@/helpers/constants';



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pagination: {
                descending: true,
                sortBy: "demand.id"
            },
            headers: [{
                text: this.$t("label.demand"),
                value: "demand.code",
                align: "left"
            }, {
                text: this.$t("label.originalOwner"),
                value: "originalOwner.name",
                align: "left"
            }, {
                text: this.$t("label.substitute"),
                value: "substituteOwner.name",
                align: "left"
            }]
        };
    },


    computed: {
        readonly: function readonly() {
            return !this.$store.getters.isAdmin;
        }
    },

    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__["a" /* default */]
    },

    methods: {
        search: function search(filters) {
            var demandOwnerSubstitutions = this.$store.getters.demandOwnerSubstitutions;

            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(demandOwnerSubstitutions, filters, function (demandOwnerSubstitutions, regex) {
                return regex.test(demandOwnerSubstitutions.demand.code) || regex.test(demandOwnerSubstitutions.originalOwner.name) || regex.test(demandOwnerSubstitutions.substituteOwner.name);
            });
        },
        refresh: function refresh() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch("loadDemandOwnerSubstitutions");

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});
"filehash yMr6KWpsxE5itDWU3U8g6wvLbRc=";

/***/ }),

/***/ "N/EK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluatedDemandComments_vue__ = __webpack_require__("bcNN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1041edd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluatedDemandComments_vue__ = __webpack_require__("Cwv1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluatedDemandComments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1041edd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluatedDemandComments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NBkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_FileUpload__ = __webpack_require__("R2v+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_Files__ = __webpack_require__("AUsU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_entities_Demand__ = __webpack_require__("R2Zp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_MenuDatePicker__ = __webpack_require__("Z1KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
      validation: __WEBPACK_IMPORTED_MODULE_4__helpers_validation__["a" /* default */],
      valid: true,
      saving: false,
      rejecting: false,
      form: __WEBPACK_IMPORTED_MODULE_7__helpers_entities_Demand__["a" /* default */].planning.build()
    };
  },

  computed: {
    demand: function demand() {
      return this.$store.getters.demand;
    },
    disabled: function disabled() {
      return !(this.demand.status.id === __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_PLANNING) || !__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isDemandActionable(this.$store.getters.profile, this.demand.owner, this.demand.status, __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_PLANNING);
    },
    disableApprovalButton: function disableApprovalButton() {
      var dataAtual = __WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf("day");
      var dataAprovacao = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.demand.maximumApprovalDeliveryDate).startOf("day");
      if (this.demand.maximumApprovalDeliveryDate) {
        if (dataAtual.isAfter(dataAprovacao) && this.demand.status.id === 3) {
          return true;
        }
      }

      return false;
    },
    cost: function cost() {
      if (!this.demand.contract.id) return null;

      var estimatedTime = __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].toNumber(this.form.estimatedTime);
      var cost = __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].toMoney(this.unitCost);
      var total = __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].toMoney(this.unitCost * estimatedTime);

      return "x " + cost + " = " + total;
    },
    unit: function unit() {
      if (!this.demand.contract.id) return null;

      var id = this.demand.contract.id;
      return this.$store.getters.contractsDictionary[id].unit.name.toLowerCase();
    },
    exibirAprovar: function exibirAprovar() {
      return !this.demand.status.id === __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_PLANNING;
    },
    unitCost: function unitCost() {
      if (!this.demand.contract.id) return null;

      var id = this.demand.contract.id;
      return this.$store.getters.contractsDictionary[id].unitCost;
    },
    isInternalSupplier: function isInternalSupplier() {
      return !this.$store.getters.demand.system.isExternalSupplier;
    }
  },

  components: {
    appFileUpload: __WEBPACK_IMPORTED_MODULE_5__components_shared_FileUpload__["a" /* default */],
    appFiles: __WEBPACK_IMPORTED_MODULE_6__components_shared_Files__["a" /* default */],
    appMenuDatePicker: __WEBPACK_IMPORTED_MODULE_8__components_shared_MenuDatePicker__["a" /* default */]
  },

  watch: {
    demand: "copyToForm"
  },

  methods: {
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.$refs.form.validate()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.saving = true;
                _context.next = 5;
                return _this.$store.dispatch("planDemand", __WEBPACK_IMPORTED_MODULE_7__helpers_entities_Demand__["a" /* default */].planning.prepare(_this.form));

              case 5:
                _this.$router.push({ name: "dashboard" });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reject: function reject() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.rejecting = true;
                _this2.form.comments = _this2.form.description;
                _context2.next = 4;
                return _this2.$store.dispatch("rejectDemand", __WEBPACK_IMPORTED_MODULE_7__helpers_entities_Demand__["a" /* default */].planning.prepare(_this2.form));

              case 4:
                _this2.$router.push({ name: "dashboard" });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    copyToForm: function copyToForm(demand) {
      this.form = __WEBPACK_IMPORTED_MODULE_7__helpers_entities_Demand__["a" /* default */].planning.copy(demand);
    },
    getFormattedDate: function getFormattedDate(date) {
      if (date) {
        var d = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).format("DD/MM/YYYY");

        return "*Este planejamento deve ser aprovado até o dia " + d;
      }
      return "*Sem data máxima de aprovação";
    }
  }
});
"filehash DNmT2lot1KLjgfmiqx2g1b+Ff3Y=";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_on_click_outside__ = __webpack_require__("YccO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_focus__ = __webpack_require__("9otY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_filters__ = __webpack_require__("aGO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__("M93x");

// JS Framework and CSS Framework



// Routing, state management, i18n and validation




// Directives



// Filters


// Default


// Register everything
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('on-click-outside', __WEBPACK_IMPORTED_MODULE_6_vue_on_click_outside__["directive"]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('focus', __WEBPACK_IMPORTED_MODULE_7__directives_focus__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__helpers_filters__).forEach(function (key) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_8__helpers_filters__[key]);
});

// Disable annoying message
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
window.Vue = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    i18n: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */]);
    }
});
'filehash uwLVXJjoWopellXD7zG/T81Bkog=';

/***/ }),

/***/ "NaOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("sonc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b6a8c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("2rH8");
function injectStyle (ssrContext) {
  __webpack_require__("IUS0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b6a8c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NnrY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs10":"","lg8":"","offset-xs1":"","offset-lg2":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('v-card',{staticClass:"pa-3"},[_c('div',{staticClass:"subheading mb-3"},[_vm._v(_vm._s(_vm.$t('label.filters')))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.reference'))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('div',[(_vm.disabled || _vm.readonly)?_c('v-text-field',{staticClass:"input-group--date-text-field",attrs:{"disabled":_vm.disabled},model:{value:(_vm.formatted),callback:function ($$v) {_vm.formatted=$$v},expression:"formatted"}}):_vm._e(),_vm._v(" "),(!_vm.disabled && !_vm.readonly)?_c('v-menu',{staticStyle:{"cursor":"arrow"},attrs:{"close-on-content-click":true,"transition":"scale-transition","offset-y":"","full-width":"","nudge-top":20,"max-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{staticStyle:{"pointer-events":"none"},attrs:{"slot":"activator","rules":_vm.validation.required},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","show-current":"true","locale":"pt"},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1):_vm._e()],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.contract'))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","items":_vm.contracts,"clearable":"","no-data-text":_vm.$t('message.warning.noData'),"maxlength":_vm.constants.LENGTH_CONTRACT,"rules":_vm.validation.required},model:{value:(_vm.form.contractId),callback:function ($$v) {_vm.$set(_vm.form, "contractId", $$v)},expression:"form.contractId"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.contractItem')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg6":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":!this.form.contractId,"items":_vm.contractItems,"no-data-text":_vm.$t('message.warning.noData'),"maxlength":_vm.constants.LENGTH_CONTRACT_ITEM},model:{value:(_vm.form.contractItemId),callback:function ($$v) {_vm.$set(_vm.form, "contractItemId", $$v)},expression:"form.contractItemId"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.system')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":!this.form.contractItemId,"items":_vm.systems,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.systemId),callback:function ($$v) {_vm.$set(_vm.form, "systemId", $$v)},expression:"form.systemId"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"disabled":_vm.creatingReport},on:{"click":_vm.clear}},[_vm._v("\n                                "+_vm._s(_vm.$t('label.clear'))+"\n                            ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"disabled":_vm.creatingReport,"loading":_vm.creatingReport,"color":"primary"},on:{"click":_vm.createReport}},[_vm._v("\n                            PDF\n                        ")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-0",attrs:{"disabled":_vm.creatingReport,"loading":_vm.creatingReport,"color":"secondary"},on:{"click":_vm.createCsvReport}},[_vm._v("\n                            CSV\n                        ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O9Vu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__ = __webpack_require__("HUpA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pagination: {
                descending: false,
                sortBy: 'name'
            },
            headers: [{
                text: this.$t('label.code'),
                value: 'id',
                align: 'left'
            }, {
                text: this.$t('label.office'),
                value: 'acronym',
                align: 'left'
            }, {
                text: this.$t('label.name'),
                value: 'name',
                align: 'left'
            }, {
                text: this.$t('label.status'),
                value: 'status',
                align: 'left'
            }, {
                text: this.$t('label.email'),
                value: 'status',
                align: 'left'
            }]
        };
    },

    methods: {
        search: function search(filters) {
            var offices = this.$store.getters.offices;

            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(offices, filters, function (office, regex) {
                return regex.test(office.acronym) || regex.test(office.name) || regex.test(office.id);
            });
        },
        refresh: function refresh() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('loadOffices');

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    computed: {
        offices: function offices() {
            var _this2 = this;

            var items = this.$store.getters.offices;
            items.forEach(function (item) {
                item.status = item.isActive ? _this2.$t('label.active') : _this2.$t('label.inactive');
            });
            return items;
        },
        readonly: function readonly() {
            return !this.$store.getters.isAdmin;
        }
    },
    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__["a" /* default */]
    }
});
'filehash 58bSGQCH4FXidpTtZuNzS+PbiyM=';

/***/ }),

/***/ "OK5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_vm._v("Encerramento")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OTdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_File__ = __webpack_require__("5Bfa");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        files: {
            type: Array,
            required: true
        },
        removedFiles: {
            type: Array,
            required: false,
            default: function _default() {
                return [];
            }
        },
        removeable: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        remove: function remove(_ref) {
            var fileName = _ref.fileName;

            var index = this.files.map(function (file) {
                return file.fileName;
            }).indexOf(fileName);
            var removed = this.files.splice(index, 1);
            this.removedFiles.push(removed[0]);
            this.$emit('update:files', this.files);
            this.$emit('update:removedFiles', this.removedFiles);
            // this.$store.dispatch('approveDemand', this.form);
        }
    },
    components: {
        appFile: __WEBPACK_IMPORTED_MODULE_0__components_shared_File__["a" /* default */]
    }
});
'filehash 9M0dX5G10/X4qLum+TG2PZsbplg=';

/***/ }),

/***/ "OszP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEvaluation),expression:"showEvaluation"}]},[_c('p',{staticClass:"body-1 grey--text text--darken-1 mt-4"},[_vm._v(_vm._s(_vm.$t('label.demandEvaluation')))]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{staticClass:"alignClass",attrs:{"row":""}},[_c('star-rating',{attrs:{"item-size":25,"inactive-color":"#eee","active-color":"#fb8c00","show-rating":false,"spacing":"0"},on:{"rating-selected":_vm.scoreValue},model:{value:(_vm.evaluationForm.score),callback:function ($$v) {_vm.$set(_vm.evaluationForm, "score", $$v)},expression:"evaluationForm.score"}}),_vm._v(" "),_c('v-btn',{staticClass:"pa-2 dotsClass",attrs:{"icon":""},on:{"click":_vm.toggleEvaluationComment}},[_c('v-icon',{staticClass:"threedots"},[_vm._v("more_horiz")])],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayEvaluationComment),expression:"displayEvaluationComment"}],attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"multi-line":"","auto-grow":"","counter":_vm.constants.LENGTH_DESCRIPTION,"maxlength":_vm.constants.LENGTH_DESCRIPTION},model:{value:(_vm.evaluationForm.comment),callback:function ($$v) {_vm.$set(_vm.evaluationForm, "comment", $$v)},expression:"evaluationForm.comment"}})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.saveEvaluation}},[_vm._v("Enviar")]),_vm._v(" "),(this.$store.getters.evaluation.id !== 0)?_c('v-btn',{attrs:{"color":"error"},on:{"click":_vm.removeEvaluation}},[_vm._v("Excluir")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P4Cw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PDC8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");




var state = {
    suppliers: []
};

var mutations = {
    setSuppliers: function setSuppliers(state, suppliers) {
        state.suppliers = suppliers;
    }
};

var actions = {
    loadSuppliers: function loadSuppliers(_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].suppliers.list();

                        case 2:
                            response = _context.sent;

                            commit('setSuppliers', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
};

var getters = {
    suppliers: function suppliers() {
        return state.suppliers || [];
    },
    suppliersValueText: function suppliersValueText(_, getters) {
        return getters.suppliers.map(function (_ref2) {
            var id = _ref2.id,
                name = _ref2.name;
            return { value: id, text: name };
        });
    },
    suppliersDictionary: function suppliersDictionary(_, getters) {
        return getters.suppliers.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash dtBkwlgTzZ2CrC7Id/7YTCHdzoY=';

/***/ }),

/***/ "Palw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_constants__ = __webpack_require__("eHeZ");


//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            timeout: 10000
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['event']), {
        display: {
            get: function get() {
                return this.event.display;
            },
            set: function set() {
                this.$store.dispatch('hideEvent');
            }
        },
        message: function message() {
            return this.event.message;
        },
        color: function color() {
            var _hash;

            var hash = (_hash = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hash, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].EVENT_SUCCESS, 'success'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hash, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].EVENT_INFO, 'primary'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hash, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].EVENT_WARNING, 'warning'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_hash, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].EVENT_ERROR, 'error'), _hash);
            return hash[this.event.type];
        }
    })
});
'filehash Moe4bxjY6oytwsGRoYIjKI3Ow+0=';

/***/ }),

/***/ "PawD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__("mWYR");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        headers: {
            type: Array,
            required: true
        },
        search: {
            type: Function,
            required: true
        },
        refresh: {
            type: Function,
            required: true
        },
        placeholder: {
            type: String,
            required: false,
            default: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.info.generalSearch')
        },
        pagination: {
            type: Object,
            required: false,
            default: function _default() {
                return {};
            }
        },
        reduced: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function data() {
        return {
            rowsPerPageItems: this.reduced ? [5] : __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */].componentOptions.rowsPerPageItems,
            searching: false,
            loading: false,
            customPagination: {
                descending: this.pagination.descending,
                sortBy: this.pagination.sortBy
            }
        };
    },


    computed: {
        // I'm a bad bad boy, I use setters with computed properties. Don't do that 'just because'.
        // If you want to do the same, read the documentation first so that you understand how it
        // works and think thrice about why you think you need it.
        filter: {
            get: function get() {
                return this.$store.getters.searchFilter;
            },
            set: function set(value) {
                this.$store.dispatch('setSearchFilter', value);
            }
        },
        filterPlaceholder: function filterPlaceholder() {
            if (!__WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].isEmpty(this.filter)) return this.filter;

            return this.placeholder;
        },
        items: function items() {
            return this.search(this.filter);
        }
    },

    beforeCreate: function beforeCreate() {
        var route = this.$store.getters.route;

        // If the user is coming from the edit version of the current page, clear the filter
        if (route.from.name) {
            var entity = route.from.name.replace('Edit', '');
            if (route.to.name !== entity + 'Index') this.$store.dispatch('clearSearchFilter');
        }
    },


    methods: {
        openSearch: function openSearch() {
            this.searching = true;
        },
        closeSearch: function closeSearch() {
            this.searching = false;
        },
        cancelSearch: function cancelSearch() {
            this.filter = '';
            this.searching = false;
        },
        reload: function reload() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.loader) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:

                                _this.loading = true;
                                _context.next = 5;
                                return _this.refresh();

                            case 5:
                                _this.loading = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});
'filehash DKvui3ApnQlNSM8eHX8Jzntq8b0=';

/***/ }),

/***/ "PfPb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pfph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    authenticate: function authenticate(credentials) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/ldap', credentials);
    }
});
'filehash LjDarFk9G6sRtb/7yny7fpR7mTE=';

/***/ }),

/***/ "Q/lz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("fP+C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f06883f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("1NdP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f06883f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q1Hv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");


/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build() {
        return {
            id: 0,
            number: '',
            description: '',
            subjectMatter: '',
            warrantyDays: null,
            warrantyValidityTerm: {
                start: null,
                finish: null
            },
            validityTerm: {
                start: null,
                finish: null
            },
            unit: { id: null },
            unitCost: '',
            hiredAmount: null,
            isInUse: false,
            isActive: true,
            items: [this.item.build()],
            office: { id: null },
            newId: 0,
            newContractItems: {},
            itemsOldToNew: [],
            demandStates: [],
            estimatedTime: null,
            executedTime: null
        };
    },
    toForm: function toForm(obj) {
        var form = __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toForm(obj, this.build());
        form.unitCost = form.unitCost.toString().replace('.', ',');
        return form;
    },
    toPayload: function toPayload(obj) {
        var payload = __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toPayload(obj);
        // payload.office = { id: 1 };
        payload.unitCost = payload.unitCost.toString().replace(',', '.');
        return payload;
    },


    item: {
        build: function build() {
            return {
                id: null,
                description: null,
                timeAmount: null,
                estimatedTime: null,
                executedTime: null,
                uuid: __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].uuidv4()
            };
        }
    }
});
'filehash bis98CLIYicrErAyTwz4M+SB2Uw=';

/***/ }),

/***/ "QOoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateContract_vue__ = __webpack_require__("Gf8v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72673f4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateContract_vue__ = __webpack_require__("3dgQ");
function injectStyle (ssrContext) {
  __webpack_require__("Lgro")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateContract_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72673f4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateContract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qcjb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R/7u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__ = __webpack_require__("ml+B");


/* eslint no-unused-vars: ["error", { "args": "none" }] */




var state = {
    demandType: {},
    demandTypes: []
};

var mutations = {
    setDemandType: function setDemandType(state, demandType) {
        state.demandType = demandType;
    },
    setDemandTypes: function setDemandTypes(state, demandTypes) {
        state.demandTypes = demandTypes;
    }
};

var actions = {
    loadDemandTypes: function loadDemandTypes(_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demandTypes.list();

                        case 2:
                            response = _context.sent;

                            commit('setDemandTypes', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    fetchDemandType: function fetchDemandType(_ref2, id) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demandTypes.get(id);

                        case 2:
                            response = _context2.sent;

                            commit('setDemandType', response.data);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    removeDemandType: function removeDemandType(_ref3, form) {
        var _this3 = this;

        var dispatch = _ref3.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demandTypes.remove(form.id);

                        case 2:
                            _context3.next = 4;
                            return dispatch('loadDemandTypes');

                        case 4:
                            if (form.isInUse) {
                                dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('message.success.demandTypeRemoved'));
                            } else {
                                dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('message.success.demandTypeDisabled'));
                            }

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    saveDemandType: function saveDemandType(_ref4, form) {
        var _this4 = this;

        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            state = _ref4.state;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demandTypes.save(form);

                        case 2:
                            response = _context4.sent;
                            _context4.next = 5;
                            return dispatch('fetchDemandType', response.data.id);

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    saveOrUpdateDemandType: function saveOrUpdateDemandType(_ref5, form) {
        var _this5 = this;

        var dispatch = _ref5.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(form.id)) {
                                _context5.next = 5;
                                break;
                            }

                            _context5.next = 3;
                            return dispatch('saveDemandType', form);

                        case 3:
                            _context5.next = 7;
                            break;

                        case 5:
                            _context5.next = 7;
                            return dispatch('updateDemandType', form);

                        case 7:
                            _context5.next = 9;
                            return dispatch('loadDemandTypes');

                        case 9:
                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('message.success.saved'));

                        case 10:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    updateDemandType: function updateDemandType(_ref6, form) {
        var _this6 = this;

        var dispatch = _ref6.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demandTypes.update(form.id, form);

                        case 2:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    }
};

var getters = {
    demandType: function demandType(state) {
        return state.demandType;
    },
    demandTypes: function demandTypes(state) {
        var demandTypes = state.demandTypes || [];
        return demandTypes.sort(function (a, b) {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].stringCompare(a.name, b.name);
        });
    },
    demandTypesValueText: function demandTypesValueText(_, getters) {
        return getters.demandTypes.map(function (_ref7) {
            var id = _ref7.id,
                name = _ref7.name,
                isActive = _ref7.isActive;
            return {
                value: id,
                text: name,
                isActive: isActive
            };
        });
    },
    demandTypesDictionary: function demandTypesDictionary(_, getters) {
        return getters.demandTypes.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash sD7Ol1XwOnU4KB7c+5ioO3kKtH0=';

/***/ }),

/***/ "R1FV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R2Zp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Person__ = __webpack_require__("rTIS");





/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build(person) {
        return {
            id: 0,
            code: 0,
            owner: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ id: null }, person),
            creator: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ id: null }, person),
            requester: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ id: null }, person),
            status: { id: null },
            system: { id: null },
            type: { id: null },
            contract: { id: null },
            contractItem: { id: null },
            relatedDemand: { id: null },
            title: '',
            description: '',
            remarks: '',
            reason: '',
            outcome: '',
            similarDemandsDescription: '',
            filesDescription: '',
            files: [],
            lastFlowDate: '',
            desirableDate: '',
            inWarranty: false,
            warrantyUntil: '',
            subOwners: [],
            ownerType: 0
        };
    },
    copy: function copy(demand) {
        demand = demand || this.build();
        var fileList = __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].acumulateFiles(demand.workflowHistory, __WEBPACK_IMPORTED_MODULE_1__helpers_constants__["a" /* default */].STATUS_CREATED);
        __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].acumulateFiles(demand.workflowHistory, __WEBPACK_IMPORTED_MODULE_1__helpers_constants__["a" /* default */].STATUS_REJECTED).forEach(function (item) {
            fileList.push(item);
        });
        return {
            id: demand.id,
            code: demand.code,
            owner: __WEBPACK_IMPORTED_MODULE_3__Person__["a" /* default */].toForm(demand.owner),
            creator: __WEBPACK_IMPORTED_MODULE_3__Person__["a" /* default */].toForm(demand.creator),
            requester: __WEBPACK_IMPORTED_MODULE_3__Person__["a" /* default */].toForm(demand.requester),
            status: { id: demand.status.id },
            system: { id: demand.system.id },
            type: { id: demand.type.id },
            contract: { id: demand.contract.id },
            contractItem: { id: (demand.contractItem || {}).id },
            relatedDemand: { id: (demand.relatedDemand || {}).id },
            title: demand.title,
            description: demand.description,
            remarks: demand.remarks,
            reason: demand.reason,
            outcome: demand.outcome,
            similarDemandsDescription: demand.similarDemandsDescription,
            filesDescription: demand.filesDescription,
            lastFlowDate: demand.lastFlowDate,
            files: fileList,
            removedFiles: [],
            desirableDate: demand.desirableDate,
            inWarranty: demand.inWarranty,
            warrantyUntil: demand.warrantyUntil,
            subOwners: demand.subOwners,
            ownerType: demand.ownerType,
            office: { id: 0, controlEvaluation: false },
            scoreAverage: demand.scoreAverage,
            allowedEvaluationSupplier: false,

            estimatedDeliveryDate: demand.estimatedDeliveryDate,
            maximumApprovalDeliveryDate: demand.maximumApprovalDeliveryDate
        };
    },
    prepare: function prepare(demand) {
        var copy = this.copy(demand);

        copy.files = demand.files.filter(function (e) {
            return e.isNewFile === true;
        });
        copy.removedFiles = demand.removedFiles;

        if (__WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].isEmptyOrZero(copy.relatedDemand.id)) copy.relatedDemand = null;

        return copy;
    },


    approval: {
        build: function build() {
            return {
                id: 0,
                code: '',
                comments: '',
                files: [],
                removedFiles: []
            };
        },
        copy: function copy(_ref) {
            var id = _ref.id,
                code = _ref.code;

            return {
                id: id,
                code: code,
                comments: '',
                files: [],
                removedFiles: []
            };
        }
    },

    cancel: {
        build: function build() {
            return {
                id: 0,
                code: '',
                comments: '',
                files: [],
                removedFiles: []
            };
        },
        copy: function copy(_ref2) {
            var id = _ref2.id,
                code = _ref2.code;

            return {
                id: id,
                code: code,
                comments: '',
                files: [],
                removedFiles: []
            };
        }
    },

    delivery: {
        build: function build() {
            return {
                id: 0,
                deliverableId: 0,
                plannedTime: '',
                deliveryDate: null,
                executedTime: '',
                description: '',
                files: [],
                removedFiles: []
            };
        },
        copy: function copy(demand) {
            var delivery = demand.deliveries[0] || this.build();

            return {
                id: demand.id,
                code: demand.code,
                deliverableId: delivery.id,
                plannedTime: delivery.plannedTime,
                deliveryDate: delivery.deliveryDate,
                executedTime: delivery.executedTime,
                description: delivery.description,
                files: __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].acumulateFiles(demand.workflowHistory, __WEBPACK_IMPORTED_MODULE_1__helpers_constants__["a" /* default */].STATUS_DELIVERY),
                removedFiles: []
            };
        },
        prepare: function prepare(delivery) {
            var copy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, delivery);

            copy.plannedTime = delivery.plannedTime.toString().replace(',', '.');
            copy.removedFiles = delivery.removedFiles;
            copy.files = delivery.files.filter(function (e) {
                return e.isNewFile === true;
            });

            return copy;
        }
    },

    planning: {
        build: function build() {
            return {
                id: 0,
                estimatedTime: '',
                daysToDelivery: null,
                description: '',
                files: [],
                removedFiles: []
            };
        },
        copy: function copy(demand) {
            if (demand.estimatedTime === undefined) demand.estimatedTime = '';

            return {
                id: demand.id,
                code: demand.code,
                estimatedTime: demand.estimatedTime.toString(), // #TODO: fix this shit
                daysToDelivery: demand.daysToDelivery,
                description: demand.planningDescription,
                estimatedDeliveryDate: demand.estimatedDeliveryDate,
                maximumApprovalDeliveryDate: demand.maximumApprovalDeliveryDate,

                files: __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].acumulateFiles(demand.workflowHistory, __WEBPACK_IMPORTED_MODULE_1__helpers_constants__["a" /* default */].STATUS_PLANNING)
            };
        },
        prepare: function prepare(planning) {
            var copy = this.copy(planning);

            copy.files = planning.files.filter(function (e) {
                return e.isNewFile === true;
            });
            copy.description = planning.description;
            copy.removedFiles = planning.removedFiles;
            copy.estimatedTime = planning.estimatedTime.toString().replace(',', '.');

            return copy;
        }
    }
});
'filehash JvdyPs13sfra2i9loMPJrCVH7yo=';

/***/ }),

/***/ "R2v+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__ = __webpack_require__("rVoo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c499e01a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__ = __webpack_require__("VE62");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c499e01a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RG33":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[(!_vm.loading)?_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[(!_vm.transient)?_c('v-alert',{staticClass:"mb-3",attrs:{"color":"warning","icon":"warning","value":"true"}},[_vm._v("\n                        "+_vm._s(_vm.$t("message.info.substitutionInUse"))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subheading mb-3"},[_vm._v("\n                        "+_vm._s(_vm.$t("label.basicInfo"))+"\n                    ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.demand"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled || !_vm.transient,"items":_vm.demands,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.demand.id),callback:function ($$v) {_vm.$set(_vm.form.demand, "id", $$v)},expression:"form.demand.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.originalOwner"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled || !_vm.transient,"items":_vm.persons,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.originalOwner.id),callback:function ($$v) {_vm.$set(_vm.form.originalOwner, "id", $$v)},expression:"form.originalOwner.id"}})],1)],1),_vm._v(" "),(!!this.form.originalOwner.id)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.substitute"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled || !_vm.transient,"items":_vm.filteredPersons,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.substituteOwner.id),callback:function ($$v) {_vm.$set(_vm.form.substituteOwner, "id", $$v)},expression:"form.substituteOwner.id"}})],1)],1):_vm._e()],1),_vm._v(" "),(!_vm.disabled)?_c('v-card-actions',[_c('v-btn',{attrs:{"disabled":_vm.removing,"loading":_vm.saving,"color":"primary"},on:{"click":_vm.save}},[_vm._v("\n                        "+_vm._s(_vm.$t("label.save"))+"\n                    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.form.isInUse && !!_vm.form.id)?_c('v-btn',{attrs:{"disabled":_vm.saving,"loading":_vm.removing,"color":"error"},on:{"click":_vm.remove}},[_vm._v("\n                        "+_vm._s(_vm.$t("label.remove"))+"\n                    ")]):_vm._e()],1):_vm._e()],1):_c('v-card',[_c('app-card-loader')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RSEO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__("mWYR");


/* eslint no-unused-vars: ["error", { "args": "none" }] */




var state = {
    demandOwnerSubstitutions: [],
    demandOwnerSubstitution: {}
};

var mutations = {
    setDemandOwnerSubstitutions: function setDemandOwnerSubstitutions(state, demandOwnerSubstitutions) {
        state.demandOwnerSubstitutions = demandOwnerSubstitutions;
    },
    setDemandOwnerSubstitution: function setDemandOwnerSubstitution(state, demandOwnerSubstitution) {
        state.demandOwnerSubstitution = demandOwnerSubstitution;
    }
};

var actions = {

    // CRUD
    fetchDemandOwnerSubstitution: function fetchDemandOwnerSubstitution(_ref, id) {
        var _this = this;

        var commit = _ref.commit,
            dispatch = _ref.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demandOwnerSubstitutions.fetch(id);

                        case 2:
                            response = _context.sent;

                            commit('setDemandOwnerSubstitution', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    loadDemandOwnerSubstitutions: function loadDemandOwnerSubstitutions(_ref2) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demandOwnerSubstitutions.list();

                        case 2:
                            response = _context2.sent;

                            commit('setDemandOwnerSubstitutions', response.data);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    removeDemandOwnerSubstitution: function removeDemandOwnerSubstitution(_ref3, form) {
        var _this3 = this;

        var dispatch = _ref3.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demandOwnerSubstitutions.remove(form.id);

                        case 2:
                            _context3.next = 4;
                            return dispatch('loadDemandOwnerSubstitutions');

                        case 4:
                            _context3.next = 6;
                            return dispatch('loadDemands');

                        case 6:

                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.success.demandOwnerSubstitutionRemoved'));

                        case 7:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    saveDemandOwnerSubstitution: function saveDemandOwnerSubstitution(_ref4, form) {
        var _this4 = this;

        var commit = _ref4.commit,
            dispatch = _ref4.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demandOwnerSubstitutions.save(form);

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    saveOrUpdateDemandOwnerSubstitution: function saveOrUpdateDemandOwnerSubstitution(_ref5, form) {
        var _this5 = this;

        var dispatch = _ref5.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(form.id)) {
                                _context5.next = 5;
                                break;
                            }

                            _context5.next = 3;
                            return dispatch('saveDemandOwnerSubstitution', form);

                        case 3:
                            _context5.next = 7;
                            break;

                        case 5:
                            _context5.next = 7;
                            return dispatch('updateDemandOwnerSubstitution', form);

                        case 7:
                            _context5.next = 9;
                            return dispatch('loadDemandOwnerSubstitutions');

                        case 9:
                            _context5.next = 11;
                            return dispatch('loadDemands');

                        case 11:
                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.success.saved'));

                        case 12:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    updateDemandOwnerSubstitution: function updateDemandOwnerSubstitution(_ref6, form) {
        var _this6 = this;

        var dispatch = _ref6.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demandOwnerSubstitutions.update(form.id, form);

                        case 2:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    }
};

var getters = {
    demandOwnerSubstitution: function demandOwnerSubstitution(state) {
        return state.demandOwnerSubstitution || {};
    },
    demandOwnerSubstitutions: function demandOwnerSubstitutions(state) {
        var demandOwnerSubstitutions = state.demandOwnerSubstitutions || [];
        return demandOwnerSubstitutions;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash G54/dO+cwJg7tukOSIEMldQLGT0=';

/***/ }),

/***/ "SQEu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Server_vue__ = __webpack_require__("iNNp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_553e0a8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Server_vue__ = __webpack_require__("GC4J");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Server_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_553e0a8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Server_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T6h/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpiredPassword_vue__ = __webpack_require__("AYtm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_021810c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpiredPassword_vue__ = __webpack_require__("jZOz");
function injectStyle (ssrContext) {
  __webpack_require__("bJnY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpiredPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_021810c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpiredPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TUIa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',[_c('v-card-text',[_c('div',{staticClass:"subheading mb-3"},[_vm._v(_vm._s(_vm.$t("label.basicInfo")))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.estimatedQuantity"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"suffix":_vm.unit,"rules":_vm.validation.requiredNumeric,"maxlength":_vm.constants.LENGTH_PLANNED_TIME},model:{value:(_vm.form.plannedTime),callback:function ($$v) {_vm.$set(_vm.form, "plannedTime", _vm._n($$v))},expression:"form.plannedTime"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.deliveryDate"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('app-menu-date-picker',{attrs:{"model":_vm.form.deliveryDate,"disabled":_vm.disabled,"label":_vm.$t('label.deliveryDate'),"rules":_vm.validation.required},on:{"update:model":function($event){return _vm.$set(_vm.form, "deliveryDate", $event)}}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.usedTime")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabledExecutedTime,"suffix":_vm.unit,"mask":_vm.validation.mask.executedTime},model:{value:(_vm.form.executedTime),callback:function ($$v) {_vm.$set(_vm.form, "executedTime", _vm._n($$v))},expression:"form.executedTime"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"subheading mt-3"},[_vm._v(_vm._s(_vm.$t("label.details")))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.demandDeliveryDetails'))}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.description")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":_vm.disabledExecutedTime,"auto-grow":"","counter":_vm.constants.LENGTH_DESCRIPTION,"maxlength":_vm.constants.LENGTH_DESCRIPTION},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.files.length > 0),expression:"form.files.length > 0"}],staticClass:"mt-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs9":"","lg10":"","offset-xs3":"","offset-lg2":""}},[_c('app-files',{attrs:{"files":_vm.form.files,"removedFiles":_vm.form.removedFiles,"removeable":!_vm.disabled},on:{"update:files":function($event){return _vm.$set(_vm.form, "files", $event)},"update:removedFiles":function($event){return _vm.$set(_vm.form, "removedFiles", $event)},"update:removed-files":function($event){return _vm.$set(_vm.form, "removedFiles", $event)}}})],1)],1)],1),_vm._v(" "),(!_vm.disabled)?_c('v-card-actions',[_c('v-btn',{attrs:{"loading":_vm.saving,"disabled":_vm.desabilitaRequestApproval,"color":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t("label.requestApproval")))]),_vm._v(" "),_c('app-file-upload',{attrs:{"disabled":_vm.saving,"model":_vm.form.files},on:{"update:model":function($event){return _vm.$set(_vm.form, "files", $event)}}})],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UA8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("dNod");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a111210_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("VzEV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a111210_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UFPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__ = __webpack_require__("HUpA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_DialogLoader__ = __webpack_require__("mB/l");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pagination: {
                descending: true,
                sortBy: "code"
            },
            headers: [{
                text: this.$t("label.code"),
                value: "code",
                align: "left"
            }, {
                text: this.$t("label.system"),
                value: "system.acronym",
                align: "left"
            }, {
                text: this.$t("label.name"),
                value: "title",
                align: "left"
            }, {
                text: this.$t("label.demandType"),
                value: "type.name",
                align: "left"
            }, {
                text: this.$t("label.averageEvaluationDemands"),
                value: "evaluationAverage",
                align: "left"
            }, {
                text: this.$t("label.comments"),
                value: "evaluationComments",
                align: "left"
            }],
            loading: true
        };
    },


    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__["a" /* default */],
        DialogLoader: __WEBPACK_IMPORTED_MODULE_4__shared_DialogLoader__["a" /* default */]
    },

    methods: {
        search: function search(filters) {
            var demands = this.$store.getters.evaluatedDemandsGrid;

            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(demands, filters, function (demand, regex) {
                return regex.test(demand.code.toString()) || regex.test(demand.system.acronym) || regex.test(demand.title) || regex.test(demand.type.name) || regex.test(demand.evaluationAverage);
            });
        },
        getEvaluatedDemands: function getEvaluatedDemands() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var id;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;
                                id = _this.$route.params.officeId;

                                if (__WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].isEmptyOrZero(id)) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 5;
                                return _this.$store.dispatch("loadEvaluatedDemandsGrid", id);

                            case 5:

                                _this.loading = false;

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    beforeMount: function beforeMount() {
        this.getEvaluatedDemands();
    }
});
"filehash oZ1uXRZuMZCXm4mDtZi+IaOvhH4=";

/***/ }),

/***/ "UIue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__ = __webpack_require__("HUpA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import constants from '@/helpers/constants';



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            headers: [{
                text: this.$t('label.name'),
                value: 'name',
                align: 'left'
            }, {
                text: this.$t('label.active') + '?',
                value: 'status',
                align: 'left'
            }, {
                text: this.$t('label.description'),
                value: 'description',
                align: 'left',
                sortable: false
            }]
        };
    },


    computed: {
        demandTypes: function demandTypes() {
            var _this = this;

            var demandTypes = this.$store.getters.demandTypes;
            demandTypes.forEach(function (type) {
                type.status = type.isActive ? _this.$t('label.yes') : _this.$t('label.no');
            });
            return demandTypes;
        },
        readonly: function readonly() {
            return !this.$store.getters.isAdmin;
        }
    },

    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__["a" /* default */]
    },

    methods: {
        search: function search(filters) {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(this.demandTypes, filters, function (demandType, regex) {
                return regex.test(demandType.status) || regex.test(demandType.name) || regex.test(demandType.description);
            });
        },
        refresh: function refresh() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadDemandTypes');

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    }
});
'filehash r76zKPoXQ4LhmgPY9kjAAF4K4to=';

/***/ }),

/***/ "UcNA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.refresh,"pagination":_vm.pagination},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'officeEdit', params: { id: item.id }},"tag":"tr"}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.acronym))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.email))])])]}}])},[(!_vm.readonly)?_c('template',{slot:"afterReloadButton"},[_c('v-btn',{attrs:{"to":{ name: 'officeCreate' },"color":"primary"}},[_vm._v(_vm._s(_vm.$t('label.createOffice')))])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VE62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file_upload btn elevation-2",class:{'btn--disabled': _vm.disabled},attrs:{"ripple":""}},[_c('div',{staticClass:"btn__content"},[_c('input',{ref:"filesInput",attrs:{"type":"file","multiple":""},on:{"change":function($event){return _vm.changed($event.target.files);}}}),_vm._v(" "),_c('v-icon',{attrs:{"left":""}},[_vm._v("fa-paperclip")]),_vm._v("Anexar Arquivos\n    ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VG0+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"popup-modal"},[_c('div',{staticClass:"window"},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VWKD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkflowHistory_vue__ = __webpack_require__("C0Va");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c314e12c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkflowHistory_vue__ = __webpack_require__("qdk4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkflowHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c314e12c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkflowHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VYCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DemandBilling_vue__ = __webpack_require__("2V8o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d195120_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DemandBilling_vue__ = __webpack_require__("NnrY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DemandBilling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d195120_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DemandBilling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VYPm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("MTBT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f38c7860_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("pJne");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f38c7860_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VdIX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");


/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build() {
        return {
            id: 0,
            score: 0,
            comment: '',
            isActive: false,
            demand: { id: 0 },
            person: { id: 0 }
        };
    },
    toForm: function toForm(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toForm(obj, this.build());
    },
    toPayload: function toPayload(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toPayload(obj);
    }
});
'filehash mVkw9hXXi2/aiQuFL8Bsr2Aq67k=';

/***/ }),

/***/ "VzEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[(!_vm.loading)?_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[(!_vm.form.isActive)?_c('v-alert',{staticClass:"mb-3",attrs:{"color":"error","icon":"error","value":"true"}},[_vm._v("\n                        "+_vm._s(_vm.$t('message.info.approverTypeInactive'))+"\n                    ")]):(_vm.form.isInUse)?_c('v-alert',{staticClass:"mb-3",attrs:{"color":"warning","icon":"warning","value":"true"}},[_vm._v("\n                        "+_vm._s(_vm.$t('message.info.approverTypeInUse'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.$t('title.approverType')))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.approverType'))}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.name'))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.text,"validate-on-blur":true,"counter":_vm.constants.LENGTH_TYPE_APPROVER_NAME,"maxlength":_vm.constants.LENGTH_TYPE_APPROVER_NAME},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1)],1),_vm._v(" "),(!_vm.disabled)?_c('v-card-actions',[_c('v-btn',{attrs:{"loading":_vm.saving,"disabled":_vm.removing,"color":"primary"},on:{"click":_vm.save}},[_vm._v("\n                        "+_vm._s(_vm.$t('label.save'))+"\n                    ")]),_vm._v(" "),(!!_vm.form.id)?_c('v-btn',{attrs:{"disabled":_vm.saving,"loading":_vm.removing,"color":"error"},on:{"click":_vm.remove}},[_vm._v("\n                        "+_vm._s(_vm.form.isInUse ? _vm.$t('label.inactivate') : _vm.$t('label.remove'))+"\n                    ")]):_vm._e()],1):_vm._e()],1):_c('v-card',[_c('app-card-loader')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W8j6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Creation_vue__ = __webpack_require__("lE98");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d865d56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Creation_vue__ = __webpack_require__("syma");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Creation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d865d56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Creation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WiLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");


/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build() {
        return {
            reference: '',
            contractId: 0,
            contractItemId: 0,
            systemId: 0
        };
    },
    toForm: function toForm(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toForm(obj, this.build());
    },
    toPayload: function toPayload(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toPayload(obj);
    }
});
'filehash p7od0AKKO69nxjewDdri8fndbqw=';

/***/ }),

/***/ "X3z0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.refresh},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'typeApproverEdit', params: { id: item.id }},"tag":"tr"}},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticClass:"is-active"},[_vm._v(_vm._s(item.status))])])]}}])},[(!_vm.readonly)?_c('template',{slot:"afterReloadButton"},[_c('v-btn',{attrs:{"to":{ name: 'typeApproverCreate' },"color":"primary"}},[_vm._v(_vm._s(_vm.$t('label.createTypeApprover')))])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XDC8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("flzs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2b1e672_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("ycSo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2b1e672_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XGL4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_download__ = __webpack_require__("mXcE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        file: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        removeable: {
            type: Boolean,
            required: false
        }
    },
    data: function data() {
        return {
            canRemove: this.removeable || false,
            progress: 0
        };
    },

    computed: {
        name: function name() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].splitFileNameExtension(this.file.fileName)[0];
        },
        extension: function extension() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].splitFileNameExtension(this.file.fileName)[1];
        },
        size: function size() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].numberToDataString(this.file.contentLength / 1024) + ' KB';
        },
        icon: function icon() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].mimeToFontAwesome(this.file.contentType);
        },
        color: function color() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].fontAwesomeFileIconToClass(this.icon);
        },
        identification: function identification() {
            return 'Arquivo ' + (this.index + 1);
        }
    },
    methods: {
        download: function download() {
            var file = this.file;

            if (!__WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].isEmptyOrZero(file.content)) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_download__["a" /* download */])(file.content, file.fileName, file.contentType);
            } else {
                var index = file.links.map(function (file) {
                    return file.rel;
                }).indexOf('download');
                var url = file.links[index].href;
                this.ajaxDownload(url, file.contentType, file.fileName);
                // download(null, file.fileName, file.contentType, url, this.callback);
            }
        },
        remove: function remove() {
            this.$emit('remove', this.file);
        },
        callback: function callback(evt) {
            var size = this.file.contentLength;

            this.progress = evt.loaded / size * 100;

            if (evt.loaded === size) this.progress = 0;
        },
        ajaxDownload: function ajaxDownload(url, type, name) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'arraybuffer';
            xhr.send();
            xhr.onprogress = this.callback;

            xhr.onload = function onload() {
                if (this.status === 200) {
                    var blob = new Blob([this.response], { type: type });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = name;
                    link.click();
                    link.remove();
                }
            };
        }
    }
});
'filehash XOI/zEcbUueYkc5wnHFg4gxdrAo=';

/***/ }),

/***/ "Y5KQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_constants__ = __webpack_require__("eHeZ");


var state = {
    event: {
        type: __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["a" /* default */].EVENT_INFO,
        message: '',
        display: false
    },

    apiEvent: {
        message: ''
    }
};

var mutations = {
    setApiEvent: function setApiEvent(state, message) {
        state.apiEvent.message = message;
    },
    setEvent: function setEvent(state, _ref) {
        var type = _ref.type,
            message = _ref.message;

        state.event.type = type;
        state.event.message = message;
        state.event.display = true;
    },
    hideEvent: function hideEvent(state) {
        state.event.display = false;
    }
};

var actions = {
    setApiEvent: function setApiEvent(_ref2, message) {
        var commit = _ref2.commit;

        commit('setApiEvent', message);
    },
    showInfo: function showInfo(_ref3, message) {
        var commit = _ref3.commit;

        var info = {
            type: __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["a" /* default */].EVENT_INFO,
            message: message
        };

        commit('setEvent', info);
    },
    showSuccess: function showSuccess(_ref4, message) {
        var commit = _ref4.commit;

        var info = {
            type: __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["a" /* default */].EVENT_SUCCESS,
            message: message
        };

        commit('setEvent', info);
    },
    showWarning: function showWarning(_ref5, message) {
        var commit = _ref5.commit;

        var info = {
            type: __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["a" /* default */].EVENT_WARNING,
            message: message
        };

        commit('setEvent', info);
    },
    showError: function showError(_ref6, message) {
        var commit = _ref6.commit;

        var info = {
            type: __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["a" /* default */].EVENT_ERROR,
            message: message
        };

        commit('setEvent', info);
    },
    hideEvent: function hideEvent(_ref7) {
        var commit = _ref7.commit;

        commit('hideEvent');
    }
};

var getters = {
    apiEvent: function apiEvent(state) {
        return state.apiEvent;
    },
    event: function event(state) {
        return state.event;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash M4b6EqrEGqlsV1IZ/djWf2vrnrc=';

/***/ }),

/***/ "Y900":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('p',{staticClass:"body-1 grey--text text--darken-1 mt-4"},[_vm._v("\n        "+_vm._s(_vm.$t("label.yourCancel"))+"\n    ")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"multi-line":"","auto-grow":"","counter":_vm.constants.LENGTH_COMMENTS,"maxlength":_vm.constants.LENGTH_COMMENTS},model:{value:(_vm.form.comments),callback:function ($$v) {_vm.$set(_vm.form, "comments", $$v)},expression:"form.comments"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.files.length > 0),expression:"form.files.length > 0"}],staticClass:"mt-3",attrs:{"row":""}},[_c('v-flex',[_c('app-files',{attrs:{"files":_vm.form.files,"removedFiles":_vm.form.removedFiles,"removeable":true},on:{"update:files":function($event){return _vm.$set(_vm.form, "files", $event)},"update:removedFiles":function($event){return _vm.$set(_vm.form, "removedFiles", $event)},"update:removed-files":function($event){return _vm.$set(_vm.form, "removedFiles", $event)}}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"success","loading":_vm.cancelling,"disabled":_vm.cancelling},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t("label.cancel")))]),_vm._v(" "),_c('app-file-upload',{attrs:{"disabled":_vm.cancelling,"model":_vm.form.files},on:{"update:model":function($event){return _vm.$set(_vm.form, "files", $event)}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","loading":_vm.cancelling,"disabled":_vm.cancelling},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t("label.close")))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YRnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__("mWYR");






var state = {
    systems: [],
    system: {}
};

var mutations = {
    setSystems: function setSystems(state, systems) {
        state.systems = systems;
    },
    setSystem: function setSystem(state, system) {
        state.system = system;
    }
};

var actions = {

    // CRUD
    fetchSystem: function fetchSystem(_ref, id) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].systems.fetch(id);

                        case 2:
                            response = _context.sent;

                            commit('setSystem', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    loadSystems: function loadSystems(_ref2) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].systems.list();

                        case 2:
                            response = _context2.sent;

                            commit('setSystems', response.data);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    removeSystem: function removeSystem(_ref3, form) {
        var _this3 = this;

        var dispatch = _ref3.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].systems.remove(form.id);

                        case 2:
                            _context3.next = 4;
                            return dispatch('loadSystems');

                        case 4:

                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.success.systemRemoved'));

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    saveSystem: function saveSystem(_ref4, form) {
        var _this4 = this;

        var dispatch = _ref4.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].systems.save(form);

                        case 2:
                            response = _context4.sent;
                            _context4.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].systems.approvers.save(response.data.id, form);

                        case 5:
                            _context4.next = 7;
                            return dispatch('fetchSystem', response.data.id);

                        case 7:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    saveOrUpdateSystem: function saveOrUpdateSystem(_ref5, form) {
        var _this5 = this;

        var dispatch = _ref5.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(form.id)) {
                                _context5.next = 5;
                                break;
                            }

                            _context5.next = 3;
                            return dispatch('saveSystem', form);

                        case 3:
                            _context5.next = 7;
                            break;

                        case 5:
                            _context5.next = 7;
                            return dispatch('updateSystem', form);

                        case 7:
                            _context5.next = 9;
                            return dispatch('loadSystems');

                        case 9:
                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.success.saved'));

                        case 10:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    updateSystem: function updateSystem(_ref6, form) {
        var _this6 = this;

        var dispatch = _ref6.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].systems.update(form.id, form);

                        case 2:
                            _context6.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].systems.approvers.save(form.id, form);

                        case 4:
                            _context6.next = 6;
                            return dispatch('fetchSystem', form.id);

                        case 6:
                            _context6.next = 8;
                            return dispatch('loadDemands');

                        case 8:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    }
};

var getters = {
    system: function system(state) {
        return state.system || {};
    },
    systems: function systems(state) {
        var systems = state.systems || [];
        return systems.sort(function (a, b) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].stringCompare(a.acronym, b.acronym);
        });
    },
    systemsValueText: function systemsValueText(_, getters) {
        return getters.systems.map(function (_ref7) {
            var id = _ref7.id,
                acronym = _ref7.acronym,
                name = _ref7.name;
            return { value: id, text: acronym + ' - ' + name };
        });
    },
    activeSystemsValueText: function activeSystemsValueText(_, getters) {
        return getters.systems.filter(function (a) {
            return a.isActive;
        }).map(function (_ref8) {
            var id = _ref8.id,
                acronym = _ref8.acronym,
                name = _ref8.name,
                contractItem = _ref8.contractItem;
            return { value: id, text: acronym + ' - ' + name, contractItemId: contractItem.id };
        });
    },
    systemsDictionary: function systemsDictionary(_, getters) {
        return getters.systems.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash +n6t9iPMP2joKkCkSyxEX/f0rLM=';

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_Header__ = __webpack_require__("9bIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_Body__ = __webpack_require__("soc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_login_Login__ = __webpack_require__("NaOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_login_ExpiredPassword__ = __webpack_require__("T6h/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dashboard_Index__ = __webpack_require__("6Tz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_Index__ = __webpack_require__("XDC8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_prodam_Index__ = __webpack_require__("JPEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_Server__ = __webpack_require__("SQEu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_demands_Edit__ = __webpack_require__("6ODB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_demands_Index__ = __webpack_require__("oDRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_demands_Report__ = __webpack_require__("ghUZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_contracts_Index__ = __webpack_require__("kcEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_contracts_Edit__ = __webpack_require__("kgKR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_contracts_UpdateContract__ = __webpack_require__("QOoL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_types_demand_Index__ = __webpack_require__("HCJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_types_demand_Edit__ = __webpack_require__("FBVM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_types_approver_Index__ = __webpack_require__("yCEk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_types_approver_Edit__ = __webpack_require__("UA8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_systems_Index__ = __webpack_require__("4kY7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_systems_Edit__ = __webpack_require__("VYPm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_persons_Index__ = __webpack_require__("Q/lz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_persons_Edit__ = __webpack_require__("g/BY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_demandOwnerSubstitutions_Index__ = __webpack_require__("FL3z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_demandOwnerSubstitutions_Edit__ = __webpack_require__("tL9a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_officesScore_Index__ = __webpack_require__("+/dO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_officesScore_EvaluatedDemands__ = __webpack_require__("85nN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_officesScore_EvaluatedDemandComments__ = __webpack_require__("N/EK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_offices_Index__ = __webpack_require__("H137");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_offices_Edit__ = __webpack_require__("v2O3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_areas_Index__ = __webpack_require__("tD7A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_areas_Edit__ = __webpack_require__("nNT6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_reports_DemandBilling__ = __webpack_require__("VYCi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_shared_HttpError__ = __webpack_require__("9bAG");




var _this = this;


















































__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

var defaultComponents = { default: __WEBPACK_IMPORTED_MODULE_7__components_shared_Body__["a" /* default */], header: __WEBPACK_IMPORTED_MODULE_6__components_shared_Header__["a" /* default */] };

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
    // Do not use history mode. Prodam's information security team
    // refuses to enable url rewrite in the server
    base: __webpack_require__.i({"NODE_ENV":"production","API_URL":"https://ngdsapi.prodam.sp.gov.br/api","API_URL_NOVA":"https://ngdsapicore.prodam.sp.gov.br/api"}).VUE_APP_ROUTE_BASE_URL,
    mode: "history",
    routes: [{
        path: "/login",
        components: { default: __WEBPACK_IMPORTED_MODULE_8__components_login_Login__["a" /* default */] },
        name: "login"
    }, {
        path: "/login",
        components: { default: __WEBPACK_IMPORTED_MODULE_8__components_login_Login__["a" /* default */] },
        name: "logout"
    }, {
        path: "/login/senhaExpirada",
        components: { default: __WEBPACK_IMPORTED_MODULE_9__components_login_ExpiredPassword__["a" /* default */] },
        name: "expiredPassword"
    }, {
        path: "/registrar/atualizar",
        components: { default: __WEBPACK_IMPORTED_MODULE_27__components_persons_Edit__["a" /* default */] },
        name: "firstLogin"
    }, {
        path: "/registrar/atualizar",
        components: { default: __WEBPACK_IMPORTED_MODULE_27__components_persons_Edit__["a" /* default */] },
        name: "profileUpdateRequired"
    }, {
        path: "/dashboard",
        components: { default: __WEBPACK_IMPORTED_MODULE_10__components_dashboard_Index__["a" /* default */], header: __WEBPACK_IMPORTED_MODULE_6__components_shared_Header__["a" /* default */] },
        name: "dashboard"
    }, {
        path: "/administracao",
        components: { default: __WEBPACK_IMPORTED_MODULE_11__components_admin_Index__["a" /* default */], header: __WEBPACK_IMPORTED_MODULE_6__components_shared_Header__["a" /* default */] },
        name: "admin"
    }, {
        path: "/prodam",
        components: { default: __WEBPACK_IMPORTED_MODULE_12__components_prodam_Index__["a" /* default */], header: __WEBPACK_IMPORTED_MODULE_6__components_shared_Header__["a" /* default */] },
        name: "prodam"
    }, {
        path: "/reports",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_37__components_reports_DemandBilling__["a" /* default */],
            name: "demandBillingReport"
        }]
    }, {
        path: "/serverData",
        components: { default: __WEBPACK_IMPORTED_MODULE_13__components_admin_Server__["a" /* default */], header: __WEBPACK_IMPORTED_MODULE_6__components_shared_Header__["a" /* default */] },
        name: "serverData"
    }, {
        path: "/areas",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_35__components_areas_Index__["a" /* default */],
            name: "areaIndex"
        }, {
            path: "nova",
            component: __WEBPACK_IMPORTED_MODULE_36__components_areas_Edit__["a" /* default */],
            name: "areaCreate"
        }, {
            path: ":id",
            component: __WEBPACK_IMPORTED_MODULE_36__components_areas_Edit__["a" /* default */],
            name: "areaEdit"
        }]
    }, {
        path: "/contratos",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_17__components_contracts_Index__["a" /* default */],
            name: "contractIndex"
        }, {
            path: "novo",
            component: __WEBPACK_IMPORTED_MODULE_18__components_contracts_Edit__["a" /* default */],
            name: "contractCreate"
        }, {
            path: ":id",
            component: __WEBPACK_IMPORTED_MODULE_18__components_contracts_Edit__["a" /* default */],
            name: "contractEdit"
        }, {
            path: "novo/:id",
            component: __WEBPACK_IMPORTED_MODULE_18__components_contracts_Edit__["a" /* default */],
            name: "contractCopy"
        }, {
            path: "atualizar/:id",
            component: __WEBPACK_IMPORTED_MODULE_19__components_contracts_UpdateContract__["a" /* default */],
            name: "contractUpdate"
        }]
    }, {
        path: "/demandas",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_15__components_demands_Index__["a" /* default */],
            name: "demandIndex"
        }, {
            path: "relatorio",
            component: __WEBPACK_IMPORTED_MODULE_16__components_demands_Report__["a" /* default */],
            name: "demandReport"
        }, {
            path: "nova",
            component: __WEBPACK_IMPORTED_MODULE_14__components_demands_Edit__["a" /* default */],
            name: "demandCreate"
        }, {
            path: ":id",
            component: __WEBPACK_IMPORTED_MODULE_14__components_demands_Edit__["a" /* default */],
            name: "demandEdit"
        }]
    }, {
        path: "/secretarias",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_33__components_offices_Index__["a" /* default */],
            name: "officeIndex"
        }, {
            path: "nova",
            component: __WEBPACK_IMPORTED_MODULE_34__components_offices_Edit__["a" /* default */],
            name: "officeCreate"
        }, {
            path: ":id",
            component: __WEBPACK_IMPORTED_MODULE_34__components_offices_Edit__["a" /* default */],
            name: "officeEdit"
        }]
    }, {
        path: "/avaliacao-secretarias",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_30__components_officesScore_Index__["a" /* default */],
            name: "officeScoreIndex"
        }, {
            path: ":officeId",
            component: __WEBPACK_IMPORTED_MODULE_31__components_officesScore_EvaluatedDemands__["a" /* default */],
            name: "officeEvaluatedDemands"
        }, {
            path: "evaluatedDemandComments/:demandId",
            component: __WEBPACK_IMPORTED_MODULE_32__components_officesScore_EvaluatedDemandComments__["a" /* default */],
            name: "officeEvaluatedDemandComments"
        }]
    }, {
        path: "/tipo-aprovador",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_22__components_types_approver_Index__["a" /* default */],
            name: "typeApproverIndex"
        }, {
            path: "novo",
            component: __WEBPACK_IMPORTED_MODULE_23__components_types_approver_Edit__["a" /* default */],
            name: "typeApproverCreate"
        }, {
            path: ":id",
            component: __WEBPACK_IMPORTED_MODULE_23__components_types_approver_Edit__["a" /* default */],
            name: "typeApproverEdit"
        }]
    }, {
        path: "/tipo-demanda",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_20__components_types_demand_Index__["a" /* default */],
            name: "typeDemandIndex"
        }, {
            path: "novo",
            component: __WEBPACK_IMPORTED_MODULE_21__components_types_demand_Edit__["a" /* default */],
            name: "typeDemandCreate"
        }, {
            path: ":id",
            component: __WEBPACK_IMPORTED_MODULE_21__components_types_demand_Edit__["a" /* default */],
            name: "typeDemandEdit"
        }]
    }, {
        path: "/sistemas",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_24__components_systems_Index__["a" /* default */],
            name: "systemIndex"
        }, {
            path: "nova",
            component: __WEBPACK_IMPORTED_MODULE_25__components_systems_Edit__["a" /* default */],
            name: "systemCreate"
        }, {
            path: ":id",
            component: __WEBPACK_IMPORTED_MODULE_25__components_systems_Edit__["a" /* default */],
            name: "systemEdit"
        }]
    }, {
        path: "/usuarios",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_26__components_persons_Index__["a" /* default */],
            name: "personIndex"
        }, {
            path: "nova",
            component: __WEBPACK_IMPORTED_MODULE_27__components_persons_Edit__["a" /* default */],
            name: "personCreate"
        }, {
            path: ":id",
            component: __WEBPACK_IMPORTED_MODULE_27__components_persons_Edit__["a" /* default */],
            name: "personEdit"
        }]
    }, {
        path: "/substituicoes",
        components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultComponents),
        children: [{
            path: "",
            component: __WEBPACK_IMPORTED_MODULE_28__components_demandOwnerSubstitutions_Index__["a" /* default */],
            name: "demandOwnerSubstitutionIndex"
        }, {
            path: "nova",
            component: __WEBPACK_IMPORTED_MODULE_29__components_demandOwnerSubstitutions_Edit__["a" /* default */],
            name: "demandOwnerSubstitutionCreate"
        }, {
            path: ":id",
            component: __WEBPACK_IMPORTED_MODULE_29__components_demandOwnerSubstitutions_Edit__["a" /* default */],
            name: "demandOwnerSubstitutionEdit"
        }]
    },
    // Errors
    {
        path: "/erro/:id",
        components: { default: __WEBPACK_IMPORTED_MODULE_38__components_shared_HttpError__["a" /* default */] },
        name: "httpError"
    },

    // Redirection
    {
        path: "*",
        redirect: { name: "dashboard" }
    }],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        if (to.hash) {
            return { selector: to.hash };
        }

        return { x: 0, y: 0 };
    }
});

router.beforeEach(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
        var person, _person;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(to.name === "httpError" || to.name === "expiredPassword")) {
                            _context.next = 3;
                            break;
                        }

                        next();
                        return _context.abrupt("return");

                    case 3:
                        if (!(to.name === "login" || to.name === "logout")) {
                            _context.next = 7;
                            break;
                        }

                        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch("logout");
                        next();
                        return _context.abrupt("return");

                    case 7:
                        if (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.isLoggedIn) {
                            _context.next = 10;
                            break;
                        }

                        next({ name: "login" });
                        return _context.abrupt("return");

                    case 10:
                        if (!__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.isStoreEmpty) {
                            _context.next = 13;
                            break;
                        }

                        _context.next = 13;
                        return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch("initialize");

                    case 13:
                        if (!(to.name !== "firstLogin" && __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.isFirstLogin)) {
                            _context.next = 17;
                            break;
                        }

                        person = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.profile.person;

                        next({ name: "firstLogin", params: { id: person.id } });
                        return _context.abrupt("return");

                    case 17:
                        if (!(to.name !== "profileUpdateRequired" && __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.isPersonUpdateRequired)) {
                            _context.next = 21;
                            break;
                        }

                        _person = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.profile.person;

                        next({ name: "profileUpdateRequired", params: { id: _person.id } });
                        return _context.abrupt("return");

                    case 21:

                        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch("setRoute", { to: to, from: from });
                        next();

                    case 23:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}());

/* harmony default export */ __webpack_exports__["a"] = (router);
"filehash d214hxqD2sV0Ep4gqNfEF74zeCQ=";

/***/ }),

/***/ "Yjch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_entities_Person__ = __webpack_require__("rTIS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_CardLoader__ = __webpack_require__("JqcZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_MenuDatePicker__ = __webpack_require__("Z1KI");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this;

        return {
            constants: __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_5__helpers_validation__["a" /* default */],
            valid: true,
            saving: false,
            loading: true,

            offices: this.$store.getters.officesValueText,
            //  areas: this.$store.getters.areasValueText,

            profile: this.$store.getters.profile,
            isFirstLogin: this.$store.getters.isFirstLogin,
            isUpdateRequired: this.$store.getters.isPersonUpdateRequired,

            form: __WEBPACK_IMPORTED_MODULE_6__helpers_entities_Person__["a" /* default */].build(),
            substitutionTermFinishRule: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__helpers_validation__["a" /* default */].required), [function () {
                return _this.form.substitutionTerm.finish >= _this.form.substitutionTerm.start || _this.$t('message.error.period');
            }]),
            outsourcedAdminRule: [function () {
                return !(_this.form.isOutsourced && _this.form.isAdmin) || _this.$t('message.error.outsourcedAdmin');
            }]
        };
    },

    computed: {
        isAdmin: function isAdmin() {
            var ok = this.$store.getters.isAdmin || this.$store.getters.profile.isRoot;
            return ok;
        },
        isRoot: function isRoot() {
            var ok = this.$store.getters.profile.isRoot;
            return ok;
        },
        canSetAdmin: function canSetAdmin() {
            if (__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(this.form.id)) return false;
            var ok = this.isAdmin && this.$store.getters.profile.person.id !== this.form.id && this.$store.getters.profile.office === this.form.office.id || this.isRoot;
            return ok;
        },
        areas: function areas() {
            var _this2 = this;

            var office = this.form.office.id;
            var temp = this.$store.getters.areas.filter(function (v) {
                return v.office.id === office && v.isActive;
            });

            if (this.form.isOutsourced) {
                temp = temp.filter(function (v) {
                    return v.isOutsourced === _this2.form.isOutsourced;
                });
            } else {
                temp = temp.filter(function (v) {
                    return !v.isOutsourced;
                });
            }

            return temp.map(function (_ref) {
                var id = _ref.id,
                    acronym = _ref.acronym,
                    name = _ref.name;
                return { value: id, text: acronym + ' - ' + name };
            });
        },
        disabled: function disabled() {
            if (__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(this.form.id)) return false;

            if (this.$store.getters.isAdmin || this.$store.getters.profile.isRoot) return false;

            return this.profile.person.id !== this.form.id;
        },
        hasSubstitute: function hasSubstitute() {
            return !__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(this.form.substitute.id);
        },
        isSubstitute: function isSubstitute() {
            return !__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(this.form.substitutes);
        },
        name: function name() {
            if (this.isFirstLogin) return this.profile.name;

            return this.form.name;
        },
        user: function user() {
            if (this.isFirstLogin) return this.profile.login;

            return this.form.username;
        },
        persons: function persons() {
            var _this3 = this;

            var persons = [];
            if (this.form.isHired) {
                this.form.office.id = 0;
                this.form.area.id = 0;
                persons = this.$store.getters.personsHired;
            } else {
                persons = this.$store.getters.personsNotHired;
            }

            if (this.form.office.id > 0) {
                persons = persons.filter(function (person) {
                    return person.office && person.office.id === _this3.form.office.id;
                });
            }

            if (this.form.isOutsourced) {
                persons = persons.filter(function (person) {
                    return person.area && person.area.id === _this3.form.area.id;
                });
            }
            persons = persons.filter(function (person) {
                return person.isActive;
            }).map(function (_ref2) {
                var id = _ref2.id,
                    username = _ref2.username,
                    name = _ref2.name;
                return {
                    value: id,
                    text: username + ' - ' + name
                };
            });
            return persons.filter(function (i) {
                return _this3.form.id !== i.value;
            });
        },
        outsourced: function outsourced() {
            // if (this.isFirstLogin && !utilities.isEmptyOrZero(this.profile.area.id)) return true;

            return false;
        }
    },

    components: {
        appCardLoader: __WEBPACK_IMPORTED_MODULE_7__components_shared_CardLoader__["a" /* default */],
        appMenuDatePicker: __WEBPACK_IMPORTED_MODULE_8__components_shared_MenuDatePicker__["a" /* default */]
    },

    watch: {
        $route: 'fetch'
    },

    created: function created() {
        this.fetch();
    },


    methods: {
        clearSubstitute: function clearSubstitute() {
            this.form.substitute = { id: null };
            this.form.substitutionTerm.start = null;
            this.form.substitutionTerm.finish = null;
        },
        onChangeSecArea: function onChangeSecArea() {
            this.clearSubstitute();
        },
        fetch: function fetch() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this4.loading = true;

                                if (__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(_this4.$route.params.id)) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 4;
                                return _this4.$store.dispatch('fetchPerson', _this4.$route.params.id);

                            case 4:
                                _this4.form = __WEBPACK_IMPORTED_MODULE_6__helpers_entities_Person__["a" /* default */].toForm(_this4.$store.getters.person);

                            case 5:

                                _this4.loading = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        save: function save() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this5.$refs.form.validate()) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _context2.prev = 2;

                                _this5.saving = true;

                                _this5.form.isUpdateRequired = false;

                                _context2.next = 7;
                                return _this5.$store.dispatch('saveOrUpdatePerson', __WEBPACK_IMPORTED_MODULE_6__helpers_entities_Person__["a" /* default */].toPayload(_this5.form));

                            case 7:

                                _this5.$router.push({ name: 'personIndex' });

                                _context2.next = 17;
                                break;

                            case 10:
                                _context2.prev = 10;
                                _context2.t0 = _context2['catch'](2);

                                if (!(_context2.t0.data && _context2.t0.data.code === "generic_error")) {
                                    _context2.next = 16;
                                    break;
                                }

                                _this5.saving = false;
                                _context2.next = 17;
                                break;

                            case 16:
                                throw _context2.t0;

                            case 17:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this5, [[2, 10]]);
            }))();
        },
        switchUser: function switchUser() {
            this.$router.push({ name: 'login' });
        }
    }
});
'filehash hURYGcVQBjSEamq8vclB+TR3R+o=';

/***/ }),

/***/ "Z1KI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuDatePicker_vue__ = __webpack_require__("2s8T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e6cf3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuDatePicker_vue__ = __webpack_require__("BmfM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuDatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e6cf3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuDatePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZQnL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__ = __webpack_require__("HUpA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import constants from '@/helpers/constants';



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            headers: [{
                text: this.$t('label.name'),
                value: 'name',
                align: 'left',
                sortable: false
            }, {
                text: this.$t('label.active') + '?',
                value: 'status',
                align: 'left'
            }]
        };
    },


    computed: {
        approverTypes: function approverTypes() {
            var _this = this;

            var types = this.$store.getters.approverTypes.filter(function (item) {
                return item.name !== 'SOLICITANTE';
            });
            types.forEach(function (type) {
                type.status = type.isActive ? _this.$t('label.yes') : _this.$t('label.no');
            });
            return types;
        },
        readonly: function readonly() {
            return !this.$store.getters.isAdmin;
        }
    },

    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__["a" /* default */]
    },

    methods: {
        search: function search(filters) {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(this.approverTypes, filters, function (type, regex) {
                return regex.test(type.name) || regex.test(type.status);
            });
        },
        refresh: function refresh() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadApproverTypes');

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    }
});
'filehash 0M1SvA88ERfYsSIKyuNS509bu3Q=';

/***/ }),

/***/ "ZdAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopupModal_vue__ = __webpack_require__("lBgK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5bc1038_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopupModal_vue__ = __webpack_require__("VG0+");
function injectStyle (ssrContext) {
  __webpack_require__("R1FV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5bc1038"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopupModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5bc1038_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopupModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZgPi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_CardLoader__ = __webpack_require__("JqcZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_SercheableDataTable__ = __webpack_require__("HUpA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pagination: {
                descending: true,
                sortBy: "code"
            },
            headers: [{
                text: this.$t("label.code"),
                value: "code",
                align: "left"
            }, {
                text: this.$t("label.system"),
                value: "system.acronym",
                align: "left"
            }, {
                text: this.$t("label.status"),
                value: "status.id",
                align: "left"
            }, {
                text: this.$t("label.owner"),
                value: "owner.name",
                align: "left"
            }, {
                text: this.$t("label.name"),
                value: "title",
                align: "left"
            }],
            loading: false,
            placeholder: this.$t("message.info.demandSearch")
        };
    },


    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_4__shared_SercheableDataTable__["a" /* default */],
        appCardLoader: __WEBPACK_IMPORTED_MODULE_3__components_shared_CardLoader__["a" /* default */]
    },

    methods: {
        search: function search(filters) {
            var demands = this.$store.getters.demandsGrid;

            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(demands, filters, function (demand, regex) {
                return regex.test(demand.code.toString()) || regex.test(demand.system.acronym) || regex.test(demand.status.name) || regex.test(demand.owner.name) || regex.test(demand.title);
            });
        },
        refresh: function refresh() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;
                                _context.next = 3;
                                return _this.$store.dispatch("loadDemandsGrid");

                            case 3:
                                _this.loading = false;

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    beforeMount: function beforeMount() {
        this.refresh();
    }
});
"filehash 7mqOhkh43oUJ7lsSpwwO5LV6agc=";

/***/ }),

/***/ "aGO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["dateToShortString"] = dateToShortString;
/* harmony export (immutable) */ __webpack_exports__["dateToLongString"] = dateToLongString;
/* harmony export (immutable) */ __webpack_exports__["personToString"] = personToString;
/* harmony export (immutable) */ __webpack_exports__["areaToString"] = areaToString;
/* harmony export (immutable) */ __webpack_exports__["shortenedDescription"] = shortenedDescription;
/* harmony export (immutable) */ __webpack_exports__["demandOwner"] = demandOwner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_constants__ = __webpack_require__("eHeZ");



function dateToShortString(value) {
    if (__WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].isEmpty(value)) return value;

    var date = typeof value === 'string' ? new Date(value) : value;

    return date.toLocaleDateString('pt-BR');
}

function dateToLongString(value) {
    if (__WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].isEmpty(value)) return value;

    var date = typeof value === 'string' ? new Date(value) : value;

    return date.toLocaleString('pt-BR');
}

function personToString(value) {
    if (__WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].isEmpty(value)) return '-';

    var name = value.name;
    var username = value.username;
    return username + ' - ' + name;
}

function areaToString(value) {
    if (__WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].isEmpty(value)) return '-';

    return value.acronym;
}

function shortenedDescription(text) {
    if (text.length < 90) return text;

    return text.substring(0, 90) + '...';
}

function demandOwner(demand) {
    return demand.status.id < __WEBPACK_IMPORTED_MODULE_1__helpers_constants__["a" /* default */].STATUS_REJECTED ? demand.owner.name : '';
}
'filehash fV5mmFEXohUQLv2O+ogWVuQQWz0=';

/***/ }),

/***/ "ayfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticStyle:{"margin-left":"7.3em","margin-right":"7.2em","text-align":"center"}},[_c('app-card-loader')],1),_vm._v(" "),(!_vm.loading)?_c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.refresh,"pagination":_vm.pagination,"placeholder":_vm.placeholder},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'demandEdit', params: { id: item.id } },"tag":"tr"}},[_c('v-tooltip',{staticClass:"demand-code",attrs:{"bottom":"","tag":"td"}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.type.name)+" -\n                            "+_vm._s(item.type.description))])]),_vm._v(" "),_c('v-tooltip',{staticClass:"system-acronym",attrs:{"bottom":"","tag":"td"}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(item.system.acronym))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.type.name)+" -\n                            "+_vm._s(item.type.description))])]),_vm._v(" "),_c('v-tooltip',{staticClass:"situation-name",attrs:{"bottom":"","tag":"td"}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(item.status.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.type.name)+" -\n                            "+_vm._s(item.type.description))])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":"","tag":"td"}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm._f("demandOwner")(item)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.type.name)+" -\n                            "+_vm._s(item.type.description))])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":"","tag":"td"}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.type.name)+" -\n                            "+_vm._s(item.type.description))])])],1)]}}],null,false,3170220005)},[_c('template',{slot:"beforeReloadButton"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"slot":"activator","icon":"","to":{ name: 'demandReport' }},slot:"activator"},[_c('v-icon',[_vm._v("filter_list")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("tooltip.allFilters")))])],1)],1),_vm._v(" "),_c('template',{slot:"afterReloadButton"},[_c('v-btn',{attrs:{"to":{ name: 'demandCreate' },"color":"primary"}},[_vm._v(_vm._s(_vm.$t("label.createDemand")))])],1)],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bJnY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bcNN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            loading: true
        };
    },

    computed: {
        demand: function demand() {
            return this.$store.getters.demandComments;
        }
    },
    methods: {
        getDemandComments: function getDemandComments() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var id;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;
                                id = _this.$route.params.demandId;

                                if (__WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].isEmptyOrZero(id)) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 5;
                                return _this.$store.dispatch("loadDemandComments", id);

                            case 5:
                                _this.loading = false;

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    beforeMount: function beforeMount() {
        this.getDemandComments();
    }
});
"filehash kjJlkOJyXHJo2ajFHXNUPgYoNm4=";

/***/ }),

/***/ "cCCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");


/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build() {
        return {
            name: '',
            isInUse: false,
            isActive: true,
            officeId: 0
        };
    },
    toForm: function toForm(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toForm(obj, this.build());
    },
    toPayload: function toPayload(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toPayload(obj);
    }
});
'filehash XhBgq06L3eCD61HS99Unncj7pYg=';

/***/ }),

/***/ "cTAj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/demand-owner-substitutions');
    },
    fetch: function fetch(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/demand-owner-substitutions/' + id);
    },
    remove: function remove(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete('/demand-owner-substitutions/' + id);
    },
    save: function save(form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/demand-owner-substitutions', form);
    },
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/demand-owner-substitutions/' + id, form);
    }
});
'filehash OIbxpUzARR6wI0zryYghRZCM8EU=';

/***/ }),

/***/ "dNod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_CardLoader__ = __webpack_require__("JqcZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_entities_ApproverType__ = __webpack_require__("cCCq");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_4__helpers_validation__["a" /* default */],
            removing: false,
            saving: false,
            loading: true,

            form: __WEBPACK_IMPORTED_MODULE_6__helpers_entities_ApproverType__["a" /* default */].build()
        };
    },


    computed: {
        disabled: function disabled() {
            return !this.$store.getters.isAdmin || !this.form.isActive;
        }
    },

    components: {
        appCardLoader: __WEBPACK_IMPORTED_MODULE_5__components_shared_CardLoader__["a" /* default */]
    },

    watch: {
        $route: 'fetch'
    },

    created: function created() {
        this.fetch();
    },


    methods: {
        fetch: function fetch() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;

                                if (__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(_this.$route.params.id)) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 4;
                                return _this.$store.dispatch('fetchApproverType', _this.$route.params.id);

                            case 4:
                                _this.form = __WEBPACK_IMPORTED_MODULE_6__helpers_entities_ApproverType__["a" /* default */].toForm(_this.$store.getters.approverType);

                            case 5:

                                _this.loading = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        remove: function remove() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.removing = true;
                                _context2.next = 3;
                                return _this2.$store.dispatch('removeApproverType', _this2.form);

                            case 3:
                                _this2.$router.push({ name: 'typeApproverIndex' });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        save: function save() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (_this3.$refs.form.validate()) {
                                    _context3.next = 2;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 2:

                                _this3.saving = true;
                                _context3.next = 5;
                                return _this3.$store.dispatch('saveOrUpdateApproverType', __WEBPACK_IMPORTED_MODULE_6__helpers_entities_ApproverType__["a" /* default */].toPayload(_this3.form));

                            case 5:
                                _this3.$router.push({ name: 'typeApproverIndex' });

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    }
});
'filehash 7QG9Mg3CJ/uNkydkxNChf2m0GDc=';

/***/ }),

/***/ "dQ2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[(!_vm.loading)?_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.$t('label.basicInfo')))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.acronym')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg5":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"maxlength":_vm.constants.LENGTH_SYSTEM_ACRONYM},model:{value:(_vm.form.acronym),callback:function ($$v) {_vm.$set(_vm.form, "acronym", $$v)},expression:"form.acronym"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.name')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg5":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.text},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.office'))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg6":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled || _vm.defaultOffice,"items":_vm.offices,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.office.id),callback:function ($$v) {_vm.$set(_vm.form.office, "id", $$v)},expression:"form.office.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.isOutsourced'))+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.disabled,"color":"primary"},model:{value:(_vm.form.isOutsourced),callback:function ($$v) {_vm.$set(_vm.form, "isOutsourced", $$v)},expression:"form.isOutsourced"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.active'))+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.disabled,"color":"primary"},model:{value:(_vm.form.isActive),callback:function ($$v) {_vm.$set(_vm.form, "isActive", $$v)},expression:"form.isActive"}})],1)],1)],1),_vm._v(" "),(!_vm.disabled)?_c('v-card-actions',[_c('v-btn',{attrs:{"loading":_vm.saving,"color":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('label.save')))]),_vm._v(" "),_c('v-spacer')],1):_vm._e()],1):_c('v-card',[_c('app-card-loader')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dZeg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_filters__ = __webpack_require__("aGO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_Files__ = __webpack_require__("AUsU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        dateApproved: function dateApproved() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_filters__["dateToLongString"])(this.item.dateApproved);
        },
        dateLabel: function dateLabel() {
            if (this.item.event.id === __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["a" /* default */].EVENT_APPROVED) return this.$t('label.dateApproved');

            return this.$t('label.dateRejected');
        }
    },
    components: {
        appFiles: __WEBPACK_IMPORTED_MODULE_2__components_shared_Files__["a" /* default */]
    }
});
'filehash qscuwMKXncx2Lyvzp2iG4aObk1o=';

/***/ }),

/***/ "dmPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.refresh,"pagination":_vm.pagination},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'areaEdit', params: { id: item.id }},"tag":"tr"}},[_c('td',[_vm._v(_vm._s(item.office.acronym))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.acronym))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticClass:"is-active"},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('td',{staticClass:"is-active"},[_vm._v(_vm._s(item.outsourced))])])]}}])},[(!_vm.readonly)?_c('template',{slot:"afterReloadButton"},[_c('v-btn',{attrs:{"to":{ name: 'areaCreate' },"color":"primary"}},[_vm._v(_vm._s(_vm.$t('label.createArea')))])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eAGK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[(!_vm.loading)?_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.$t('label.basicInfo')))]),_vm._v(" "),(_vm.isAdmin)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.requestPersonUpdate'))+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(_vm.form.isUpdateRequired),callback:function ($$v) {_vm.$set(_vm.form, "isUpdateRequired", $$v)},expression:"form.isUpdateRequired"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.isFirstLogin)?_c('p',[_vm._v(_vm._s(_vm.$t('message.info.personFirstLogin'))+".")]):_vm._e(),_vm._v(" "),(_vm.isUpdateRequired)?_c('p',[_vm._v(_vm._s(_vm.$t('message.info.personUpdateRequired'))+".")]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.name')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg5":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.name))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.user')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg5":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.user))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.email'))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg7":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.requiredEmail,"validate-on-blur":true,"counter":_vm.constants.LENGTH_EMAIL,"maxlength":_vm.constants.LENGTH_EMAIL},model:{value:(_vm.form.emailAddress),callback:function ($$v) {_vm.$set(_vm.form, "emailAddress", $$v)},expression:"form.emailAddress"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.hired'))+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-checkbox',{attrs:{"disabled":!_vm.isRoot,"color":"primary"},model:{value:(_vm.form.isHired),callback:function ($$v) {_vm.$set(_vm.form, "isHired", $$v)},expression:"form.isHired"}})],1)],1),_vm._v(" "),(_vm.isAdmin)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.isAdmin'))+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.disabled || !_vm.canSetAdmin,"color":"primary"},model:{value:(_vm.form.isAdmin),callback:function ($$v) {_vm.$set(_vm.form, "isAdmin", $$v)},expression:"form.isAdmin"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.isOutsourced'))+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.disabled || (!_vm.isAdmin && !_vm.isFirstLogin) || _vm.form.isHired,"color":"primary","rules":_vm.outsourcedAdminRule},model:{value:(_vm.form.isOutsourced),callback:function ($$v) {_vm.$set(_vm.form, "isOutsourced", $$v)},expression:"form.isOutsourced"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.active'))+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.disabled || !_vm.canSetAdmin,"color":"primary"},model:{value:(_vm.form.isActive),callback:function ($$v) {_vm.$set(_vm.form, "isActive", $$v)},expression:"form.isActive"}})],1)],1),_vm._v(" "),(!_vm.form.isHired)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.office'))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg6":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled || _vm.outsourced || _vm.form.isHired,"items":_vm.offices,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},on:{"change":_vm.onChangeSecArea},model:{value:(_vm.form.office.id),callback:function ($$v) {_vm.$set(_vm.form.office, "id", $$v)},expression:"form.office.id"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.form.isHired)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.area'))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled || _vm.outsourced || _vm.form.isHired,"items":_vm.areas,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},on:{"change":_vm.onChangeSecArea},model:{value:(_vm.form.area.id),callback:function ($$v) {_vm.$set(_vm.form.area, "id", $$v)},expression:"form.area.id"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.isFirstLogin && !_vm.isSubstitute)?_c('div',[_c('div',{staticClass:"subheading mt-3"},[_vm._v(_vm._s(_vm.$t('label.substitute')))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.substitute'))}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.person')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled,"items":_vm.persons,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.substitute.id),callback:function ($$v) {_vm.$set(_vm.form.substitute, "id", $$v)},expression:"form.substitute.id"}})],1)],1),_vm._v(" "),(_vm.hasSubstitute)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.startDate')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('app-menu-date-picker',{attrs:{"disabled":_vm.disabled,"model":_vm.form.substitutionTerm.start,"rules":_vm.validation.required},on:{"update:model":function($event){return _vm.$set(_vm.form.substitutionTerm, "start", $event)}}})],1)],1):_vm._e(),_vm._v(" "),(_vm.hasSubstitute)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.endDate')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('app-menu-date-picker',{attrs:{"disabled":_vm.disabled,"model":_vm.form.substitutionTerm.finish,"rules":_vm.substitutionTermFinishRule},on:{"update:model":function($event){return _vm.$set(_vm.form.substitutionTerm, "finish", $event)}}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.isFirstLogin && _vm.isSubstitute)?_c('div',[_c('div',{staticClass:"subheading mt-3"},[_vm._v(_vm._s(_vm.$t('label.substitutes')))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.substitutes'))}}),_vm._v(" "),_vm._l((_vm.form.substitutes),function(person){return _c('v-layout',{key:person.id,staticClass:"row--short",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(person.username))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(person.name))])])],1)})],2):_vm._e()],1),_vm._v(" "),(!_vm.disabled)?_c('v-card-actions',[_c('v-btn',{attrs:{"loading":_vm.saving,"color":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('label.save')))]),_vm._v(" "),(_vm.isFirstLogin || _vm.isUpdateRequired)?_c('v-btn',{attrs:{"disabled":_vm.saving,"color":"primary"},on:{"click":_vm.switchUser}},[_vm._v(_vm._s(_vm.$t('label.switchUser'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.isFirstLogin && !_vm.isSubstitute)?_c('v-btn',{attrs:{"disabled":_vm.saving,"color":"secondary"},on:{"click":_vm.clearSubstitute}},[_vm._v(_vm._s(_vm.$t('label.clearSubstitute'))+"\n                    ")]):_vm._e()],1):_vm._e()],1):_c('v-card',[_c('app-card-loader')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eHeZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

    componentOptions: {
        rowsPerPageItems: [25, 50, 100, 250]
    },

    STORE_EMPTY: 0,
    STORE_INITIALIZING: 1,
    STORE_READY: 2,

    EVENT_INFO: 0,
    EVENT_SUCCESS: 1,
    EVENT_WARNING: 2,
    EVENT_ERROR: 3,

    LENGTH_COMMENTS: 1000,
    LENGTH_CONTRACT: 9,
    LENGTH_CONTRACT_DESCRIPTION: 40,
    LENGTH_CONTRACT_OBJECT: 500,
    LENGTH_CONTRACT_WARRANTY: 5,
    LENGTH_CONTRACT_UNIT_VALUE: 10,
    LENGTH_CONTRACT_HIRED_AMOUNT: 10,
    LENGTH_CONTRACT_MEASURE_UNIT: 10,
    LENGTH_CONTRACT_ITEM: 40,
    LENGTH_CONTRACT_ITEM_QUANTITY: 9,
    LENGTH_DEMAND: 6,
    LENGTH_DEMAND_CODE: 10,
    LENGTH_DESCRIPTION: 1000,
    LENGTH_DAYS_TO_DELIVERY: 10,
    LENGTH_EMAIL: 60,
    LENGTH_ESTIMATED_TIME: 10,
    LENGTH_EXECUTED_TIME: 10,
    LENGTH_FILES_DESCRIPTION: 1000,
    LENGTH_REASON: 1000,
    LENGTH_BILLING_REFERENCE: 6,
    LENGTH_OUTCOME: 1000,
    LENGTH_PLANNED_TIME: 10,
    LENGTH_REMARKS: 1000,
    LENGTH_SIMILAR_DEMANDS: 100,
    LENGTH_SYSTEM_ACRONYM: 8,
    LENGTH_SYSTEM_NAME: 100,
    LENGTH_SYSTEM_DESCRIPTION: 300,
    LENGTH_TITLE: 100,
    LENGTH_TYPE_APPROVER_NAME: 50,
    LENGTH_TYPE_DEMAND_NAME: 60,
    LENGTH_TYPE_DEMAND_DESCRIPTION: 500,
    LENGTH_UNIT: 20,

    ROLES_ADMIN: 'ngds/admin',
    ROLES_EDIT_SYSTEM: 'ngds/admin', // 'ngds/sistema_cadastro',
    ROLES_EDIT_CONTRACT: 'ngds/admin', // 'ngds/contrato_cadastro',
    ROLES_EDIT_APPROVER_TYPE: 'ngds/admin', // 'ngds/tipo_aprovador_cadastro',
    ROLES_EDIT_DEMAND_TYPE: 'ngds/admin', // 'ngds/tipo_demanda_cadastro',
    ROLES_EDIT_PERSON: 'ngds/admin', // 'ngds/pessoa_cadastro',

    STATUS_ANY: 0,
    STATUS_CREATED: 1,
    STATUS_CREATED_APPROVAL: 2,
    STATUS_PLANNING: 3,
    STATUS_PLANNING_APPROVAL: 4,
    STATUS_DELIVERY: 5,
    STATUS_DELIVERY_APPROVAL: 6,
    STATUS_FINALIZING: 7,
    STATUS_REJECTED: 8,
    STATUS_DONE: 9,

    EVENT_APPROVED: 1,
    EVENT_REJECTED: 100
});
'filehash m7eSNfPBkhTEsLuXXC/BWKQQ7po=';

/***/ }),

/***/ "ebpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__ = __webpack_require__("ml+B");






var state = {
    offices: [],
    scoreOffices: [],
    office: {}
};

var mutations = {
    setOffices: function setOffices(state, offices) {
        state.offices = offices;
    },
    setScoreOffices: function setScoreOffices(state, scoreOffices) {
        state.scoreOffices = scoreOffices;
    },
    setOffice: function setOffice(state, office) {
        state.office = office;
    }
};

var actions = {
    loadOffices: function loadOffices(_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].offices.list();

                        case 2:
                            response = _context.sent;

                            commit('setOffices', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    getEvaluateOffices: function getEvaluateOffices(_ref2) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].offices.getEvaluateOffices();

                        case 2:
                            response = _context2.sent;

                            commit('setScoreOffices', response.data.output);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    fetchOffice: function fetchOffice(_ref3, id) {
        var _this3 = this;

        var commit = _ref3.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].offices.get(id);

                        case 2:
                            response = _context3.sent;

                            commit('setOffice', response.data);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    saveOrUpdateOffice: function saveOrUpdateOffice(_ref4, form) {
        var _this4 = this;

        var dispatch = _ref4.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(form.id)) {
                                _context4.next = 5;
                                break;
                            }

                            _context4.next = 3;
                            return dispatch('saveOffice', form);

                        case 3:
                            _context4.next = 7;
                            break;

                        case 5:
                            _context4.next = 7;
                            return dispatch('updateOffice', form);

                        case 7:
                            _context4.next = 9;
                            return dispatch('loadOffices');

                        case 9:
                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('message.success.saved'));

                        case 10:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    saveOffice: function saveOffice(_ref5, form) {
        var _this5 = this;

        var dispatch = _ref5.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].offices.save(form);

                        case 2:
                            response = _context5.sent;
                            _context5.next = 5;
                            return dispatch('fetchOffice', response.data.id);

                        case 5:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    updateOffice: function updateOffice(_ref6, form) {
        var _this6 = this;

        var dispatch = _ref6.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].offices.update(form.id, form);

                        case 2:
                            _context6.next = 4;
                            return dispatch('fetchOffice', form.id);

                        case 4:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    }
};

var getters = {
    office: function office() {
        return state.office || [];
    },
    offices: function offices() {
        return state.offices || [];
    },
    scoreOffices: function scoreOffices() {
        return state.scoreOffices || [];
    },
    officesValueText: function officesValueText(_, getters) {
        return getters.offices.filter(function (i) {
            return !__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(i.id);
        }).map(function (_ref7) {
            var id = _ref7.id,
                acronym = _ref7.acronym,
                name = _ref7.name;
            return { value: id, text: acronym + ' - ' + name };
        });
    },
    officesDictionary: function officesDictionary(_, getters) {
        return getters.offices.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash UvixQUx9WrgkpPexqijoZ23g/WI=';

/***/ }),

/***/ "enKM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__ = __webpack_require__("HUpA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import constants from '@/helpers/constants';



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pagination: {
                descending: true,
                sortBy: 'number'
            },
            headers: [{
                text: this.$t('label.office'),
                value: 'office.officeNameDisplay',
                align: 'left'
            }, {
                text: this.$t('label.number'),
                value: 'number',
                align: 'left'
            }, {
                text: this.$t('label.validity'),
                value: 'validityTerm.validityDisplay',
                align: 'left'
            }, {
                text: this.$t('label.active') + '?',
                value: 'status',
                align: 'left'
            }, {
                text: this.$t('label.description'),
                value: 'description',
                align: 'left',
                sortable: false
            }, {
                text: 'Quantidade Orçada',
                value: 'number',
                align: 'left',
                sortable: false
            }, {
                text: 'Quantidade Executada',
                value: 'number',
                align: 'left',
                sortable: false
            }]
        };
    },


    computed: {
        contracts: function contracts() {
            var _this = this;

            var contracts = this.$store.getters.contracts;
            contracts.forEach(function (contract) {
                contract.status = contract.isActive ? _this.$t('label.yes') : _this.$t('label.no');
            });
            return contracts;
        },
        readonly: function readonly() {
            return !this.$store.getters.isAdmin;
        }
    },

    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__["a" /* default */]
    },

    methods: {
        search: function search(filters) {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(this.contracts, filters, function (contract, regex) {
                return regex.test(contract.office.officeNameDisplay) || regex.test(contract.number) || regex.test(contract.description) || regex.test(contract.validityTerm.validityDisplay) || regex.test(contract.status);
            });
        },
        refresh: function refresh() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadContracts');

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    }
});
'filehash dprkzAlQ2h5aKnOkKSn+uRvDt9o=';

/***/ }),

/***/ "eqmm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"dateTime"},[_vm._v("\n        "+_vm._s(_vm.dateApproved)+"\n    ")]),_vm._v(" "),_c('td',{staticClass:"person-name"},[_vm._v("\n        "+_vm._s(_vm.item.responsible.name)+"\n    ")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"comment-wrapper"},[_vm._v("\n            "+_vm._s(_vm.item.comments)+"\n        ")])]),_vm._v(" "),_c('td',{staticClass:"file-download"},[(_vm.hasFiles)?_c('span',[_c('v-icon',{staticStyle:{"transform":"scaleX(-1)"}},[_vm._v("fa-paperclip")]),_vm._v(" "+_vm._s(_vm.countFiles))],1):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"event-type"},[(_vm.isApprovalOrRejectionStatus)?_c('v-icon',{class:_vm.color,attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ew0L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },


    computed: {
        isHired: function isHired() {
            return this.$store.getters.profile.person.isHired;
        }
    },

    methods: {
        manageScoreOffices: function manageScoreOffices() {
            this.$router.push({ name: 'officeScoreIndex' });
        }
    }
});
'filehash YrD/UvKA2ro3wMTOvf1neFUIl5E=';

/***/ }),

/***/ "eyBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Approver_vue__ = __webpack_require__("+VlW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f9d9d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Approver_vue__ = __webpack_require__("kAHT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Approver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f9d9d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Approver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fP+C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__ = __webpack_require__("HUpA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pagination: {
                descending: false,
                sortBy: "name"
            },
            headers: [{
                text: this.$t("label.area"),
                value: "area.acronym",
                align: "left"
            }, {
                text: this.$t("label.code"),
                value: "username",
                align: "left"
            }, {
                text: this.$t("label.name"),
                value: "name",
                align: "left"
            }, {
                text: this.$t("label.email"),
                value: "emailAddress",
                align: "left",
                sortable: false
            }, {
                text: this.$t("label.active") + "?",
                value: "status",
                align: "left"
            }]
        };
    },

    computed: {
        persons: function persons() {
            var _this = this;

            var persons = this.$store.getters.persons.filter(function (person) {
                if (!_this.$store.getters.profile.office) return person;
                return !!person.area && person.office.id === _this.$store.getters.profile.office;
            });
            persons.forEach(function (person) {
                person.status = person.isActive ? _this.$t("label.yes") : _this.$t("label.no");
            });
            return persons;
        },
        readonly: function readonly() {
            return !this.$store.getters.isAdmin;
        }
    },

    methods: {
        search: function search(filters) {
            // const persons = this.$store.getters.persons;

            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(this.persons, filters, function (person, regex) {
                return regex.test(person.username) || regex.test(person.name) || regex.test((person.area || {}).acronym) || regex.test(person.emailAddress || regex.test(person.status));
            });
        },
        refresh: function refresh() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch("loadPersons");

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__["a" /* default */]
    }
});
"filehash yjlJ5/KFKSkj5TaYKyu52Cf89SQ=";

/***/ }),

/***/ "faRb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");





var state = {
    units: []
};

var mutations = {
    setUnits: function setUnits(state, units) {
        state.units = units;
    }
};

var actions = {
    loadUnits: function loadUnits(_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].units.list();

                        case 2:
                            response = _context.sent;

                            commit('setUnits', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
};

var getters = {
    units: function units() {
        var units = state.units || [];
        return units.sort(function (a, b) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].stringCompare(a.name, b.name);
        });
    },
    unitsValueText: function unitsValueText(_, getters) {
        return getters.units.map(function (_ref2) {
            var id = _ref2.id,
                name = _ref2.name;
            return { value: id, text: name };
        });
    },
    unitsDictionary: function unitsDictionary(_, getters) {
        return getters.units.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash k0HwFHhdoc/QUYdykYUf+GM2ppw=';

/***/ }),

/***/ "flzs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },


    computed: {
        isRoot: function isRoot() {
            return this.$store.getters.profile.isRoot;
        },
        isAdmin: function isAdmin() {
            return this.$store.getters.profile.isAdmin;
        },
        isHired: function isHired() {
            return this.$store.getters.profile.person.isHired;
        }
    },

    methods: {
        manageOffices: function manageOffices() {
            this.$router.push({ name: 'officeIndex' });
        },
        manageAreas: function manageAreas() {
            this.$router.push({ name: 'areaIndex' });
        },
        createReport: function createReport() {
            this.$router.push({ name: 'demandBillingReport' });
        }
    }
});
'filehash k67nLSTAJlDsNf6k/qRJs1oGtts=';

/***/ }),

/***/ "fsEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Area__ = __webpack_require__("Ko1i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_CardLoader__ = __webpack_require__("JqcZ");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_4__helpers_validation__["a" /* default */],
            valid: true,
            saving: false,
            loading: true,
            defaultOffice: false,

            form: __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Area__["a" /* default */].build(),
            offices: this.$store.getters.officesValueText
        };
    },

    computed: {
        isAdmin: function isAdmin() {
            return this.$store.getters.isAdmin;
        },
        isRoot: function isRoot() {
            return this.$store.getters.profile.isRoot;
        },
        disabled: function disabled() {
            return !(this.isAdmin || this.isRoot);
        }
    },

    components: {
        appCardLoader: __WEBPACK_IMPORTED_MODULE_6__components_shared_CardLoader__["a" /* default */]
    },

    watch: {
        $route: 'fetch'
    },

    created: function created() {
        this.fetch();
    },


    methods: {
        fetch: function fetch() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;

                                if (__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(_this.$route.params.id)) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 4;
                                return _this.$store.dispatch('fetchArea', _this.$route.params.id);

                            case 4:
                                _this.form = __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Area__["a" /* default */].toForm(_this.$store.getters.area);

                            case 5:

                                _this.loading = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        save: function save() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.$refs.form.validate()) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:

                                _this2.saving = true;
                                _context2.next = 5;
                                return _this2.$store.dispatch('saveOrUpdateArea', __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Area__["a" /* default */].toPayload(_this2.form));

                            case 5:
                                _this2.$router.push({ name: 'areaIndex' });

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        hasOffice: function hasOffice() {
            if (this.$store.getters.profile.office > 0) {
                this.form.officeId = this.$store.getters.profile.office;
                this.defaultOffice = true;
            }
        }
    }
});
'filehash y/gnUkjey4Ktlh2YIzB3GZq57CY=';

/***/ }),

/***/ "g/BY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("Yjch");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26672112_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("eAGK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26672112_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gfkZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utilities__ = __webpack_require__("ml+B");








var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: "https://ngdsapi.prodam.sp.gov.br/api"
});

http.interceptors.request.use(function (config) {
    // Insert the authentication header
    if (!__WEBPACK_IMPORTED_MODULE_5__helpers_utilities__["a" /* default */].isEmpty(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.profile)) {
        var token = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.profile.token;
        config.headers.Authorization = "Bearer " + token;
    }

    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

http.interceptors.response.use(function (response) {
    return response;
}, function (_ref) {
    var response = _ref.response;

    // Server didn't answer
    if (__WEBPACK_IMPORTED_MODULE_5__helpers_utilities__["a" /* default */].isEmpty(response)) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("setApiEvent", __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("message.error.networkError"));
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: "httpError", params: { id: 404 } });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }

    // Token expired or the credentials are invalid
    if (response.status === 401) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("showError", response.data.message);
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
            name: response.data.code === "cac_login_expired" ? "expiredPassword" : "login"
        });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }

    // Token expired or the credentials are invalid
    if (response.status === 403 && response.data.code === "invalid_state_change") {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("showError", response.data.message);
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: "demandIndex" });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }

    if (response.status === 403 && response.data.code === "generic_error") {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("showError", response.data.message);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }

    // Custom Application error
    if (!__WEBPACK_IMPORTED_MODULE_5__helpers_utilities__["a" /* default */].isEmpty(response.data) && !__WEBPACK_IMPORTED_MODULE_5__helpers_utilities__["a" /* default */].isEmpty(response.data.message)) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("setApiEvent", response.data.developerMessage || response.data.message);
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: "httpError", params: { id: response.status } });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }

    // Something went very wrong
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("setApiEvent", __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("message.error.fatalError"));
    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: "httpError", params: { id: 500 } });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
});

/* harmony default export */ __webpack_exports__["a"] = (http);
"filehash WdzPEz0pfByF6O6SPp/JZAzmuFw=";

/***/ }),

/***/ "ghUZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__ = __webpack_require__("BaNo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb6120a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__ = __webpack_require__("DBrU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb6120a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "giH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_validation__ = __webpack_require__("6OHK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: {
      type: Object,
      required: true,
      default: function _default() {}
    },
    index: {
      type: Number,
      required: true,
      default: 0
    },
    suffix: {
      type: String,
      required: true,
      default: ""
    },
    isInUse: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["a" /* default */],
      validation: __WEBPACK_IMPORTED_MODULE_1__helpers_validation__["a" /* default */],

      description: this.model.description,
      timeAmount: this.model.timeAmount,
      estimatedTime: this.model.estimatedTime,
      executedTime: this.model.executedTime,
      active: this.model.active,
      isContractItemInUse: this.model.isContractItemInUse
    };
  },


  computed: {
    removable: function removable() {
      return this.model.id === null;
    },
    activeState: function activeState() {
      if (this.model.active === true) {
        this.active = true;
      }
    },
    contractInUse: function contractInUse() {
      if (this.isContractItemInUse === true) {
        return true;
      }
      return false;
    },
    contractCopy: function contractCopy() {
      if (this.$route.name === "contractCopy") {
        return true;
      }
      return false;
    }
  },

  watch: {
    description: "update",
    timeAmount: "update",
    active: "update"
  },

  methods: {
    update: function update() {
      this.$emit("change", {
        id: this.model.id,
        uuid: this.model.uuid,
        description: this.description,
        timeAmount: this.timeAmount,
        active: this.active
      });
    },
    remove: function remove() {
      this.$emit("remove", this.model.uuid);
    }
  }
});
"filehash 8FsbYZG9GEXovrPZa4Fty3LBvrI=";

/***/ }),

/***/ "gkpS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__httpNovoEndpoint__ = __webpack_require__("5zE3");



/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/offices');
    },
    get: function get(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/offices/' + id);
    },
    save: function save(form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/offices', form);
    },
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/offices/' + id, form);
    },
    getEvaluateOffices: function getEvaluateOffices() {
        var ret = __WEBPACK_IMPORTED_MODULE_1__httpNovoEndpoint__["a" /* default */].get('/Secretarias/avaliacaoScore');
        return ret;
    }
});
'filehash IzXerApPh/JASBJ49hUMd3CIPPo=';

/***/ }),

/***/ "gmY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__ = __webpack_require__("ml+B");






var state = {
    contracts: [],
    contract: {}
};

var mutations = {
    setContract: function setContract(state, contract) {
        state.contract = contract;
    },
    setContracts: function setContracts(state, contracts) {
        state.contracts = contracts;
    }
};

var actions = {
    fetchContract: function fetchContract(_ref, id) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].contracts.fetch(id);

                        case 2:
                            response = _context.sent;

                            commit('setContract', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    loadContracts: function loadContracts(_ref2) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].contracts.list();

                        case 2:
                            response = _context2.sent;

                            commit('setContracts', response.data);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    removeContract: function removeContract(_ref3, form) {
        var _this3 = this;

        var dispatch = _ref3.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].contracts.remove(form.id);

                        case 2:
                            _context3.next = 4;
                            return dispatch('loadContracts');

                        case 4:

                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('message.success.contractRemoved'));

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    saveContract: function saveContract(_ref4, form) {
        var _this4 = this;

        var dispatch = _ref4.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].contracts.save(form);

                        case 2:
                            response = _context4.sent;
                            _context4.next = 5;
                            return dispatch('fetchContract', response.data.id);

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    saveOrUpdateContract: function saveOrUpdateContract(_ref5, form) {
        var _this5 = this;

        var dispatch = _ref5.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(form.id)) {
                                _context5.next = 5;
                                break;
                            }

                            _context5.next = 3;
                            return dispatch('saveContract', form);

                        case 3:
                            _context5.next = 7;
                            break;

                        case 5:
                            _context5.next = 7;
                            return dispatch('updateContract', form);

                        case 7:
                            _context5.next = 9;
                            return dispatch('loadContracts');

                        case 9:
                            _context5.next = 11;
                            return dispatch('loadContractItems');

                        case 11:
                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('message.success.saved'));

                        case 12:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    updateContract: function updateContract(_ref6, form) {
        var _this6 = this;

        var dispatch = _ref6.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].contracts.update(form.id, form);

                        case 2:
                            _context6.next = 4;
                            return dispatch('fetchContract', form.id);

                        case 4:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    }
};

var getters = {
    contract: function contract(state) {
        return state.contract;
    },
    contracts: function contracts(state) {
        var contracts = state.contracts || [];
        return contracts.sort(function (a, b) {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].stringCompare(a.number, b.number);
        });
    },
    contractsValueText: function contractsValueText(_, getters) {
        return getters.contracts.map(function (_ref7) {
            var id = _ref7.id,
                number = _ref7.number,
                description = _ref7.description,
                isActive = _ref7.isActive,
                validityTerm = _ref7.validityTerm;
            return {
                value: id,
                text: number + ' - ' + __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].toDate(validityTerm.finish) + ' - ' + description,
                isActive: isActive
            };
        });
    },
    contractsDictionary: function contractsDictionary(_, getters) {
        return getters.contracts.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash NnveEzMk3JGKhwAOelvQ4h9tySk=';

/***/ }),

/***/ "gsp3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__("mWYR");






var state = {
    evaluation: {}
};

var mutations = {
    setEvaluation: function setEvaluation(state, evaluation) {
        state.evaluation = evaluation;
    }
};

var actions = {
    getEvaluation: function getEvaluation(_ref, data) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].evaluations.get(data.demandId, data.personId);

                        case 2:
                            response = _context.sent;

                            commit('setEvaluation', response.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    saveOrUpdateEvaluation: function saveOrUpdateEvaluation(_ref2, form) {
        var _this2 = this;

        var dispatch = _ref2.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(form.id)) {
                                _context2.next = 5;
                                break;
                            }

                            _context2.next = 3;
                            return dispatch('saveEvaluation', form);

                        case 3:
                            _context2.next = 7;
                            break;

                        case 5:
                            _context2.next = 7;
                            return dispatch('updateEvaluation', form);

                        case 7:

                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.success.evaluationSaved'));

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    saveEvaluation: function saveEvaluation(_ref3, form) {
        var _this3 = this;

        var commit = _ref3.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].evaluations.save(form);

                        case 2:
                            commit('setEvaluation', form);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    updateEvaluation: function updateEvaluation(_ref4, form) {
        var _this4 = this;

        var commit = _ref4.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].evaluations.update(form.id, form);

                        case 2:
                            commit('setEvaluation', form);

                        case 3:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    removeEvaluation: function removeEvaluation(_ref5, form) {
        var _this5 = this;

        var dispatch = _ref5.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].evaluations.remove(form.id);

                        case 2:

                            dispatch('showSuccess', __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('message.success.evaluationRemoved'));

                        case 3:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    }
};

var getters = {
    evaluation: function evaluation() {
        return state.evaluation || {};
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
'filehash 1NhQ8CQPuUCpgJ8jwTUtNxWKzbs=';

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__admin__ = __webpack_require__("5eyz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__approverTypes__ = __webpack_require__("pD3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__areas__ = __webpack_require__("+Xmh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__("Pfph");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contractItems__ = __webpack_require__("5Au0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contracts__ = __webpack_require__("tbHi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__deliverables__ = __webpack_require__("82R3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__demands__ = __webpack_require__("pEll");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__demandOwnerSubstitutions__ = __webpack_require__("cTAj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__demandTypes__ = __webpack_require__("4XQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__evaluations__ = __webpack_require__("ukcv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__offices__ = __webpack_require__("gkpS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__persons__ = __webpack_require__("4eBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__suppliers__ = __webpack_require__("+105");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__systems__ = __webpack_require__("s8Ye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__units__ = __webpack_require__("Lpxf");

















/* harmony default export */ __webpack_exports__["a"] = ({
    admin: __WEBPACK_IMPORTED_MODULE_0__admin__["a" /* default */],
    approverTypes: __WEBPACK_IMPORTED_MODULE_1__approverTypes__["a" /* default */],
    areas: __WEBPACK_IMPORTED_MODULE_2__areas__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */],
    contractItems: __WEBPACK_IMPORTED_MODULE_4__contractItems__["a" /* default */],
    contracts: __WEBPACK_IMPORTED_MODULE_5__contracts__["a" /* default */],
    deliverables: __WEBPACK_IMPORTED_MODULE_6__deliverables__["a" /* default */],
    demands: __WEBPACK_IMPORTED_MODULE_7__demands__["a" /* default */],
    demandOwnerSubstitutions: __WEBPACK_IMPORTED_MODULE_8__demandOwnerSubstitutions__["a" /* default */],
    demandTypes: __WEBPACK_IMPORTED_MODULE_9__demandTypes__["a" /* default */],
    evaluations: __WEBPACK_IMPORTED_MODULE_10__evaluations__["a" /* default */],
    offices: __WEBPACK_IMPORTED_MODULE_11__offices__["a" /* default */],
    persons: __WEBPACK_IMPORTED_MODULE_12__persons__["a" /* default */],
    suppliers: __WEBPACK_IMPORTED_MODULE_13__suppliers__["a" /* default */],
    systems: __WEBPACK_IMPORTED_MODULE_14__systems__["a" /* default */],
    units: __WEBPACK_IMPORTED_MODULE_15__units__["a" /* default */]
});
'filehash 3ZUiHXmXJeWzdTnDILWTwZhK9cE=';

/***/ }),

/***/ "h215":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_FileUpload__ = __webpack_require__("R2v+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_Files__ = __webpack_require__("AUsU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Demand__ = __webpack_require__("R2Zp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    message: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
      valid: true,
      approving: false,
      rejecting: false,

      form: __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Demand__["a" /* default */].approval.build()
    };
  },


  computed: {
    demand: function demand() {
      return this.$store.getters.demand;
    },
    disableApprovalButton: function disableApprovalButton() {
      var dataAtual = __WEBPACK_IMPORTED_MODULE_6_moment___default()().startOf("day");
      var dataAprovacao = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.demand.maximumApprovalDeliveryDate).startOf("day");

      if (dataAtual.isAfter(dataAprovacao) && this.demand.status.id === 4) {
        return true;
      }
      if (!this.demand.dtImplementation && this.demand.status.id === 7 && this.demand.supplier.id === 1) {
        return true;
      }

      return false;
    },
    disableRejectButton: function disableRejectButton() {
      var dataAtual = __WEBPACK_IMPORTED_MODULE_6_moment___default()().startOf("day");
      var dataAprovacao = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.demand.maximumApprovalDeliveryDate).startOf("day");

      // When the maximum approval date is in the past and status is 4,
      // keep Reject ENABLED (i.e., do not disable the button)
      if (dataAtual.isAfter(dataAprovacao) && this.demand.status.id === 4) {
        return false;
      }

      // For other conditions, reuse the same disabling logic as approval
      return this.disableApprovalButton;
    }
  },

  components: {
    appFileUpload: __WEBPACK_IMPORTED_MODULE_3__components_shared_FileUpload__["a" /* default */],
    appFiles: __WEBPACK_IMPORTED_MODULE_4__components_shared_Files__["a" /* default */]
  },

  mounted: function mounted() {
    this.form = __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Demand__["a" /* default */].approval.copy(this.demand);
    console.log();
  },


  methods: {
    approve: function approve() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.$refs.form.validate()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;

                _this.approving = true;
                _context.next = 6;
                return _this.$store.dispatch("approveDemand", _this.form);

              case 6:
                _this.$router.push({ name: "dashboard" });
                _context.next = 16;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);

                if (!(_context.t0.data && _context.t0.data.code === "generic_error")) {
                  _context.next = 15;
                  break;
                }

                _this.approving = false;
                _context.next = 16;
                break;

              case 15:
                throw _context.t0;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 9]]);
      }))();
    },
    reject: function reject() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.$refs.form.validate()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:

                _this2.rejecting = true;
                _context2.next = 5;
                return _this2.$store.dispatch("rejectDemand", _this2.form);

              case 5:
                _this2.$router.push({ name: "dashboard" });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
"filehash JCz5a76i3YScB2roYVI4n+7Ygxk=";

/***/ }),

/***/ "hiVW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_filters__ = __webpack_require__("aGO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        icon: function icon() {
            return this.isApproval ? 'done' : 'clear';
        },
        color: function color() {
            return this.isApproval ? 'green--text' : 'red--text';
        },
        dateApproved: function dateApproved() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_filters__["dateToLongString"])(this.item.dateApproved);
        },
        isApproval: function isApproval() {
            return this.item.event.id === __WEBPACK_IMPORTED_MODULE_1__helpers_constants__["a" /* default */].EVENT_APPROVED;
        },
        isApprovalOrRejectionStatus: function isApprovalOrRejectionStatus() {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].isApprovalOrRejectionStatus(this.item.status.id);
        },
        hasFiles: function hasFiles() {
            return this.isApprovalOrRejectionStatus && !__WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].isEmptyOrZero(this.item.files);
        },
        countFiles: function countFiles() {
            return this.hasFiles ? this.item.files.length : 0;
        }
    }
});
'filehash 9eIP+pk9UWwCFCSMKNTnuTqIdVA=';

/***/ }),

/***/ "iNNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            connString: ''
        };
    },


    computed: {
        isRoot: function isRoot() {
            return this.$store.getters.profile.isRoot;
        }
    },
    created: function created() {
        this.fetch();
    },


    methods: {
        fetch: function fetch() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('fetchConnString');

                            case 2:
                                _this.connString = _this.$store.getters.connString;

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});
'filehash wCei4W77AHNyzCJi3zmnBSP4ZBg=';

/***/ }),

/***/ "iQRC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog--loader"},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-text',[_c('v-progress-circular',{staticClass:"secondary--text",attrs:{"size":70,"indeterminate":""}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j3+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cancel_vue__ = __webpack_require__("xC/9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8a8e61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cancel_vue__ = __webpack_require__("Y900");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cancel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8a8e61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cancel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jZOz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","offset-xs4":""}},[_c('v-card',[_c('v-card-text',[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"title mb-3 mt-1"},[_vm._v("GDS — Gestão de Demandas e Serviços")]),_vm._v(" "),_c('label',{staticClass:"form-label text-xs-left"},[_vm._v(_vm._s(_vm.$t("label.user")))]),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.validation.login,"validate-on-blur":true},model:{value:(_vm.form.username),callback:function ($$v) {_vm.$set(_vm.form, "username", $$v)},expression:"form.username"}}),_vm._v(" "),_c('label',{staticClass:"form-label text-xs-left"},[_vm._v(_vm._s(_vm.$t("label.currentPassword")))]),_vm._v(" "),_c('v-text-field',{attrs:{"type":"password","rules":_vm.validation.password,"validate-on-blur":true},model:{value:(_vm.form.oldPassword),callback:function ($$v) {_vm.$set(_vm.form, "oldPassword", $$v)},expression:"form.oldPassword"}}),_vm._v(" "),_c('label',{staticClass:"form-label text-xs-left"},[_vm._v(_vm._s(_vm.$t("label.newPassword")))]),_vm._v(" "),_c('v-text-field',{attrs:{"type":"password","rules":_vm.validation.password,"validate-on-blur":true},model:{value:(_vm.form.newPassword),callback:function ($$v) {_vm.$set(_vm.form, "newPassword", $$v)},expression:"form.newPassword"}}),_vm._v(" "),_c('label',{staticClass:"form-label text-xs-left"},[_vm._v(_vm._s(_vm.$t("label.confirmPassword")))]),_vm._v(" "),_c('v-text-field',{attrs:{"type":"password","rules":_vm.rules.confirmPassword,"validate-on-blur":true},model:{value:(_vm.form.confirmPassword),callback:function ($$v) {_vm.$set(_vm.form, "confirmPassword", $$v)},expression:"form.confirmPassword"}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-0",attrs:{"type":"submit","color":"primary","loading":_vm.loading}},[_vm._v(_vm._s(_vm.$t("label.enter")))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jere":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_CardLoader__ = __webpack_require__("JqcZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_MenuDatePicker__ = __webpack_require__("Z1KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Contract__ = __webpack_require__("Q1Hv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContractItem__ = __webpack_require__("L9D/");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      constants: __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["a" /* default */],
      validation: __WEBPACK_IMPORTED_MODULE_6__helpers_validation__["a" /* default */],
      valid: true,

      saving: false,
      loading: true,
      removing: false,

      form: __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Contract__["a" /* default */].build(),
      units: this.$store.getters.unitsValueText,
      offices: this.$store.getters.officesValueText,

      warrantValidityTermStartRule: [function () {
        if (_this.form.warrantyValidityTerm.start == null && _this.form.warrantyValidityTerm.finish != null) {
          return _this.$t("message.error.emptyStartDate");
        } else if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.form.warrantyValidityTerm.start).isBefore(_this.form.validityTerm.start)) {
          return _this.$t("message.error.validityStart");
        }
        return true;
      }],
      warrantvalidityTermFinishRule: [function () {
        if (_this.form.warrantyValidityTerm.start != null && _this.form.warrantyValidityTerm.finish == null) {
          return _this.$t("message.error.emptyFinishDate");
        } else if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.form.warrantyValidityTerm.finish).isBefore(_this.form.warrantyValidityTerm.start)) {
          return _this.$t("message.error.validityFinish");
        }
        return true;
      }],
      validityTermFinishRule: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__helpers_validation__["a" /* default */].required), [function () {
        return _this.form.validityTerm.finish >= _this.form.validityTerm.start || _this.$t("message.error.period");
      }])
    };
  },


  computed: {
    unit: function unit() {
      if (!this.form.unit.id) return "";
      return this.$store.getters.unitsDictionary[this.form.unit.id].name.toLowerCase();
    },
    disabled: function disabled() {
      return !this.$store.getters.isAdmin || !this.form.isActive;
    },
    contractExists: function contractExists() {
      if (this.$route.name === "contractEdit") {
        return true;
      }
      return false;
    },
    contractCopy: function contractCopy() {
      if (this.$route.name === "contractCopy") {
        this.form.id = 0;
        this.form.estimatedTime = 0;
        this.form.executedTime = 0;
        for (var i = 0; i < this.form.items.length; i++) {
          this.form.items[i].estimatedTime = 0;
          this.form.items[i].executedTime = 0;
        }
        return true;
      }
      return false;
    }
  },

  components: {
    appCardLoader: __WEBPACK_IMPORTED_MODULE_7__components_shared_CardLoader__["a" /* default */],
    appContractItem: __WEBPACK_IMPORTED_MODULE_10__ContractItem__["a" /* default */],
    appMenuDatePicker: __WEBPACK_IMPORTED_MODULE_8__components_shared_MenuDatePicker__["a" /* default */]
  },

  watch: {
    $route: "fetch"
  },

  created: function created() {
    this.fetch();
  },


  methods: {
    addItem: function addItem() {
      this.form.items.splice(this.form.items.length, 0, __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Contract__["a" /* default */].item.build());
    },
    removeItem: function removeItem(uuid) {
      var index = this.form.items.map(function (item) {
        return item.uuid;
      }).indexOf(uuid);
      this.form.items.splice(index, 1);
    },
    updateItem: function updateItem(value) {
      var index = this.form.items.map(function (item) {
        return item.uuid;
      }).indexOf(value.uuid);
      this.form.items.splice(index, 1, value);
    },
    clearWarrantyDays: function clearWarrantyDays() {
      this.form.warrantyDays = null;
    },
    clearWarrantyDate: function clearWarrantyDate() {
      this.form.warrantyValidityTerm.start = null;
      this.form.warrantyValidityTerm.finish = null;
    },
    clearWarrantyDaysAndDate: function clearWarrantyDaysAndDate() {
      this.clearWarrantyDays();
      this.clearWarrantyDate();
    },
    fetch: function fetch() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;

                id = _this2.$route.params.id;

                if (__WEBPACK_IMPORTED_MODULE_5__helpers_utilities__["a" /* default */].isEmptyOrZero(id)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return _this2.$store.dispatch("fetchContract", id);

              case 5:
                _this2.form = __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Contract__["a" /* default */].toForm(_this2.$store.getters.contract);

              case 6:

                _this2.loading = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    remove: function remove() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.removing = true;
                _context2.next = 3;
                return _this3.$store.dispatch("removeContract", __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Contract__["a" /* default */].toPayload(_this3.form));

              case 3:
                _this3.$router.push({ name: "contractIndex" });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    save: function save() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this4.$refs.form.validate()) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:

                _this4.saving = true;
                _context3.next = 5;
                return _this4.$store.dispatch("saveOrUpdateContract", __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Contract__["a" /* default */].toPayload(_this4.form));

              case 5:
                _this4.$router.push({ name: "contractIndex" });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    copyContractButton: function copyContractButton() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.$router.push({ name: "contractCopy" });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    updateContractButton: function updateContractButton() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.$router.push({ name: "contractUpdate" });

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    }
  }
});
"filehash kOc89pLTWdVlUDs9d/ZC9/YlnR0=";

/***/ }),

/***/ "jtxW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Approve_vue__ = __webpack_require__("h215");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3be434a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Approve_vue__ = __webpack_require__("1hy9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Approve_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3be434a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Approve_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kAHT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-3",attrs:{"xs4":""}},[(!_vm.isSub)?_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled && !!_vm.model.id,"placeholder":_vm.$t('label.approverType'),"items":_vm.types,"rules":_vm.rules.type,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}}):_c('v-icon',{staticStyle:{"float":"right"}},[_vm._v("subdirectory_arrow_right")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"autocomplete":"","placeholder":_vm.$t('label.person'),"items":_vm.persons,"rules":_vm.rules.person,"no-data-text":_vm.$t('message.warning.noData')},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('div',{style:(_vm.backgroundAlteracao),attrs:{"title":_vm.msgAlt}},[_vm._v(_vm._s(item.text))])]}}]),model:{value:(_vm.person),callback:function ($$v) {_vm.person=$$v},expression:"person"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-2",attrs:{"xs1":""}},[(!_vm.disabled || !_vm.model.id)?_c('v-icon',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.remove}},[_vm._v("delete")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-2",attrs:{"xs1":""}},[(!_vm.disabled || !!_vm.model.id)?_c('v-icon',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.addSub}},[_vm._v("add")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kKQe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3ceb7d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Closure_vue__ = __webpack_require__("OK5X");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3ceb7d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Closure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kcEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("enKM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0993ba20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("yb5X");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0993ba20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kgKR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("jere");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_511672f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("5NyF");
function injectStyle (ssrContext) {
  __webpack_require__("tulF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_511672f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kuha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.refresh},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'typeDemandEdit', params: { id: item.id }},"tag":"tr"}},[_c('td',{staticStyle:{"width":"400px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticStyle:{"width":"100px"}},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('td',{attrs:{"title":item.description}},[_vm._v(_vm._s(_vm._f("shortenedDescription")(item.description)))])])]}}])},[(!_vm.readonly)?_c('template',{slot:"afterReloadButton"},[_c('v-btn',{attrs:{"to":{ name: 'typeDemandCreate' },"color":"primary"}},[_vm._v(_vm._s(_vm.$t('label.createTypeDemand')))])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lBgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PopupModal',

    data: function data() {
        return {
            isVisible: false
        };
    },

    methods: {
        open: function open() {
            this.isVisible = true;
        },
        close: function close() {
            this.isVisible = false;
        }
    }
});
'filehash x1Ok98hZsA1U0IArQr0vL9mvmW0=';

/***/ }),

/***/ "lE98":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_FileUpload__ = __webpack_require__("R2v+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_Files__ = __webpack_require__("AUsU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_demands_shared_Cancel__ = __webpack_require__("j3+u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_MenuDatePicker__ = __webpack_require__("Z1KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Demand__ = __webpack_require__("R2Zp");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
      validation: __WEBPACK_IMPORTED_MODULE_4__helpers_validation__["a" /* default */],
      valid: true,
      saving: false,
      processing: false,
      canceling: false,
      form: __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Demand__["a" /* default */].build(),
      persons: this.$store.getters.personsValueText,
      systems: this.$store.getters.activeSystemsValueText,
      demands: this.$store.getters.demandsValueText
    };
  },

  computed: {
    area: function area() {
      if (this.form.requester.id > 0) {
        var person = this.$store.getters.personsDictionary[this.form.requester.id];
        if (person.isHired || !person.area) return "";

        var area = this.$store.getters.areasDictionary[person.area.id];
        return area.acronym + " - " + area.name;
      }
      return "";
    },
    contractItems: function contractItems() {
      var _this = this;

      return this.$store.getters.contractItemsValueText.filter(function (item) {
        return item.contractId === _this.form.contract.id;
      });
    },
    contracts: function contracts() {
      return __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].combobox(this.$store.getters.contractsValueText, this.form.contract.id);
    },
    demand: function demand() {
      return this.$store.getters.demand;
    },
    demandTypes: function demandTypes() {
      return __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].combobox(this.$store.getters.demandTypesValueText, this.form.type.id);
    },
    canRequest: function canRequest() {
      return this.demand.status.id <= __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_CREATED;
    },
    canCancel: function canCancel() {
      var _this2 = this;

      // Demand hasn't been saved yet, so there's nothing to cancel
      if (__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(this.demand.id)) return false;

      var creatorId = this.$store.getters.personsDictionary[this.form.creator.id].id;
      var requesterId = this.$store.getters.personsDictionary[this.form.requester.id].id;
      var userLoggedId = this.$store.getters.profile.person.id;
      var ownerId = this.$store.getters.demand.owner.id;

      // Creator of a demand can cancel demand until status id 1 ("Aberta")
      if (creatorId === userLoggedId && this.demand.status.id === 1) {
        return true;
      }

      // Requester of a demand can cancel demand until status id 1 ("Aberta")
      if (requesterId === userLoggedId && this.demand.status.id === 1) {
        return true;
      }

      if (ownerId === userLoggedId && this.demand.status.id === 1 || ownerId === userLoggedId && this.demand.status.id === 2) {
        return true;
      }

      if (this.demand.subOwners) {
        /* eslint max-len: ["error", { "code": 200 }] */
        if (this.demand.subOwners.filter(function (owner) {
          return owner.id === _this2.$store.getters.profile.person.id;
        }).length === 0 === false && this.demand.status.id === 2) {
          return true;
        }
      }

      // Demand is already done or rejected, can't be canceled
      if (this.demand.status.id === __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_DONE || this.demand.status.id === __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_REJECTED) {
        return false;
      }

      // Logged user is an prodam admin
      if (this.$store.getters.isAdmin && this.$store.getters.profile.isHired) {
        return true;
      }

      // Logged user is a root user.
      if (this.$store.getters.profile.isRoot) {
        return true;
      }

      // Logged user or creator is a contrator, only allow cancel if they are the same person
      if (this.$store.getters.profile.person.isHired || this.demand.creator.isHired) {
        return this.demand.creator.id === this.$store.getters.profile.person.id;
      }

      // Logged user is not an admin of his office.
      if (!this.$store.getters.isAdmin) {
        return false;
      }

      try {
        // User is a employee of the city. Allow canceling if he
        // belongs to the same secretary as the creator
        var areas = this.$store.getters.areasDictionary;
        var creatorOffice = areas[this.demand.creator.area.id].office.id;
        var userOffice = areas[this.$store.getters.profile.person.area.id].office.id;

        return creatorOffice === userOffice;
      } catch (e) {
        return true;
      }
    },
    disabled: function disabled() {
      return this.demand.status.id >= __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_PLANNING || this.demand.owner.id !== this.$store.getters.profile.person.id && !this.$store.getters.isAdmin;
    },
    disabledWorkflow: function disabledWorkflow() {
      return this.demand.status.id >= __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_CREATED_APPROVAL || this.demand.owner.id !== this.$store.getters.profile.person.id && !this.$store.getters.isAdmin;
    },
    disabledContract: function disabledContract() {
      return this.demand.status.id !== __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_CREATED_APPROVAL || this.demand.status.id == null || this.demand.owner.id !== this.$store.getters.profile.person.id && !this.$store.getters.isAdmin;
    },
    showArea: function showArea() {
      return !__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(this.area);
    },
    isAdmin: function isAdmin() {
      var ok = this.$store.getters.isAdmin;
      return ok;
    },
    enableAdmin: function enableAdmin() {
      if (this.$store.getters.isAdmin) {
        return !this.$store.getters.isAdmin;
      }
      return this.disabled;
    },
    enableContract: function enableContract() {
      if (this.demand.status.id !== __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_CREATED_APPROVAL && this.$store.getters.isAdmin) {
        this.disabledContract = false;
        return false;
      }
      return this.disabledContract;
    }
  },

  components: {
    appFileUpload: __WEBPACK_IMPORTED_MODULE_5__components_shared_FileUpload__["a" /* default */],
    appFiles: __WEBPACK_IMPORTED_MODULE_6__components_shared_Files__["a" /* default */],
    appCancel: __WEBPACK_IMPORTED_MODULE_7__components_demands_shared_Cancel__["a" /* default */],
    appMenuDatePicker: __WEBPACK_IMPORTED_MODULE_8__components_shared_MenuDatePicker__["a" /* default */]
  },

  beforeMount: function beforeMount() {
    this.copyToForm();
  },


  watch: {
    demand: "copyToForm",
    "form.system.id": "chooseContract"
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      _this3.demands = _this3.$store.getters.relatedDemandsValueText;
    }, 600);
  },

  methods: {
    chooseContract: function chooseContract(value, oldValue) {
      var _this4 = this;

      // This condition happens when the user opens the page to edit a demand
      if (oldValue === null && this.demand.status.id) return;

      var system = this.$store.getters.systemsDictionary[value];
      // If system has a contract return it, else return default contract.
      var contract = system.contract || this.$store.getters.contracts[0];
      this.form.contract.id = contract.id || 0;
      // If system has a contract item return it, else return the first item in the contract
      this.form.contractItem.id = (system.contractItem || this.$store.getters.contractItems.filter(function (item) {
        return item.contract.id === _this4.form.contract.id;
      })[0]).id || 0;
    },
    copyToForm: function copyToForm() {
      this.form = __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Demand__["a" /* default */].copy(this.demand);
      if (this.form.code === 0) {
        this.form.requester.id = 0;
      }
    },
    verifyDemand: function verifyDemand(value) {
      if (value === this.demand.id) {
        this.form.relatedDemand.id = 0;
        this.$store.dispatch("showError", "Não é possível relacionar a demanda a ela mesma.");
      }
    },
    save: function save() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this5.$refs.form.validate()) {
                  _context.next = 3;
                  break;
                }

                _this5.$store.dispatch("showError", _this5.$t("message.error.formError"));
                return _context.abrupt("return");

              case 3:

                _this5.saving = true;
                _context.next = 6;
                return _this5.$store.dispatch("saveOrUpdateDemand", __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Demand__["a" /* default */].prepare(_this5.form));

              case 6:
                _this5.saving = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    advance: function advance() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this6.$refs.form.validate()) {
                  _context2.next = 3;
                  break;
                }

                _this6.$store.dispatch("showError", _this6.$t("message.error.formError"));
                return _context2.abrupt("return");

              case 3:
                _this6.processing = true;
                _context2.next = 6;
                return _this6.$store.dispatch("saveOrUpdateDemand", __WEBPACK_IMPORTED_MODULE_9__helpers_entities_Demand__["a" /* default */].prepare(_this6.form));

              case 6:
                _this6.processing = false;
                _context2.next = 9;
                return _this6.$store.dispatch("requestDemand", _this6.$store.getters.demand);

              case 9:
                _this6.$router.push({ name: "dashboard" });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    cancel: function cancel() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this7.canceling = true;
                // await this.$store.dispatch('cancelDemand', this.form);
                // this.$router.push({ name: 'dashboard' });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    }
  }
});
"filehash X1XElByxNVua/ri3MaPxFNKwGTg=";

/***/ }),

/***/ "ljCp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");


/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build() {
        return {
            id: 0,
            acronym: '',
            name: '',
            email: '',
            isActive: true,
            controlAccess: false,
            controlContract: false,
            controlEvaluation: false,
            evaluationStartDate: ''
        };
    },
    toForm: function toForm(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toForm(obj, this.build());
    },
    toPayload: function toPayload(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toPayload(obj);
    }
});
'filehash cPF9pZeyDW3h/efP8M0a8yOCuuo=';

/***/ }),

/***/ "mB/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dc67334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogLoader_vue__ = __webpack_require__("iQRC");
function injectStyle (ssrContext) {
  __webpack_require__("P4Cw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dc67334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mWYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("TXmL");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = {
    pt: {
        label: {
            acronym: "Sigla",
            action: "Ação",
            active: "Ativo",
            addApprover: "Adicionar aprovador",
            addContractItem: "Adicionar cesta",
            addStep: "Adicionar tipo aprovador",
            admin: "Administração",
            prodam: "PRODAM",
            approval: "Aprovação",
            approvalCycle: "Sequência de aprovação",
            approvalDateF: "Aprovada em",
            approvalDetails: "Detalhes da aprovação",
            approve: "Aprovar",
            approved: "Aprovado",
            approvers: "Aprovadores",
            approverType: "Tipo do aprovador",
            area: "Área",
            audit: "Auditoria",
            auditSession: "Sessão de auditoria",
            basicInfo: "Informações Básicas",
            cancel: "Cancelar",
            cancelDemand: "Cancelar demanda",
            clear: "Limpar",
            clearSubstitute: "Remover substituto",
            close: "Fechar",
            closure: "Encerramento",
            code: "Código",
            comments: "Comentários",
            comment: "Comentário",
            configuration: "Configuração",
            confirmPassword: "Confirmar senha",
            contract: "Contrato",
            contractItem: "Cesta",
            contractNumber: "Número do contrato",
            contractObject: "Objeto",
            contractCopy: "Copiar contrato",
            contractUpdate: "Migrar demandas",
            contractor: "Relacionamento",
            contractorManager: "Gerente Relacionamento",
            contracts: "Contratos",
            controlAccess: "Controla Acesso",
            createArea: "Criar área",
            createContract: "Criar contrato",
            createDemand: "Criar demanda",
            createDemandOwnerSubstitutions: "Criar substituição",
            createOffice: "Criar secretaria",
            createSystem: "Criar sistema",
            createTypeDemand: "Criar tipo de demanda",
            createTypeApprover: "Criar tipo de aprovador",
            creator: "Criador",
            currentPassword: "Senha atual",
            date: "Data",
            dateApproved: "Data aprovação",
            dateRejected: "Data rejeição",
            days: "dias",
            dashboard: "Painel",
            deliverablesAmount: "Quantidade de entregas",
            delivery: "Entrega",
            deliveryDate: "Data de entrega",
            deliveryTime: "Prazo estimado (Dias úteis)",
            estimatedDeliveryDate: "Data Estimada de Entrega",
            demand: "Demanda",
            demands: "Demandas",
            demandType: "Tipo de Demanda",
            description: "Descrição",
            desirableDate: "Data desejável",
            details: "Detalhes",
            editPerson: "Editar usuário",
            email: "Email",
            endDate: "Data de termino",
            enter: "Entrar",
            estimatedQuantity: "Quantidade orçada",
            estimatedTime: "Horas previstas",
            events: "Eventos",
            execute: "Executar",
            executedQuantity: "Quantidade executada",
            export: "Exportar",
            exit: "Sair",
            files: "Arquivos",
            filesDescription: "Descrição",
            filters: "Filtros",
            flow: "Tipo de demanda",
            from: "De",
            demandTypes: "Tipos de demanda",
            hired: "Prodam",
            hiredAmount: "Quantidade contratada",
            inactive: "Inativo",
            inactivate: "Desativar",
            isAdmin: "Administrador",
            isOutsourced: "Terceiro",
            lifeCycle: "Ciclo de vida",
            message: "Mensagem",
            name: "Nome",
            newUser: "Registrar usuário",
            newPassword: "Nova senha",
            number: "Número",
            office: "Secretaria",
            originalOwner: "Responsável",
            outcome: "Resultado",
            owner: "Responsável atual",
            pagination: "Registros por página",
            password: "Senha do Domínio",
            person: "Usuário",
            persons: "Usuários",
            planning: "Planejamento",
            profile: "Perfil",
            reason: "Justificativa",
            receivedDate: "Data de Chegada",
            reference: "Referência",
            reload: "Recarregar",
            reject: "Devolver",
            relatedDemand: "Demanda vinculada",
            remarks: "Observações",
            remove: "Remover",
            report: "Relatório",
            request: "Solicitação",
            requestApproval: "Enviar para aprovação",
            requester: "Solicitante",
            requestPersonUpdate: "Atualiza perfil",
            restart: "Reiniciar",
            save: "Salvar",
            saveDemand: "Salvar demanda",
            search: "Pesquisar",
            similarDemandsDescription: "Demandas similares",
            startDate: "Data de início",
            status: "Situação",
            substitute: "Substituto",
            substitutes: "Substituições",
            substitutions: "Substituições",
            switchUser: "Trocar de usuário",
            system: "Sistema",
            supplier: "Fornecedor",
            systems: "Sistemas",
            title: "Título",
            to: "Até",
            token: "Dados de Autorização",
            types: "Tipos",
            unit: "Unidade de medida",
            unitCost: "Valor unitário",
            usedTime: "Horas executadas",
            user: "Usuário",
            validity: "Validade",
            warranty: "Prazo de garantia",
            warrantyValidity: "Validade da garantia",
            workflowHistory: "Histórico desta etapa",
            yourApproval: "Sua aprovação",
            yourCancel: "Seu cancelamento",
            yes: "Sim",
            no: "Não",
            averageEvaluationDemands: "Avaliação",
            demandEvaluation: "Avaliação da Demanda",
            notEvaluatedDemands: "Demandas",
            evaluatedDemands: "Avaliadas",
            dateStartEvaluationDemand: "Data",
            allowsEvaluation: "Permite Avaliação",
            evaluationStartDate: "Data de Início Avaliação",
            houveDevolucoes: "Demandas com Devolução",
            dtImplementacao: "Fim Garantia",
            implantacao: "Implantação",
            garantia: "Garantia"
        },

        message: {
            error: {
                approvalDateRequired: "Informe a data em que a demanda foi aprovada",
                areaRequired: "Informe a area",
                attachmentsEmpty: "O arquivo selecionado está vazio",
                attachmentsQuantity: "O limite permitido são 5 arquivos",
                attachmentsSize: "O limite permitido são 5MB por arquivo",
                cac: "Falha ao comunicar com o CAC. Tente novamente mais tarde.",
                contractRequired: "Informe o contrato",
                contractNewRequired: "Informe o novo contrato",
                contractNewItemRequired: "Informe pelo menos 1 item para ser atualizado",
                credentials: "O usuário ou senha informados são inválidos.",
                deliveryDateRequired: "Informe a data de entrega",
                descriptionRequired: "Informe a descrição",
                emailAddressInvalid: "Informe um email válido",
                emailAddressRequired: "Informe o email",
                emptyFinishDate: "A data final deve ser preenchida",
                emptyStartDate: "A data inicial deve ser preenchida",
                estimatedQuantityRequired: "Informe a quantidade orçada",
                executedTimeRequired: "Informe a quantidade executada",
                fatalError: "Um erro inesperado aconteceu. Por favor entre em contato com a PRODAM.",
                flowRequired: "Informe o fluxo de aprovação",
                formError: "Seu formulário contém erros",
                networkError: "Erro de comunicação com o servidor. Por favor tente novamente mais tarde.",
                noPermission: "Você não tem permissão para acessar esta página",
                officeRequired: "Informe a secretaria",
                outsourcedAdmin: "Usuário terceirizado não pode ser administrador.",
                passwordRequired: "Informe sua senha",
                passwordNoMatch: "As senhas não conferem",
                passwordTooSmall: "A senha deve ter 6 ou mais caracteres",
                period: "A data de término deve ser posterior a data de início",
                plannedTimeRequired: "Informe a quantidade orçada",
                required: "Obrigatório",
                requesterRequired: "Informe o solicitante",
                server: "Falha ao buscar os dados. Tenta novamente mais tarde.",
                systemRequired: "Informe o sistema",
                titleRequired: "Informe o titulo",
                userRequired: "Informe seu usuário",
                validityFinish: "A data final da garantia deve ser posterior a data inicial",
                validityStart: "A data de início da garantia deve ser posterior ou igual a data de validade"
            },
            info: {
                approverType: "Tipos de aprovadores são usados em tipos de demanda para determinar as aprovações necessárias em cada situação do ciclo de vida da demanda. O usuário que será responsável pela aprovação é determinado pelo sistema a qual a demanda pertence.",
                approverTypeInactive: "Este tipo de aprovador está inativo. Ele não pode ser modificado.",
                approverTypeInUse: "Um ou mais sistemas e/ou tipos de demanda usam este tipo de aprovador.",
                contractInactive: "Este contrato está inativo. Ele não pode ser modificado.",
                contractInUse: "Uma ou mais demandas ativas e/ou sistemas usam este contrato. Os itens da cesta em uso não podem ser inativados.",
                contractItems: "Informe o nome e a quantidade de {unit} disponível em cada um dos itens da cesta.",
                demandCancelRequest: "Insira um motivo para o cancelamento da demanda. Essa ação é definitiva e irreversível.",
                demandCreationApproval: "Revise os dados da demanda e os comentários inseridos pelos aprovadores anteriores (se houver) antes de aprovar sua necessidade ou devolver a demanda.",
                demandCreationDetails: "Informe o objetivo da demanda e se haverá criação, alteração ou exclusão de funcionalidades do sistema (descrição), quais precauções devem ser tomadas (observação), qual problema a demanda irá resolver (justificativa) e qual o resultado esperado após sua execução (resultado). Se esta for uma demanda regular &mdash; como geração de relatórios &mdash; informe os números das demandas anteriores que trataram do mesmo assunto (demandas similares).",
                demandCreationLifeCycle: "Os dados abaixo são controlados pelo sistema e não podem ser alterados.",
                demandCreationSentForApproval: "Solicitação enviada para aprovação",
                demandDeliveryApproval: "Revise a entrega, fazendos as verificações necessárias, e os comentários inseridos pelos aprovadores anteriores (se houver) antes de aprovar ou devolver esta demanda.",
                demandDeliveryDetails: "Informe a localização e dados de acesso do entregável (no caso do desenvolvimento, evolução ou manutenção de um sistema) ou quais arquivos correspondem as evidências (no caso de demandas que não são facilmente verificáveis).",
                demandDeliverySentForApproval: "Entrega enviada para aprovação",
                demandFiles: "Indique como cada arquivo deve ser usado.",
                demandFinalizing: "Esta demanda foi executada e será encerrada. Por favor indique que você está ciente.",
                demandNotFound: "Demanda não encontrada",
                demandPlanningApproval: "Revise as informações de planejamento da demanda e os comentários inseridos pelos aprovadores anteriores (se houver) antes de ratificar sua necessidade ou devolver a demanda.",
                demandPlanningBasicInfo: "Informe o tempo que será necessário para executar a demanda e em quantos dias úteis ela será finalizada.",
                demandPlanningDetails: "Descreva as atividade que serão executadas na demanda e indique o tempo necessário para cada uma. Caso o campo abaixo não seja o suficiente, clique no botão 'Anexar arquivos' para anexar os documentos necessários.",
                demandPlanningSentForApproval: "Planejamento enviado para aprovação",
                demandSaved: "Demanda D{code} salva.",
                demandSearch: "Busque demandas ativas, ou encerradas a até 30 dias, por qualquer coluna da tabela abaixo",
                demandSearchNumber: "Digite o número da demanda e aperte enter",
                demandTypeApprovers: "Informe os tipos de aprovadores necessários em cada situação, assim como sua alçada. A ordem que os tipos de aprovadores aparecem em cada situação será a ordem em que eles devem realizar a aprovação.",
                demandTypeInactive: "Este tipo de demanda está inativo. Ele não pode ser modificado.",
                demandTypeInUse: "Uma ou mais demandas ativas usam este tipo de demanda. A sequência de aprovadores não pode ser alterada.",
                expireSubstitutes: "Esta rotina ",
                generalSearch: "Busque por qualquer uma das colunas da tabela abaixo",
                notSavedF: "Não salva",
                person: "",
                personFirstLogin: "Esta é a primeira vez que você acessa o GDS. Por favor preencha os campos abaixo para ter acesso ao sistema.",
                personUpdateRequired: "Seu perfil está desatualizado. Por favor confira as informações abaixo e clique em salvar para ter acesso ao resto do sistema.",
                personSearch: "Busque por código ou nome",
                substitute: "Informe qual usuário ficará responsável pelas demandas deste usuário. Durante o período de vigência apenas o substituto poderá aprovar as demandas deste usuário.",
                substitutes: "Este usuário substitui os usuários abaixo.",
                systemApprovers: "Informe quais usuários podem aprovar demandas neste sistema e por qual tipo de aprovação eles são responsáveis.",
                systemInUse: "Uma ou mais demandas ativas usam este sistema. Alterações no relacionamento Prodam ou lista de aprovadores podem levar a mudanças nos responsáveis por estas demandas.",
                substitutionInUse: "Não é permitido alterar a demanda ou o responsável de uma substituição existente."
            },
            success: {
                contractRemoved: "Contrato removido com sucesso",
                demandApproved: "Demanda D{code} aprovada com sucesso",
                demandCanceled: "Demanda D{code} cancelada com sucesso",
                demandOwnerSubstitutionRemoved: "Substituição removida com sucesso",
                demandRejected: "Demanda D{code} devolvida com sucesso",
                demandRequested: "Demanda D{code} enviada para aprovação",
                demandSaved: "Demanda D{code} salva com sucesso",
                systemRemoved: "Sistema removido com sucesso",
                approverTypeRemoved: "Tipo de aprovador removido com sucesso",
                demandTypeDisabled: "Tipo de demanda desabilitado com sucesso",
                demandTypeRemoved: "Tipo de demanda removido com sucesso",
                saved: "Dados salvos com sucesso",
                userSaved: "Dados salvos com sucesso",
                passwordUpdated: "Senha alterada com sucesso.",
                evaluationRemoved: "Avaliação removida com sucesso",
                evaluationSaved: "Avaliação salva com sucesso"
            },

            validation: {
                invalid: "Inválido",
                loginTooShort: "Informe pelo menos 7 caracteres",
                notZero: "Informe um valor maior do que 0 (zero)",
                numeric: "Informe um valor numérico",
                passwordTooShort: "Informe pelo menos 6 caracteres",
                required: "Obrigatório",
                tooShort: "Informe pelo menos 3 caracteres",
                unique: "Valor já informado"
            },

            warning: {
                noData: "Dados não encontrados",
                noDataWorkflowHistory: "Nenhuma aprovação realizada até o momento"
            }
        },

        tooltip: {
            actions: "Ações",
            allFilters: "Todos os filtros",
            report: "Relatório",
            refresh: "Atualizar",
            remove: "Remover"
        },

        title: {
            approverType: "Tipo de Aprovador",
            demandType: "Tipo de Demanda",
            ownedDemands: "Demandas sob sua responsabilidade",
            createdDemands: "Demandas que você criou para outras pessoas",
            requestedDemands: "Demandas solicitadas por você",
            quickSearch: "Busca rápida"
        },

        type: {
            status: ["-", "Aberta", "Aprovação da solicitação", "Planejamento", "Aprovação do planejamento", "Em Execução", "Aprovação da entrega", "Encerramento", "Cancelada", "Encerrada"],
            event: {
                approved: "Aprovado",
                rejected: "Rejeitado"
            },
            httpError: {
                400: "Erro de validação",
                404: "Não encontrado",
                403: "Proibido",
                500: "Erro fatal",
                501: "Ação não suportada",
                503: "Serviço indisponível"
            }
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    locale: "pt",
    messages: messages
}));
"filehash fYVgtnAA9ZRl0Xt3CKfd9G5XcD4=";

/***/ }),

/***/ "mXcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = download;
/* eslint-disable */
function download(data, strFileName, strMimeType, url, progressCallback) {

    var self = window,
        // this script is only for browsers anyway...
    defaultMime = "application/octet-stream",
        // this default mime also triggers iframe downloads
    mimeType = strMimeType || defaultMime,
        payload = data,

    //url = !strFileName && !strMimeType && payload,
    anchor = document.createElement("a"),
        toString = function toString(a) {
        return String(a);
    },
        myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
        fileName = strFileName || "download",
        blob,
        reader;
    myBlob = myBlob.call ? myBlob.bind(self) : Blob;

    if (String(this) === "true") {
        //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
        payload = [payload, mimeType];
        mimeType = payload[0];
        payload = payload[1];
    }

    if (url && url.length < 2048) {
        // if no filename and no mime, assume a url was passed as the only argument
        //fileName = url.split("/").pop().split("?")[0];
        anchor.href = url; // assign href prop to temp anchor
        if (anchor.href.indexOf(url) !== -1) {
            // if the browser determines that it's a potentially valid url path:
            var ajax = new XMLHttpRequest();
            ajax.open("GET", url, true);
            ajax.responseType = 'blob';
            ajax.onprogress = progressCallback;
            ajax.onload = function (e) {
                download(e.target.response, fileName, defaultMime);
            };
            setTimeout(function () {
                ajax.send();
            }, 0); // allows setting custom ajax headers using the return:
            return ajax;
        } // end if valid url?
    } // end if url?


    //go ahead and download dataURLs right away
    if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {

        if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
            payload = dataUrlToBlob(payload);
            mimeType = payload.type || defaultMime;
        } else {
            return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
            navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
        }
    } //end if dataURL passed?

    blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

    function dataUrlToBlob(strUrl) {
        var parts = strUrl.split(/[:;,]/),
            type = parts[1],
            decoder = parts[2] == "base64" ? atob : decodeURIComponent,
            binData = decoder(parts.pop()),
            mx = binData.length,
            i = 0,
            uiArr = new Uint8Array(mx);

        for (i; i < mx; ++i) {
            uiArr[i] = binData.charCodeAt(i);
        }return new myBlob([uiArr], { type: type });
    }

    function saver(url, winMode) {

        if ('download' in anchor) {
            //html5 A[download]
            anchor.href = url;
            anchor.setAttribute("download", fileName);
            anchor.className = "download-js-link";
            anchor.innerHTML = "downloading...";
            anchor.style.display = "none";
            document.body.appendChild(anchor);
            setTimeout(function () {
                anchor.click();
                document.body.removeChild(anchor);
                if (winMode === true) {
                    setTimeout(function () {
                        self.URL.revokeObjectURL(anchor.href);
                    }, 250);
                }
            }, 66);
            return true;
        }

        // handle non-a[download] safari as best we can:
        if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
            url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
            if (!window.open(url)) {
                // popup blocked, offer direct download:
                if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
                    location.href = url;
                }
            }
            return true;
        }

        //do iframe dataURL download (old ch+FF):
        var f = document.createElement("iframe");
        document.body.appendChild(f);

        if (!winMode) {
            // force a mime that will download:
            url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
        }
        f.src = url;
        setTimeout(function () {
            document.body.removeChild(f);
        }, 333);
    } //end saver


    if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(blob, fileName);
    }

    if (self.URL) {
        // simple fast and modern way using Blob and URL:
        saver(self.URL.createObjectURL(blob), true);
    } else {
        // handle non-Blob()+non-URL browsers:
        if (typeof blob === "string" || blob.constructor === toString) {
            try {
                return saver("data:" + mimeType + ";base64," + self.btoa(blob));
            } catch (y) {
                return saver("data:" + mimeType + "," + encodeURIComponent(blob));
            }
        }

        // Blob but not URL support:
        reader = new FileReader();
        reader.onload = function (e) {
            saver(this.result);
        };
        reader.readAsDataURL(blob);
    }
    return true;
}; /* end download() */

"filehash LrttK3qhquTodou6pQOvw+JMnBw=";

/***/ }),

/***/ "ml+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("eHeZ");








/* harmony default export */ __webpack_exports__["a"] = ({
    isEmpty: function isEmpty(value) {
        if (value === null || value === undefined) return true;

        if (typeof value === 'number') return false;

        if (typeof value === 'string') return value.match(/^ *$/) !== null;

        if (Array.isArray(value)) return value.length === 0;

        if (value instanceof Date) return false;

        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) === 'object') return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(value).length === 0;

        return false;
    },
    isEmptyOrZero: function isEmptyOrZero(value) {
        if (this.isEmpty(value)) return true;

        if (typeof value === 'string') return value.match(/^0*$/) !== null;

        if (typeof value === 'number' && value === 0) return true;

        return false;
    },
    isNumeric: function isNumeric(value) {
        return (/^\d{0,15}([,.]\d{1,2})*$/.test(value.toString())
        );
    },
    uuidv4: function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            /* eslint-disable no-bitwise */
            var r = Math.random() * 16 | 0;
            /* eslint-disable no-bitwise, no-mixed-operators */
            var v = c === 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    },
    splitAtDelimiters: function splitAtDelimiters(value) {
        if (this.isEmpty(value)) return value;

        return value.split(/[\s;,]+/);
    },
    filterMultiple: function filterMultiple(array, filters, callback) {
        var _this = this;

        if (this.isEmpty(array) || this.isEmpty(filters)) return array;

        var filteredArray = array;
        var filterPieces = this.splitAtDelimiters(filters);

        filterPieces.forEach(function (filter) {
            if (!_this.isEmpty(filter)) {
                var regex = new RegExp(filter.trim(), 'i');
                filteredArray = filteredArray.filter(function (item) {
                    return callback(item, regex);
                });
            }
        });

        return filteredArray;
    },
    mimeApplicationToFontAwesome: function mimeApplicationToFontAwesome(mime) {
        if (this.isEmpty(mime)) return 'fa-file-o';

        if (mime.includes('excel') || mime.includes('.sheet')) return 'fa-file-excel-o';

        if (mime.includes('powerpoint') || mime.includes('.presentation')) return 'fa-file-powerpoint-o';

        if (mime.includes('word') || mime.includes('.document')) return 'fa-file-word-o';

        if (mime.includes('javascript')) return 'fa-file-code-o';

        if (mime.includes('pdf')) return 'fa-file-pdf-o';

        if (mime.includes('compressed')) return 'fa-file-archive-o';

        return 'fa-file-o';
    },
    mimeToFontAwesome: function mimeToFontAwesome(mime) {
        if (this.isEmpty(mime)) return 'fa-file-o';

        var _mime$split = mime.split('/'),
            _mime$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_mime$split, 2),
            prefix = _mime$split2[0],
            sufix = _mime$split2[1];

        var hash = {
            image: 'fa-file-image-o',
            audio: 'fa-file-audio-o',
            video: 'fa-file-video-o',
            application: this.mimeApplicationToFontAwesome(sufix),
            text: 'fa-file-text-o'
        };

        return hash[prefix];
    },
    fontAwesomeFileIconToClass: function fontAwesomeFileIconToClass(icon) {
        if (this.isEmpty(icon)) return 'grey--text text--darken-1';

        var hash = {
            'fa-file-image-o': 'purple--text text--darken-2',
            'fa-file-audio-o': 'purple--text text--darken-2',
            'fa-file-excel-o': 'green--text text--darken-2',
            'fa-file-powerpoint-o': 'amber--text text--darken-3',
            'fa-file-word-o': 'blue--text text--darken-4',
            'fa-file-text-o': 'blue--text text--darken-4',
            'fa-file-pdf-o': 'red--text text--darken-4',
            'fa-file-archive-o': 'brown--text text--darken-1'
        };

        return hash[icon] || 'grey--text text--darken-1';
    },
    splitFileNameExtension: function splitFileNameExtension(fileName) {
        if (this.isEmpty(fileName)) return ['', ''];

        var index = fileName.lastIndexOf('.');

        if (index <= 0) return [fileName, ''];

        var name = fileName.substr(0, index);
        var extension = fileName.substr(index + 1);

        return [name, extension];
    },
    numberToDataString: function numberToDataString(value) {
        return Math.ceil(value).toLocaleString('en-us', { maximumFractionDigits: 0 });
    },
    filterByStatus: function filterByStatus(array) {
        for (var _len = arguments.length, status = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            status[_key - 1] = arguments[_key];
        }

        if (this.isEmpty(array)) return [];

        return array.filter(function (item) {
            return status.some(function (status) {
                return status === item.status.id;
            });
        });
    },
    acumulateFiles: function acumulateFiles(workflowHistory, status) {
        if (this.isEmptyOrZero(workflowHistory)) return [];

        var items = this.filterByStatus(workflowHistory, status);
        var files = items.reduce(function (arr, obj) {
            return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(arr), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(obj.files));
        }, []);

        return files.sort(function (a, b) {
            return a.id - b.id;
        });
    },
    isApprovalOrRejectionStatus: function isApprovalOrRejectionStatus(value) {
        var status = [__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].STATUS_CREATED_APPROVAL, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].STATUS_PLANNING_APPROVAL, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].STATUS_DELIVERY_APPROVAL, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].STATUS_REJECTED, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].STATUS_FINALIZING];

        return status.includes(value);
    },
    isDemandActionable: function isDemandActionable(user, person, status, value) {
        var exact = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

        // Admins can always do anything
        if (user.isAdmin) return true;

        // No status, can't be actioned
        if (this.isEmpty(status)) return false;

        // No reference person, can't be actioned
        if (this.isEmpty(person)) return false;

        // Only the person specified can change it
        if (person.id !== user.person.id) return false;

        // No value given for comparison, can be actioned if it exists (status > 0)
        if (this.isEmptyOrZero(value)) return !this.isEmptyOrZero(status.id);

        // Make the comparison
        return exact ? status.id === value : status.id <= value;
    },
    stringCompare: function stringCompare(a, b) {
        var aUpper = a.toUpperCase().trim();
        var bUpper = b.toUpperCase().trim();

        if (aUpper < bUpper) return -1;
        if (aUpper > bUpper) return 1;
        return 0;
    },
    padStart: function padStart(value, targetLength, padString) {
        targetLength >>= 0;
        padString = String(padString || ' ');
        if (value.length > targetLength) {
            return String(this);
        }

        targetLength -= value.length;
        if (targetLength > padString.length) {
            padString += padString.repeat(targetLength / padString.length);
        }
        return padString.slice(0, targetLength) + String(value);
    },
    toMoney: function toMoney(val) {
        return Number(val).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    toNumber: function toNumber(val) {
        return Number(val.toString().replace(',', '.'));
    },
    toFixedFloat: function toFixedFloat(val) {
        var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

        var numberString = val.toString().replace(',', '.');
        var hasDecimal = numberString.indexOf('.') > 0;
        var number = this.toNumber(numberString.replace(/\D+/g, ''));
        var exp = Math.pow(10, numberString.length - 1 - numberString.indexOf('.'));
        var value = hasDecimal ? parseFloat(number) / exp : parseFloat(numberString);
        return parseFloat(value).toFixed(precision);
    },
    toDate: function toDate(val) {
        return new Date(val).toLocaleDateString('pt-BR');
    },
    toTime: function toTime(val) {
        return new Date(val).toLocaleTimeString('pt-BR');
    },
    toDateTime: function toDateTime(val) {
        return [this.toDate(val), this.toTime(val)].join('_');
    },
    clone: function clone(obj) {
        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(base, JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj)));
    },
    toForm: function toForm(obj) {
        var _this2 = this;

        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var clone = this.clone(obj, base);

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(clone).forEach(function (key) {
            var property = clone[key];
            if (Array.isArray(property)) {
                property.forEach(function (item) {
                    item.uuid = _this2.uuidv4();
                });
            }
        });

        return clone;
    },
    toPayload: function toPayload(obj) {
        var _this3 = this;

        var clone = this.clone(obj);

        // To avoid problems with the API, remove from the
        // payload any nested object that constains only the
        // ID property and it's empty or Zero, or any properties
        // that are empty collections.
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(clone).forEach(function (key) {
            var property = clone[key];

            if (!property) return;

            if ((typeof property === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(property)) !== 'object') return;

            if (Array.isArray(property) && property.length > 0) return;

            if (property instanceof Date) return;

            if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(property).length > 1) return;

            if (!_this3.isEmptyOrZero(property.id)) return;

            clone[key] = null;
        });

        return clone;
    },
    combobox: function combobox(arr, id) {
        return arr.filter(function (item) {
            return item.isActive || item.value === id;
        });
    }
});
'filehash QYM93VYP96r8ewsjgf5MP6vND8s=';

/***/ }),

/***/ "nNT6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("fsEY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca588c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("dQ2j");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca588c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nQlK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");


/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build() {
        return {
            id: 0,
            demand: { id: 0 },
            originalOwner: { id: 0 },
            substituteOwner: { id: 0 }
        };
    },
    toForm: function toForm(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toForm(obj, this.build());
    },
    toPayload: function toPayload(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toPayload(obj);
    }
});
'filehash 5j1kuNhrUCAUYv4Qh/1peD3eKuc=';

/***/ }),

/***/ "oCru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg10":"","offset-lg1":""}},[_c('p',{staticClass:"body-1 grey--text text--darken-1"},[_vm._v(_vm._s(_vm.$t('title.ownedDemands')))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingOwner),expression:"loadingOwner"}]},[_c('v-progress-circular',{staticClass:"secondary--text",attrs:{"size":30,"indeterminate":""}})],1),_vm._v(" "),(!_vm.loadingOwner)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.ownedHeaders,"items":_vm.ownedDemands,"hide-actions":"","no-data-text":_vm.$t('message.warning.noData'),"pagination":_vm.pagination,"rows-per-page-items":[500]},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'demandEdit', params: { id: item.id } },"tag":"tr"}},[_c('td',{staticClass:"demand-code"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',{staticClass:"system-acronym"},[_vm._v(_vm._s(item.system.acronym))]),_vm._v(" "),_c('td',{staticClass:"situation-name"},[_vm._v(_vm._s(item.status.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("dateToLongString")(item.lastFlowDate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))])])]}}],null,false,3888467527)}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg10":"","offset-lg1":""}},[_c('p',{staticClass:"body-1 grey--text text--darken-1 mt-5"},[_vm._v(_vm._s(_vm.$t('title.requestedDemands')))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingRequester),expression:"loadingRequester"}]},[_c('v-progress-circular',{staticClass:"secondary--text",attrs:{"size":30,"indeterminate":""}})],1),_vm._v(" "),(!_vm.loadingRequester)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.createdHeaders,"items":_vm.requestedDemands,"hide-actions":"","no-data-text":_vm.$t('message.warning.noData'),"pagination":_vm.pagination,"rows-per-page-items":[500]},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'demandEdit', params: { id: item.id } },"tag":"tr"}},[_c('td',{staticClass:"demand-code"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',{staticClass:"system-acronym"},[_vm._v(_vm._s(item.system.acronym))]),_vm._v(" "),_c('td',{staticClass:"situation-name"},[_vm._v(_vm._s(item.status.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("demandOwner")(item)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))])])]}}],null,false,1597446419)}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg10":"","offset-lg1":""}},[_c('p',{staticClass:"body-1 grey--text text--darken-1 mt-5"},[_vm._v(_vm._s(_vm.$t('title.createdDemands')))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingCreator),expression:"loadingCreator"}]},[_c('v-progress-circular',{staticClass:"secondary--text",attrs:{"size":30,"indeterminate":""}})],1),_vm._v(" "),(!_vm.loadingCreator)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.requestedHeaders,"items":_vm.createdDemands,"hide-actions":"","no-data-text":_vm.$t('message.warning.noData'),"pagination":_vm.pagination,"rows-per-page-items":[500]},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'demandEdit', params: { id: item.id } },"tag":"tr"}},[_c('td',{staticClass:"demand-code"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',{staticClass:"system-acronym"},[_vm._v(_vm._s(item.system.acronym))]),_vm._v(" "),_c('td',{staticClass:"situation-name"},[_vm._v(_vm._s(item.status.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.requester.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))])])]}}],null,false,918243309)}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oDRG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("ZgPi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e0482aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("ayfp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e0482aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p7Jl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pD3o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/approver-types');
    },
    get: function get(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/approver-types/' + id);
    },
    remove: function remove(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete('/approver-types/' + id);
    },
    save: function save(form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/approver-types', form);
    },
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/approver-types/' + id, form);
    }
});
'filehash f9q4rQx1/r8axcVuHC22ZiWIPBA=';

/***/ }),

/***/ "pEll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__("gfkZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__httpNovoEndpoint__ = __webpack_require__("5zE3");




/* harmony default export */ __webpack_exports__["a"] = ({

    // CRUD
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get('/demands');
    },

    // consulta a demanda selecionada no Grid tela Demadas
    // (tela src\components\demands\Edit.vue fetchDemand).
    fetch: function fetch(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get('/demands/' + id);
    },
    save: function save(form) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post('/demands', form);
    },
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].put('/demands/' + id + '/', form);
    },


    // Actions
    approve: function approve(id, form) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].put('/demands/' + id + '/approve', form);
    },
    cancel: function cancel(id, form) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].put('/demands/' + id + '/cancel', form);
    },
    reject: function reject(id, form) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].put('/demands/' + id + '/reject', form);
    },
    plan: function plan(id, form) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].put('/demands/' + id + '/planning', form);
    },
    request: function request(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].put('/demands/' + id + '/request');
    },
    deliver: function deliver(id, form) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post('/demands/' + id + '/deliver', form);
    },


    // Other
    findByCode: function findByCode(form) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get('/demands/findByCode?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(form));
    },
    search: function search(form) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get('/demands/search?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(form));
    },
    findByRequest: function findByRequest(form) {
        return __WEBPACK_IMPORTED_MODULE_2__httpNovoEndpoint__["a" /* default */].get('/Demandas/BuscaDemandasPorSolicitante?cdUsuario=' + form);
    },
    findByCreator: function findByCreator(form) {
        return __WEBPACK_IMPORTED_MODULE_2__httpNovoEndpoint__["a" /* default */].get('/Demandas/BuscaDemandasPorCriador?cdUsuario=' + form);
    },
    findByOwner: function findByOwner(form) {
        return __WEBPACK_IMPORTED_MODULE_2__httpNovoEndpoint__["a" /* default */].get('/Demandas/BuscaDemandasPorResponsavel?cdUsuario=' + form);
    },
    searchByFilter: function searchByFilter(form) {
        var ret = __WEBPACK_IMPORTED_MODULE_2__httpNovoEndpoint__["a" /* default */].get('/Demandas/BuscaDemandasPesquisa?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(form));
        return ret;
    },
    getForGrid: function getForGrid() {
        var ret = __WEBPACK_IMPORTED_MODULE_2__httpNovoEndpoint__["a" /* default */].get('/Demandas/BuscaDemandasGrid');
        return ret;
    },
    getEvaluatedForGrid: function getEvaluatedForGrid(officeId) {
        var ret = __WEBPACK_IMPORTED_MODULE_2__httpNovoEndpoint__["a" /* default */].get('/Demandas/BuscaDemandasSecretariaAvaliadas?cdSecretaria=' + officeId);
        return ret;
    },
    getDemandComments: function getDemandComments(demandId) {
        var ret = __WEBPACK_IMPORTED_MODULE_2__httpNovoEndpoint__["a" /* default */].get('/Demandas/BuscaComentariosDemanda?cdDemanda=' + demandId);
        return ret;
    }
});
'filehash CzBfRiLm8ZjNGejTS25ssaalJmQ=';

/***/ }),

/***/ "pJne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('confirm-dialogue',{ref:"confirmDialogue"}),_vm._v(" "),(!_vm.loading)?_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[(_vm.form.isInUse)?_c('v-alert',{staticClass:"mb-3",attrs:{"color":"warning","icon":"warning","value":"true"}},[_vm._v("\n                        "+_vm._s(_vm.$t("message.info.systemInUse"))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subheading mb-3"},[_vm._v("\n                        "+_vm._s(_vm.$t("label.basicInfo"))+"\n                    ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.acronym"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.text,"maxlength":_vm.constants.LENGTH_SYSTEM_ACRONYM},model:{value:(_vm.form.acronym),callback:function ($$v) {_vm.$set(_vm.form, "acronym", $$v)},expression:"form.acronym"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.name"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.text,"maxlength":_vm.constants.LENGTH_SYSTEM_NAME,"counter":_vm.constants.LENGTH_SYSTEM_NAME},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.office"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg6":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled,"items":_vm.offices,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.office.id),callback:function ($$v) {_vm.$set(_vm.form.office, "id", $$v)},expression:"form.office.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.contract"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled,"items":_vm.contracts,"clearable":"","no-data-text":_vm.$t('message.warning.noData'),"maxlength":_vm.constants.LENGTH_CONTRACT,"rules":_vm.validation.required},model:{value:(_vm.form.contract.id),callback:function ($$v) {_vm.$set(_vm.form.contract, "id", $$v)},expression:"form.contract.id"}})],1)],1),_vm._v(" "),(!!this.form.contract.id)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.contractItem"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg6":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabled,"items":_vm.contractItems,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData'),"maxlength":_vm.constants.LENGTH_CONTRACT_ITEM},model:{value:(_vm.form.contractItem.id),callback:function ($$v) {_vm.$set(_vm.form.contractItem, "id", $$v)},expression:"form.contractItem.id"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.supplier"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"disabled":_vm.disabled,"items":_vm.suppliers,"autocomplete":"","rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},on:{"change":_vm.clearContractor},model:{value:(_vm.form.supplier.id),callback:function ($$v) {_vm.$set(_vm.form.supplier, "id", $$v)},expression:"form.supplier.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.contractor"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"disabled":_vm.disabled || _vm.noOfficeDisabled,"items":_vm.persons,"rules":_vm.validation.required,"autocomplete":"","no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.contractor.id),callback:function ($$v) {_vm.$set(_vm.form.contractor, "id", $$v)},expression:"form.contractor.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.contractorManager")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"disabled":_vm.disabled || _vm.noOfficeDisabled,"items":_vm.contractorManagers,"autocomplete":"","no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.contractorManager.id),callback:function ($$v) {_vm.$set(_vm.form.contractorManager, "id", $$v)},expression:"form.contractorManager.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.description"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":_vm.disabled,"rules":_vm.validation.text,"auto-grow":"","counter":_vm.constants.LENGTH_SYSTEM_DESCRIPTION,"maxlength":_vm.constants.LENGTH_SYSTEM_DESCRIPTION},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"subheading"},[_vm._v("\n                        "+_vm._s(_vm.$t("label.approvers"))+"\n                    ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.systemApprovers'))}}),_vm._v(" "),_vm._l((_vm.form.approvers),function(approver){return _c('app-approver',{key:approver.uuid,attrs:{"office":_vm.form.office.id,"model":approver,"list":_vm.form.approvers,"disabled":_vm.disabled || _vm.form.isInUse,"isSub":approver.isSub,"msgAlt":approver.msgAlt},on:{"remove":_vm.removeApprover,"change":_vm.updateApprover,"sub":_vm.addSub}})})],2),_vm._v(" "),(!_vm.disabled)?_c('v-card-actions',[_c('v-btn',{attrs:{"disabled":_vm.removing,"loading":_vm.saving,"color":"primary"},on:{"click":_vm.save}},[_vm._v("\n                        "+_vm._s(_vm.$t("label.save"))+"\n                    ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.saving || _vm.removing},on:{"click":_vm.addApprover}},[_c('v-icon',{staticClass:"mr-3"},[_vm._v("person_outline")]),_vm._v("\n                        "+_vm._s(_vm.$t("label.addApprover"))+"\n                    ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.form.isInUse && !!_vm.form.id)?_c('v-btn',{attrs:{"disabled":_vm.saving,"loading":_vm.removing,"color":"error"},on:{"click":_vm.remove}},[_vm._v("\n                        "+_vm._s(_vm.$t("label.remove"))+"\n                    ")]):_vm._e()],1):_vm._e()],1):_c('v-card',[_c('app-card-loader')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qdk4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"body-1 grey--text text--darken-1 mt-4"},[_vm._v(_vm._s(_vm.$t('label.workflowHistory')))]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.items,"hide-actions":"","no-data-text":_vm.$t('message.warning.noDataWorkflowHistory'),"pagination":_vm.pagination,"rows-per-page-items":_vm.rowsPerPageItems,"id":"workflowHistory"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',{staticClass:"dateTime"},[_vm._v(_vm._s(_vm.$t('label.date')))]),_vm._v(" "),_c('th',{staticClass:"person-name"},[_vm._v(_vm._s(_vm.$t('label.person')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('label.comments')))]),_vm._v(" "),_c('th',{staticClass:"file-download"},[_vm._v(_vm._s(_vm.$t('label.files')))]),_vm._v(" "),_c('th',{staticClass:"event-type"},[_vm._v(_vm._s(_vm.$t('label.approved'))+"?")])])]}},{key:"items",fn:function(props){return [_c('app-workflow-item',{attrs:{"item":props.item},nativeOn:{"click":function($event){return _vm.toggleDetail(props.item)}}})]}}])}),_vm._v(" "),_c('div',{attrs:{"id":"detail"}},[(_vm.isDetailing)?_c('app-workflow-item-detail',{attrs:{"item":_vm.detail}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r55f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");


/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build() {
        return {
            id: 0,
            acronym: '',
            name: '',
            contract: { id: null },
            contractItem: { id: null },
            office: { id: null },
            description: '',
            contractor: { id: null },
            contractorManager: { id: null },
            priority: { id: 1 },
            isInUse: false,
            isActive: true,
            supplier: { id: null },
            approvers: []
        };
    },
    toForm: function toForm(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toForm(obj, this.build());
    },
    toPayload: function toPayload(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toPayload(obj);
    },


    // Children
    approver: {
        build: function build() {
            return {
                person: { id: null },
                type: { id: null },
                uuid: __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].uuidv4()
            };
        }
    }
});
'filehash zCLOgaOON+tqrV2cMZHCOgNoU2A=';

/***/ }),

/***/ "rDH2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import constants from '@/helpers/constants';


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            menu: false
        };
    },

    computed: {
        isRoot: function isRoot() {
            return this.$store.getters.profile.isRoot;
        },
        isAdmin: function isAdmin() {
            return this.isRoot || this.$store.getters.profile.isAdmin;
        },
        isHired: function isHired() {
            return this.$store.getters.profile.isHired;
        },
        person: function person() {
            return this.$store.getters.profile.person;
        },
        name: function name() {
            return this.person.name;
        },
        username: function username() {
            return this.person.username.toUpperCase();
        },
        area: function area() {
            var area = {};
            if (this.person.area) {
                area = this.person.area;
            }
            return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].isEmpty(area.acronym) ? this.$t('label.hired') : area.acronym;
        }
    },
    methods: {
        admin: function admin() {
            this.menu = false;
            this.$router.push({ name: 'admin' });
        },
        prodam: function prodam() {
            this.menu = false;
            this.$router.push({ name: 'prodam' });
        },
        logout: function logout() {
            this.$router.push({ name: 'logout' });
        },
        profile: function profile() {
            this.menu = false;

            var id = this.$store.getters.profile.person.id;
            this.$router.push({ name: 'personEdit', params: { id: id } });
        }
    }
});
'filehash jEQNfhSKFdD6glgbKfZ6anQRs3w=';

/***/ }),

/***/ "rTIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



/* harmony default export */ __webpack_exports__["a"] = ({
    build: function build() {
        var officeId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.profile ? __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.profile.office : null;

        return {
            isHired: false,
            isUpdateRequired: false,
            isAdmin: false,
            emailAddress: '',
            area: { id: null },
            office: { id: officeId },
            substitute: { id: null },
            substitutionTerm: {
                start: null,
                finish: null
            },
            substitutes: [],
            substitutedInDemands: [],
            substitutingInDemands: [],
            name: '',
            username: '',
            isRoot: false,
            isActive: false,
            isOutsourced: false,
            approverOf: []
        };
    },
    toForm: function toForm(obj) {
        return __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toForm(obj, this.build());
    },
    toPayload: function toPayload(obj) {
        var clone = __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["a" /* default */].toPayload(obj);

        if (clone.isHired) {
            clone.area = null;
            clone.office = null;
        }

        if (!clone.substitute) clone.substitutionTerm = null;

        return clone;
    }
});
'filehash XwEHsl/7PTjv9lYY1me/4I2hv4Q=';

/***/ }),

/***/ "rVoo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__File__ = __webpack_require__("5Bfa");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        model: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        }
    },
    data: function data() {
        return {
            files: this.model
        };
    },

    watch: {
        files: function files(val) {
            this.$emit('update:model', val);
        },
        model: function model(val) {
            this.files = val;
        }
    },
    methods: {
        changed: function changed(files) {
            /* Adding files is asynchronous, don't count on this.files.length
             * to impose a limit as it fails when adding 6 or more files at the
             * same time
             */
            var quantity = this.files.length;

            for (var i = 0; i < files.length; i++) {
                var file = files[i];

                if (this.isAboveFileLimit(quantity)) return;

                if (!this.isRepeated(file) && !this.isAboveSizeLimit(file) && !this.isEmptyFile(file)) {
                    this.load(file);
                    quantity++;
                }
            }

            this.$refs.filesInput.value = '';
        },
        load: function load(file) {
            var _this = this;

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function (e) {
                _this.files.push({
                    fileName: file.name,
                    contentLength: file.size,
                    contentType: file.type,
                    content: e.target.result,
                    isNewFile: true
                });
            };
        },
        isAboveFileLimit: function isAboveFileLimit(quantity) {
            if (quantity >= 5) {
                this.$store.dispatch('showError', this.$t('message.error.attachmentsQuantity'));
                return true;
            }

            return false;
        },
        isAboveSizeLimit: function isAboveSizeLimit(_ref) {
            var size = _ref.size;

            if (size / 1024 / 1024 > 5) {
                this.$store.dispatch('showError', this.$t('message.error.attachmentsSize'));
                return true;
            }

            return false;
        },
        isEmptyFile: function isEmptyFile(_ref2) {
            var size = _ref2.size;

            if (size === 0) {
                this.$store.dispatch('showError', this.$t('message.error.attachmentsEmpty'));
                return true;
            }

            return false;
        },
        isRepeated: function isRepeated(_ref3) {
            var name = _ref3.name;

            return this.files.find(function (item) {
                return item.fileName.toLowerCase() === name.toLowerCase();
            });
        }
    },
    components: {
        appFile: __WEBPACK_IMPORTED_MODULE_0__File__["a" /* default */]
    }
});
'filehash eKFMrouyQsuwXDcZqoPtvtIEtaQ=';

/***/ }),

/***/ "s8Ye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({

    approvers: {
        save: function save(id, approvers) {
            return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/systems/' + id + '/approvers', approvers);
        }
    },

    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/systems');
    },
    fetch: function fetch(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/systems/' + id);
    },
    remove: function remove(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete('/systems/' + id);
    },
    save: function save(form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/systems', form);
    },
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/systems/' + id, form);
    }
});
'filehash 4ZlHC1+WExYqF+QTNC0MLhEGSpg=';

/***/ }),

/***/ "sIiZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"dense":"","dark":"","app":"","clipped-left":""}},[_c('v-toolbar-title',[_vm._v("GDS")]),_vm._v(" "),_c('div',{attrs:{"id":"toolbar--search"}},[_c('v-text-field',{attrs:{"disabled":_vm.searching,"mask":_vm.validation.mask.demandCode,"hide-details":"","placeholder":"Busque pelo código da demanda"},nativeOn:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)}},model:{value:(_vm.code),callback:function ($$v) {_vm.code=_vm._n($$v)},expression:"code"}}),_vm._v(" "),(!_vm.searching)?_c('v-btn',{staticClass:"ma-0",attrs:{"icon":""},on:{"click":_vm.search}},[_c('v-icon',{attrs:{"color":"grey darken-4"}},[_vm._v("search")])],1):_vm._e(),_vm._v(" "),(_vm.searching)?_c('v-progress-circular',{attrs:{"size":24,"indeterminate":"","color":"primary"}}):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":{name: 'dashboard'}}},[_vm._v(" "+_vm._s(_vm.$t('label.dashboard')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":{name: 'demandIndex'}}},[_vm._v(" "+_vm._s(_vm.$t('label.demands')))]),_vm._v(" "),(_vm.isAdmin)?_c('v-btn',{attrs:{"flat":"","to":{name: 'contractIndex'}}},[_vm._v(" "+_vm._s(_vm.$t('label.contracts')))]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":{name: 'systemIndex'}}},[_vm._v(" "+_vm._s(_vm.$t('label.systems')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":{name: 'personIndex'}}},[_vm._v(" "+_vm._s(_vm.$t('label.persons')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":{name: 'demandOwnerSubstitutionIndex'}}},[_vm._v(" "+_vm._s(_vm.$t('label.substitutions')))]),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":""},slot:"activator"},[_vm._v(_vm._s(_vm.$t('label.types')))]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"to":{name: 'typeApproverIndex'}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('label.approvers')))])],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{name: 'typeDemandIndex'}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('label.demands')))])],1)],1)],1),_vm._v(" "),_c('app-profile')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sgZV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_validation__ = __webpack_require__("6OHK");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import Money from '@/components/shared/Money';

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        model: {
            type: Object,
            required: true,
            default: function _default() {}
        },
        list: {
            type: Array,
            required: false,
            default: function _default() {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data: function data() {
        var _this = this;

        return {
            constants: __WEBPACK_IMPORTED_MODULE_1__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_3__helpers_validation__["a" /* default */],

            costThreshold: this.model.costThreshold.toString().replace('.', ','),
            type: this.model.approverType.id,

            rules: {
                type: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__helpers_validation__["a" /* default */].required), [function () {
                    return _this.list.filter(function (item) {
                        return item.uuid !== _this.model.uuid && item.approverType.id === _this.type;
                    }).length === 0 || _this.$t('message.validation.unique');
                }])
            }
        };
    },


    computed: {
        types: function types() {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].combobox(this.$store.getters.approverTypesValueText, this.type);
        }
    },

    components: {
        // appMoney: Money,
    },
    watch: {
        type: 'update',
        costThreshold: 'update'
    },

    methods: {
        update: function update() {
            this.$emit('change', {
                costThreshold: __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].toFixedFloat(this.costThreshold),
                status: this.model.status,
                approverType: { id: this.type },
                uuid: this.model.uuid
            });
            this.costThreshold = this.costThreshold.toString().replace('.', ',');
        },
        remove: function remove() {
            this.$emit('remove', this.model.uuid);
        }
    }
});
'filehash +tN7Mh8vXLGP0OLG0wfdL7nIz9c=';

/***/ }),

/***/ "shUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{staticClass:"elevation-1",attrs:{"offset-x":"","close-on-content-click":false,"nudge-top":200},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-card',[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption"},[_vm._v(_vm._s(_vm.username)+" • "+_vm._s(_vm.area)+" • ID "+_vm._s(_vm.person.id))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.isAdmin || _vm.isHired)?_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.admin}},[_vm._v(" "+_vm._s(_vm.$t('label.admin')))]):_vm._e(),_vm._v(" "),(_vm.isHired)?_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.prodam}},[_vm._v(" "+_vm._s(_vm.$t('label.prodam')))]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","small":""},on:{"click":_vm.profile}},[_vm._v(_vm._s(_vm.$t('label.profile')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","small":"","color":"error"},on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.$t('label.exit')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "soUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__ = __webpack_require__("HUpA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_DialogLoader__ = __webpack_require__("mB/l");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pagination: {
                descending: false,
                sortBy: 'name'
            },
            headers: [{
                text: this.$t('label.code'),
                value: 'id',
                align: 'left'
            }, {
                text: this.$t('label.office'),
                value: 'acronym',
                align: 'left'
            }, {
                text: this.$t('label.name'),
                value: 'name',
                align: 'left'
            }, {
                text: this.$t('label.averageEvaluationDemands'),
                value: 'average',
                align: 'left'
            }, {
                text: this.$t('label.notEvaluatedDemands'),
                value: 'notEvaluatedDemands',
                align: 'left'
            }, {
                text: this.$t('label.evaluatedDemands'),
                value: 'evaluatedDemands',
                align: 'left'
            }, {
                text: this.$t('label.dateStartEvaluationDemand'),
                value: 'dtStartEvaluation',
                align: 'left'
            }],
            loading: true,
            summary: {},
            placeholder: "Busque por Código, Nome ou Sigla da Secretaria"
        };
    },

    methods: {
        search: function search(filters) {
            var offices = this.$store.getters.scoreOffices.avaliacaoSecretarias;

            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(offices, filters, function (office, regex) {
                return regex.test(office.acronym) || regex.test(office.name) || regex.test(office.id);
            });
        },
        loadEvaluateOffices: function loadEvaluateOffices() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;
                                _context.next = 3;
                                return _this.$store.dispatch('getEvaluateOffices');

                            case 3:
                                _this.summary = _this.$store.getters.scoreOffices;
                                _this.loading = false;

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    beforeMount: function beforeMount() {
        this.loadEvaluateOffices();
    },

    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__["a" /* default */],
        DialogLoader: __WEBPACK_IMPORTED_MODULE_4__shared_DialogLoader__["a" /* default */]
    }
});
'filehash VmpzKmkSnRyzE/ddqCUqK7nPvOQ=';

/***/ }),

/***/ "soc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8961ce24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Body_vue__ = __webpack_require__("GjwJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8961ce24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Body_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sonc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_validation__ = __webpack_require__("6OHK");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            validation: __WEBPACK_IMPORTED_MODULE_2__helpers_validation__["a" /* default */],
            loading: false,
            form: {
                username: "",
                password: "",
                recaptchaToken: null
            }
        };
    },

    methods: {
        submit: function submit() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.$refs.form.validate()) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 2:
                                _context.prev = 2;

                                _this.loading = true;
                                _context.next = 6;
                                return _this.recaptcha();

                            case 6:
                                _context.next = 8;
                                return _this.$store.dispatch("login", _this.form);

                            case 8:
                                _this.$router.push({ name: "dashboard" });
                                _context.next = 14;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context["catch"](2);

                                _this.loading = false;

                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[2, 11]]);
            }))();
        },
        recaptcha: function recaptcha() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var token;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.$recaptchaLoaded();

                            case 2:
                                _context2.next = 4;
                                return _this2.$recaptcha("submit");

                            case 4:
                                token = _context2.sent;


                                // Do stuff with the received token.
                                _this2.form.recaptchaToken = token;

                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        this.$nextTick(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _this3.recaptcha();

                        case 2:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        })));
    }
});
"filehash cyA2VN8DE3QHVuP0bjfDeT0ebk8=";

/***/ }),

/***/ "syma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',[_c('v-card-text',[_c('div',{staticClass:"subheading mb-3"},[_vm._v(_vm._s(_vm.$t("label.basicInfo")))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.creator")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm._f("personToString")(_vm.form.creator)))])])],1),_vm._v(" "),(_vm.showArea)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.area")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('span',{staticClass:"form-value"},[_vm._v(_vm._s(_vm.area))])])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.system"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabledWorkflow,"items":_vm.systems,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.system.id),callback:function ($$v) {_vm.$set(_vm.form.system, "id", $$v)},expression:"form.system.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.flow"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.disabledWorkflow,"items":_vm.demandTypes,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.type.id),callback:function ($$v) {_vm.$set(_vm.form.type, "id", $$v)},expression:"form.type.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.requester"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.enableAdmin,"items":_vm.persons,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData')},model:{value:(_vm.form.requester.id),callback:function ($$v) {_vm.$set(_vm.form.requester, "id", $$v)},expression:"form.requester.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.contract"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.enableContract,"items":_vm.contracts,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData'),"maxlength":_vm.constants.LENGTH_CONTRACT},on:{"change":function($event){_vm.form.contractItem.id = null}},model:{value:(_vm.form.contract.id),callback:function ($$v) {_vm.$set(_vm.form.contract, "id", $$v)},expression:"form.contract.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.contractItem"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg6":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.enableContract,"items":_vm.contractItems,"rules":_vm.validation.required,"no-data-text":_vm.$t('message.warning.noData'),"maxlength":_vm.constants.LENGTH_CONTRACT_ITEM},model:{value:(_vm.form.contractItem.id),callback:function ($$v) {_vm.$set(_vm.form.contractItem, "id", $$v)},expression:"form.contractItem.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.relatedDemand")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-select',{attrs:{"autocomplete":"","disabled":_vm.enableAdmin,"items":_vm.demands,"clearable":"","no-data-text":_vm.$t('message.warning.noData'),"maxlength":_vm.constants.LENGTH_DEMAND},on:{"input":_vm.verifyDemand},model:{value:(_vm.form.relatedDemand.id),callback:function ($$v) {_vm.$set(_vm.form.relatedDemand, "id", $$v)},expression:"form.relatedDemand.id"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"subheading mt-3"},[_vm._v(_vm._s(_vm.$t("label.details")))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.demandCreationDetails'))}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.title"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.text,"counter":_vm.constants.LENGTH_TITLE,"maxlength":_vm.constants.LENGTH_TITLE},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.description"))+"*")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":_vm.disabled,"rules":_vm.validation.text,"auto-grow":"","counter":_vm.constants.LENGTH_DESCRIPTION,"maxlength":_vm.constants.LENGTH_DESCRIPTION},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.desirableDate")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('app-menu-date-picker',{attrs:{"model":_vm.form.desirableDate,"disabled":_vm.disabled,"label":_vm.$t('label.desirableDate')},on:{"update:model":function($event){return _vm.$set(_vm.form, "desirableDate", $event)}}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.remarks")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":_vm.disabled,"auto-grow":"","counter":_vm.constants.LENGTH_REMARKS,"maxlength":_vm.constants.LENGTH_REMARKS},model:{value:(_vm.form.remarks),callback:function ($$v) {_vm.$set(_vm.form, "remarks", $$v)},expression:"form.remarks"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.reason")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":_vm.disabled,"auto-grow":"","counter":_vm.constants.LENGTH_REASON,"maxlength":_vm.constants.LENGTH_REASON},model:{value:(_vm.form.reason),callback:function ($$v) {_vm.$set(_vm.form, "reason", $$v)},expression:"form.reason"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.outcome")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":_vm.disabled,"auto-grow":"","counter":_vm.constants.LENGTH_OUTCOME,"maxlength":_vm.constants.LENGTH_OUTCOME},model:{value:(_vm.form.outcome),callback:function ($$v) {_vm.$set(_vm.form, "outcome", $$v)},expression:"form.outcome"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.similarDemandsDescription")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"counter":_vm.constants.LENGTH_SIMILAR_DEMANDS,"maxlength":_vm.constants.LENGTH_SIMILAR_DEMANDS},model:{value:(_vm.form.similarDemandsDescription),callback:function ($$v) {_vm.$set(_vm.form, "similarDemandsDescription", $$v)},expression:"form.similarDemandsDescription"}})],1)],1),_vm._v(" "),(_vm.form.files.length > 0)?_c('div',[_c('div',{staticClass:"subheading mt-3"},[_vm._v(_vm._s(_vm.$t("label.files")))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('message.info.demandFiles'))}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t("label.filesDescription")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-text-field',{attrs:{"multi-line":"","disabled":_vm.disabled,"auto-grow":"","counter":_vm.constants.LENGTH_FILES_DESCRIPTION,"maxlength":_vm.constants.LENGTH_FILES_DESCRIPTION},model:{value:(_vm.form.filesDescription),callback:function ($$v) {_vm.$set(_vm.form, "filesDescription", $$v)},expression:"form.filesDescription"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-3",attrs:{"xs9":"","lg10":"","offset-xs3":"","offset-lg2":""}},[_c('app-files',{attrs:{"files":_vm.form.files,"removedFiles":_vm.form.removedFiles,"removeable":!_vm.disabled},on:{"update:files":function($event){return _vm.$set(_vm.form, "files", $event)},"update:removedFiles":function($event){return _vm.$set(_vm.form, "removedFiles", $event)},"update:removed-files":function($event){return _vm.$set(_vm.form, "removedFiles", $event)}}})],1)],1)],1):_vm._e()],1),_vm._v(" "),(!_vm.disabled || _vm.canCancel || !_vm.disabledContract || _vm.enableAdmin)?_c('v-card-actions',[(_vm.canRequest)?_c('v-btn',{attrs:{"disabled":this.saving || this.canceling,"loading":_vm.processing,"color":"primary"},on:{"click":_vm.advance}},[_vm._v("\n        "+_vm._s(_vm.$t("label.requestApproval"))+"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.disabled)?_c('app-file-upload',{attrs:{"disabled":this.saving || this.processing || this.canceling,"model":_vm.form.files},on:{"update:model":function($event){return _vm.$set(_vm.form, "files", $event)}}}):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.enableAdmin)?_c('v-btn',{attrs:{"disabled":this.processing || this.canceling,"loading":_vm.saving},on:{"click":_vm.save}},[_vm._v("\n        "+_vm._s(_vm.$t("label.save"))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.canCancel)?_c('v-btn',{attrs:{"disabled":this.saving || this.processing,"loading":_vm.canceling,"color":"error"},on:{"click":_vm.cancel}},[_vm._v("\n        "+_vm._s(_vm.$t("label.cancel"))+"\n      ")]):_vm._e()],1):_vm._e()],1),_vm._v(" "),(_vm.canceling)?_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('app-cancel',{attrs:{"message":_vm.$t('message.info.demandCancelRequest'),"isCancelling":_vm.canceling},on:{"update:isCancelling":function($event){_vm.canceling=$event},"update:is-cancelling":function($event){_vm.canceling=$event}}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tD7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("xZzR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d55b5c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("dmPs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d55b5c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tJgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopupModal__ = __webpack_require__("ZdAF");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ConfirmDialogue',

    components: { PopupModal: __WEBPACK_IMPORTED_MODULE_1__PopupModal__["a" /* default */] },

    data: function data() {
        return {
            // Parameters that change depending on the type of dialogue
            title: undefined,
            message: undefined,
            okButton: undefined,
            cancelButton: 'Cancelar',
            resolvePromise: undefined,
            rejectPromise: undefined
        };
    },

    methods: {
        show: function show() {
            var _this = this;

            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.title = opts.title;
            this.message = opts.message;
            this.okButton = opts.okButton;
            if (opts.cancelButton) {
                this.cancelButton = opts.cancelButton;
            }
            // Once we set our config, we tell the popup modal to open
            this.$refs.popup.open();
            // Return promise so the caller can get results
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this.resolvePromise = resolve;
                _this.rejectPromise = reject;
            });
        },
        _confirm: function _confirm() {
            this.$refs.popup.close();
            this.resolvePromise(true);
        },
        _cancel: function _cancel() {
            this.$refs.popup.close();
            this.resolvePromise(false);
            // Or you can throw an error
            // this.rejectPromise(new Error('User cancelled the dialogue'))
        }
    }
});
'filehash zafzsMRgfJqvSR6tawe0vuuxuCA=';

/***/ }),

/***/ "tL9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("yhrj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d0fb2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("RG33");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d0fb2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tbHi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/contracts');
    },
    fetch: function fetch(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/contracts/' + id);
    },
    remove: function remove(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete('/contracts/' + id);
    },
    save: function save(form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/contracts', form);
    },
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/contracts/' + id, form);
    }
});
'filehash qC52jclJRBGFMPRxRQN61dJW8WM=';

/***/ }),

/***/ "tulF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u5xo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Profile__ = __webpack_require__("uL9T");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import constants from '@/helpers/constants';


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            code: '',
            searching: false,
            validation: __WEBPACK_IMPORTED_MODULE_2__helpers_validation__["a" /* default */]
        };
    },

    computed: {
        isAdmin: function isAdmin() {
            return this.$store.getters.isAdmin;
        }
    },
    components: {
        appProfile: __WEBPACK_IMPORTED_MODULE_3__Profile__["a" /* default */]
    },

    methods: {
        search: function search() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var demand;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.searching = true;
                                _context.next = 3;
                                return _this.$store.dispatch('findDemandByCode', { code: _this.code });

                            case 3:
                                demand = _this.$store.getters.demand;

                                if (demand.code === _this.code) {
                                    _this.code = '';
                                    console.log("cdIdentificadorFornecedor = " + demand.supplier.id);
                                    _this.$router.push({ name: 'demandEdit', params: { id: demand.id } });
                                } else {
                                    _this.$store.dispatch('showWarning', _this.$t('message.info.demandNotFound'));
                                }

                                _this.searching = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});
'filehash LHc22+kWJQIFasQeD2LBkxqgAZw=';

/***/ }),

/***/ "uK4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Demand__ = __webpack_require__("R2Zp");








var state = {
    demands: [],
    demandsGrid: [],
    evaluatedDemandsGrid: [],
    demandComments: {},
    demand: {}
};

var mutations = {
    setDemands: function setDemands(state, demands) {
        state.demands = demands;
    },
    setDemandsGrid: function setDemandsGrid(state, demands) {
        state.demandsGrid = demands;
    },
    setEvaluatedDemandsGrid: function setEvaluatedDemandsGrid(state, demands) {
        state.evaluatedDemandsGrid = demands;
    },
    setDemandComments: function setDemandComments(state, demand) {
        state.demandComments = demand;
    },
    setDemand: function setDemand(state, demand) {
        state.demand = demand;
    },
    appendDemand: function appendDemand(state, demand) {
        state.demands.splice(0, 0, demand);
    },
    updateDemand: function updateDemand(state, demand) {
        var index = state.demands.map(function (item) {
            return item.id;
        }).indexOf(demand.id);
        state.demands.splice(index, 1, demand);
    }
};

var actions = {
    // CRUD
    // consulta a demanda selecionada no Grid tela Demadas
    // (tela src\components\demands\Edit.vue fetchDemand).
    fetchDemand: function fetchDemand(_ref, id) {
        var _this = this;

        var commit = _ref.commit,
            dispatch = _ref.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.fetch(id);

                        case 2:
                            response = _context.sent;

                            commit("setDemand", response.data);
                            dispatch("syncDemand", response.data);

                        case 5:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    loadDemands: function loadDemands(_ref2) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.list();

                        case 2:
                            response = _context2.sent;

                            commit("setDemands", response.data);

                        case 4:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    loadDemandsGrid: function loadDemandsGrid(_ref3) {
        var _this3 = this;

        var commit = _ref3.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var responseGrid;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.getForGrid();

                        case 2:
                            responseGrid = _context3.sent;

                            commit("setDemandsGrid", responseGrid.data.output);

                        case 4:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    loadEvaluatedDemandsGrid: function loadEvaluatedDemandsGrid(_ref4, officeId) {
        var _this4 = this;

        var commit = _ref4.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var responseGrid;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.getEvaluatedForGrid(officeId);

                        case 2:
                            responseGrid = _context4.sent;

                            commit("setEvaluatedDemandsGrid", responseGrid.data.output);

                        case 4:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    loadDemandComments: function loadDemandComments(_ref5, demandId) {
        var _this5 = this;

        var commit = _ref5.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.getDemandComments(demandId);

                        case 2:
                            response = _context5.sent;

                            commit("setDemandComments", response.data.output);

                        case 4:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    saveDemand: function saveDemand(_ref6, form) {
        var _this6 = this;

        var dispatch = _ref6.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.save(form);

                        case 2:
                            response = _context6.sent;
                            _context6.next = 5;
                            return dispatch("fetchDemand", response.data.id);

                        case 5:

                            dispatch("showSuccess", __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t("message.success.demandSaved", { code: response.data.code }));

                        case 6:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    },
    saveOrUpdateDemand: function saveOrUpdateDemand(_ref7, form) {
        var _this7 = this;

        var dispatch = _ref7.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmptyOrZero(form.id)) {
                                _context7.next = 5;
                                break;
                            }

                            _context7.next = 3;
                            return dispatch("saveDemand", form);

                        case 3:
                            _context7.next = 7;
                            break;

                        case 5:
                            _context7.next = 7;
                            return dispatch("updateDemand", form);

                        case 7:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }))();
    },
    updateDemand: function updateDemand(_ref8, form) {
        var _this8 = this;

        var dispatch = _ref8.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.update(form.id, form);

                        case 2:
                            _context8.next = 4;
                            return dispatch("fetchDemand", form.id);

                        case 4:

                            dispatch("showSuccess", __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t("message.success.demandSaved", { code: form.code }));

                        case 5:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }))();
    },


    // Actions
    findDemandByCode: function findDemandByCode(_ref9, form) {
        var _this9 = this;

        var commit = _ref9.commit,
            dispatch = _ref9.dispatch,
            state = _ref9.state;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            if (!(__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmpty(form.code) || state.demand.code === form.code)) {
                                _context9.next = 2;
                                break;
                            }

                            return _context9.abrupt("return");

                        case 2:
                            _context9.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.findByCode(form);

                        case 4:
                            response = _context9.sent;

                            if (response.data) {
                                commit("setDemand", response.data);
                                dispatch("syncDemand", response.data);
                            }

                        case 6:
                        case "end":
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9);
        }))();
    },
    approveDemand: function approveDemand(_ref10, _ref11) {
        var _this10 = this;

        var dispatch = _ref10.dispatch;
        var id = _ref11.id,
            comments = _ref11.comments,
            files = _ref11.files,
            code = _ref11.code;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            _context10.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.approve(id, { comments: comments, files: files });

                        case 2:
                            _context10.next = 4;
                            return dispatch("fetchDemand", id);

                        case 4:

                            dispatch("showSuccess", __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t("message.success.demandApproved", { code: code }));

                        case 5:
                        case "end":
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10);
        }))();
    },
    rejectDemand: function rejectDemand(_ref12, _ref13) {
        var _this11 = this;

        var dispatch = _ref12.dispatch;
        var id = _ref13.id,
            comments = _ref13.comments,
            files = _ref13.files,
            code = _ref13.code;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            _context11.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.reject(id, { comments: comments, files: files });

                        case 2:
                            _context11.next = 4;
                            return dispatch("fetchDemand", id);

                        case 4:

                            dispatch("showSuccess", __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t("message.success.demandRejected", { code: code }));

                        case 5:
                        case "end":
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11);
        }))();
    },
    cancelDemand: function cancelDemand(_ref14, _ref15) {
        var _this12 = this;

        var dispatch = _ref14.dispatch;
        var id = _ref15.id,
            comments = _ref15.comments,
            files = _ref15.files,
            code = _ref15.code;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.cancel(id, { comments: comments, files: files });

                        case 2:
                            _context12.next = 4;
                            return dispatch("fetchDemand", id);

                        case 4:

                            dispatch("showSuccess", __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t("message.success.demandCanceled", { code: code }));

                        case 5:
                        case "end":
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12);
        }))();
    },
    requestDemand: function requestDemand(_ref16, _ref17) {
        var _this13 = this;

        var dispatch = _ref16.dispatch;
        var id = _ref17.id,
            code = _ref17.code;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _context13.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.request(id);

                        case 2:
                            _context13.next = 4;
                            return dispatch("fetchDemand", id);

                        case 4:

                            dispatch("showSuccess", __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t("message.success.demandRequested", { code: code }));

                        case 5:
                        case "end":
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13);
        }))();
    },
    planDemand: function planDemand(_ref18, form) {
        var _this14 = this;

        var dispatch = _ref18.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            _context14.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.plan(form.id, form);

                        case 2:
                            _context14.next = 4;
                            return dispatch("fetchDemand", form.id);

                        case 4:

                            dispatch("showSuccess", __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t("message.success.demandRequested", { code: form.code }));

                        case 5:
                        case "end":
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14);
        }))();
    },
    deliverDemand: function deliverDemand(_ref19, form) {
        var _this15 = this;

        var dispatch = _ref19.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _context15.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.deliver(form.id, form);

                        case 2:
                            _context15.next = 4;
                            return dispatch("fetchDemand", form.id);

                        case 4:

                            dispatch("showSuccess", __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t("message.success.demandRequested", { code: form.code }));

                        case 5:
                        case "end":
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15);
        }))();
    },


    // Support
    resetDemand: function resetDemand(_ref20) {
        var commit = _ref20.commit;

        var demand = __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Demand__["a" /* default */].build(this.getters.profile.person);
        commit("setDemand", demand);
    },
    syncDemand: function syncDemand(_ref21, demand) {
        var commit = _ref21.commit;

        var demands = this.getters.demandsDictionary;

        if (__WEBPACK_IMPORTED_MODULE_4__helpers_utilities__["a" /* default */].isEmpty(demands[demand.id])) {
            commit("appendDemand", demand);
        } else {
            commit("updateDemand", demand);
        }
    },
    findDemandByRequest: function findDemandByRequest(_ref22, form) {
        var _this16 = this;

        var commit = _ref22.commit,
            dispatch = _ref22.dispatch,
            state = _ref22.state;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            _context16.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.findByRequest(form);

                        case 2:
                            response = _context16.sent;
                            return _context16.abrupt("return", response);

                        case 4:
                        case "end":
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16);
        }))();
    },
    findDemandByCreator: function findDemandByCreator(_ref23, form) {
        var _this17 = this;

        var commit = _ref23.commit,
            dispatch = _ref23.dispatch,
            state = _ref23.state;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            _context17.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.findByCreator(form);

                        case 2:
                            response = _context17.sent;
                            return _context17.abrupt("return", response);

                        case 4:
                        case "end":
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17);
        }))();
    },
    findDemandByOwner: function findDemandByOwner(_ref24, form) {
        var _this18 = this;

        var commit = _ref24.commit,
            dispatch = _ref24.dispatch,
            state = _ref24.state;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            _context18.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.findByOwner(form);

                        case 2:
                            response = _context18.sent;
                            return _context18.abrupt("return", response);

                        case 4:
                        case "end":
                            return _context18.stop();
                    }
                }
            }, _callee18, _this18);
        }))();
    },
    searchByFilter: function searchByFilter(_ref25, filter) {
        var _this19 = this;

        var commit = _ref25.commit,
            dispatch = _ref25.dispatch,
            state = _ref25.state;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            _context19.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].demands.searchByFilter(filter);

                        case 2:
                            response = _context19.sent;
                            return _context19.abrupt("return", response);

                        case 4:
                        case "end":
                            return _context19.stop();
                    }
                }
            }, _callee19, _this19);
        }))();
    }
};

var getters = {
    demand: function demand(state) {
        return state.demand;
    },
    demands: function demands(state) {
        return state.demands || [];
    },
    demandsGrid: function demandsGrid(state) {
        return state.demandsGrid || [];
    },
    demandComments: function demandComments(state) {
        return state.demandComments;
    },
    evaluatedDemandsGrid: function evaluatedDemandsGrid(state) {
        return state.evaluatedDemandsGrid || [];
    },
    demandsValueText: function demandsValueText(_, getters) {
        return getters.demands.map(function (_ref26) {
            var id = _ref26.id,
                code = _ref26.code,
                title = _ref26.title;
            return {
                value: id,
                text: code + " - " + title
            };
        });
    },
    relatedDemandsValueText: function relatedDemandsValueText(_, getters) {
        var d = getters.demand;
        return getters.demands.filter(function (dm) {
            return dm.id !== d.id;
        }).map(function (_ref27) {
            var id = _ref27.id,
                code = _ref27.code,
                title = _ref27.title;
            return {
                value: id,
                text: code + " - " + title
            };
        });
    },
    demandsNotCanceledOrClosedValueText: function demandsNotCanceledOrClosedValueText(_, getters) {
        return getters.demands.filter(function (dm) {
            return dm.status.id !== 8 && dm.status.id !== 9;
        }).map(function (_ref28) {
            var id = _ref28.id,
                code = _ref28.code,
                title = _ref28.title;
            return {
                value: id,
                text: code + " - " + title
            };
        });
    },
    demandsDictionary: function demandsDictionary(_, getters) {
        return getters.demands.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});
    },
    demandsDictionaryByCode: function demandsDictionaryByCode(_, getters) {
        return getters.demands.reduce(function (map, obj) {
            map[obj.code] = obj;
            return map;
        }, {});
    },
    isExternalSupplier: function isExternalSupplier(_, getters) {
        return state.demand.system.isExternalSupplier;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});
"filehash f7MQf1FRW4czRvoiueigsyrj10A=";

/***/ }),

/***/ "uL9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("rDH2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_112831a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("shUM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_112831a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uZj0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.files),function(file,index){return _c('app-file',{key:file.name,attrs:{"file":file,"index":index,"removeable":_vm.removeable},on:{"remove":_vm.remove}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ukcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("gfkZ");


/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(demandId, userId) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/evaluations?demandId=' + demandId + '&userId=' + userId);
    },
    save: function save(form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/evaluations', form);
    },
    update: function update(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put('/evaluations/' + id, form);
    },
    remove: function remove(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete('/evaluations/' + id);
    }
});
'filehash Q18k4AJgPqlD9q0KgjHBIaN5uZs=';

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v2O3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("HcLV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2c827d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("xEqT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2c827d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x1c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":"","lg1":""}},[_c('label',{staticClass:"form-label"},[_vm._v("Item "+_vm._s(_vm.index + 1))])]),_vm._v(" "),_c('v-flex',{staticClass:"mr-2",attrs:{"xs3":"","lg3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.text,"maxlength":_vm.constants.LENGTH_CONTRACT_ITEM},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-2",attrs:{"xs2":"","lg2":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.biggerThanZero,"mask":_vm.validation.mask.timeAmount},model:{value:(_vm.timeAmount),callback:function ($$v) {_vm.timeAmount=$$v},expression:"timeAmount"}})],1),_vm._v(" "),(_vm.removable)?_c('v-flex',{staticClass:"pt-2",attrs:{"xs1":""}},[_c('v-icon',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.remove}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),(!_vm.removable)?_c('v-flex',{staticClass:"mr-2",attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":true},model:{value:(_vm.estimatedTime),callback:function ($$v) {_vm.estimatedTime=$$v},expression:"estimatedTime"}})],1):_vm._e(),_vm._v(" "),(!_vm.removable)?_c('v-flex',{staticClass:"mr-2",attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":true},model:{value:(_vm.executedTime),callback:function ($$v) {_vm.executedTime=$$v},expression:"executedTime"}})],1):_vm._e(),_vm._v(" "),(!_vm.removable && !_vm.contractCopy)?_c('v-flex',{staticClass:"pt-2",attrs:{"xs0":""}},[_c('v-switch',_vm._g({attrs:{"disabled":_vm.contractInUse},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm.activeState))],1):_vm._e(),_vm._v(" "),(_vm.contractInUse && !_vm.contractCopy)?_c('v-flex',{staticClass:"pt-2",attrs:{"xs1":""}},[_c('span',[_vm._v("**")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xC/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_FileUpload__ = __webpack_require__("R2v+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_Files__ = __webpack_require__("AUsU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Demand__ = __webpack_require__("R2Zp");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        message: {
            type: String,
            required: true
        },
        isCancelling: {
            type: Boolean
        }
    },
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
            valid: true,
            cancelling: false,

            form: __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Demand__["a" /* default */].cancel.build()
        };
    },


    computed: {
        demand: function demand() {
            return this.$store.getters.demand;
        }
    },

    components: {
        appFileUpload: __WEBPACK_IMPORTED_MODULE_3__components_shared_FileUpload__["a" /* default */],
        appFiles: __WEBPACK_IMPORTED_MODULE_4__components_shared_Files__["a" /* default */]
    },

    mounted: function mounted() {
        this.form = __WEBPACK_IMPORTED_MODULE_5__helpers_entities_Demand__["a" /* default */].cancel.copy(this.demand);
    },


    methods: {
        cancel: function cancel() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.cancelling = true;
                                _context.next = 3;
                                return _this.$store.dispatch("cancelDemand", _this.form);

                            case 3:
                                _this.$router.push({ name: "dashboard" });

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        close: function close() {
            this.canceling = false;
            this.$emit("update:isCancelling", false);
        }
    }
});
"filehash 706JDHFA0XTEhrYRYt7m41L2rxs=";

/***/ }),

/***/ "xEqT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[(!_vm.loading)?_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.$t('label.basicInfo')))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.acronym')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg5":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"maxlength":_vm.constants.LENGTH_SYSTEM_ACRONYM},model:{value:(_vm.form.acronym),callback:function ($$v) {_vm.$set(_vm.form, "acronym", $$v)},expression:"form.acronym"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.name')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg5":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.text},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.email')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","lg5":""}},[_c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.validation.email},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.active'))+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","lg10":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.disabled,"color":"primary"},model:{value:(_vm.form.isActive),callback:function ($$v) {_vm.$set(_vm.form, "isActive", $$v)},expression:"form.isActive"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.controlAccess'))+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","lg1":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.disabled,"color":"primary"},model:{value:(_vm.form.controlAccess),callback:function ($$v) {_vm.$set(_vm.form, "controlAccess", $$v)},expression:"form.controlAccess"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v("Controla Contrato?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","lg1":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.disabled,"color":"primary"},model:{value:(_vm.form.controlContract),callback:function ($$v) {_vm.$set(_vm.form, "controlContract", $$v)},expression:"form.controlContract"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v("Controla Avaliação?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","lg1":""}},[_c('v-checkbox',{attrs:{"disabled":_vm.disabled,"color":"primary"},on:{"change":_vm.onChange},model:{value:(_vm.form.controlEvaluation),callback:function ($$v) {_vm.$set(_vm.form, "controlEvaluation", $$v)},expression:"form.controlEvaluation"}})],1),_vm._v(" "),(_vm.form.controlEvaluation)?_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('label.evaluationStartDate')))])]):_vm._e(),_vm._v(" "),(_vm.form.controlEvaluation)?_c('v-flex',{attrs:{"xs2":"","lg2":""}},[_c('app-menu-date-picker',{attrs:{"model":_vm.form.evaluationStartDate,"disabled":_vm.disabled,"label":_vm.$t('label.evaluationStartDate')},on:{"update:model":function($event){return _vm.$set(_vm.form, "evaluationStartDate", $event)}}})],1):_vm._e()],1)],1),_vm._v(" "),(!_vm.disabled)?_c('v-card-actions',[_c('v-btn',{attrs:{"loading":_vm.saving,"color":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('label.save')))]),_vm._v(" "),_c('v-spacer')],1):_vm._e()],1):_c('v-card',[_c('app-card-loader')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_Event__ = __webpack_require__("JShu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_DialogLoader__ = __webpack_require__("mB/l");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        shouldDisplayLoader: function shouldDisplayLoader() {
            return this.$store.getters.isStoreInitializing;
        }
    },

    components: {
        appDialogLoader: __WEBPACK_IMPORTED_MODULE_1__components_shared_DialogLoader__["a" /* default */],
        appEvent: __WEBPACK_IMPORTED_MODULE_0__components_shared_Event__["a" /* default */]
    }
});
'filehash OLYTqc6xQlEQ6139fScL81+JKp4=';

/***/ }),

/***/ "xZzR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__ = __webpack_require__("HUpA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pagination: {
                descending: false,
                sortBy: 'name'
            },
            headers: [{
                text: this.$t('label.office'),
                value: 'office.acronym',
                align: 'left'
            }, {
                text: this.$t('label.acronym'),
                value: 'acronym',
                align: 'left'
            }, {
                text: this.$t('label.name'),
                value: 'name',
                align: 'left'
            }, {
                text: this.$t('label.active') + '?',
                value: 'status',
                align: 'left'
            }, {
                text: this.$t('label.isOutsourced') + '?',
                value: 'outsourced',
                align: 'left'
            }]
        };
    },

    methods: {
        search: function search(filters) {
            var _this = this;

            var areas = this.$store.getters.areas.filter(function (v) {
                return v.isActive && (v.office.id === _this.$store.getters.profile.office || !_this.$store.getters.profile.office);
            });

            return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a" /* default */].filterMultiple(areas, filters, function (area, regex) {
                return regex.test(area.office.acronym) || regex.test(area.acronym) || regex.test(area.name) || regex.test(area.id) || regex.test(area.status) || regex.test(area.outsourced);
            });
        },
        refresh: function refresh() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$store.dispatch('loadAreas');

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    computed: {
        areas: function areas() {
            var _this3 = this;

            var areas = this.$store.getters.areas;
            areas.forEach(function (area) {
                area.status = area.isActive ? _this3.$t('label.yes') : _this3.$t('label.no');
            });
            areas.forEach(function (area) {
                area.outsourced = area.isOutsourced ? _this3.$t('label.yes') : _this3.$t('label.no');
            });
            return areas;
        },
        readonly: function readonly() {
            return !this.$store.getters.isAdmin;
        }
    },
    components: {
        appSercheableDataTable: __WEBPACK_IMPORTED_MODULE_3__shared_SercheableDataTable__["a" /* default */]
    }
});
'filehash tuF3w/9A6TRfSc65IY+yQNKh1VI=';

/***/ }),

/***/ "yCEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("ZQnL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f368c590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("X3z0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f368c590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yb5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-sercheable-data-table',{attrs:{"headers":_vm.headers,"search":_vm.search,"refresh":_vm.refresh,"pagination":_vm.pagination},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'contractEdit', params: { id: item.id }},"tag":"tr"}},[_c('td',{staticClass:"contract-office"},[_vm._v(_vm._s(item.office.officeNameDisplay))]),_vm._v(" "),_c('td',{staticClass:"contract-number"},[_vm._v(_vm._s(item.number))]),_vm._v(" "),_c('td',{staticClass:"validity"},[_vm._v(_vm._s(item.validityTerm.validityDisplay))]),_vm._v(" "),_c('td',{staticClass:"is-active"},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',{staticClass:"contract-estimatedTime"},[_vm._v(_vm._s(item.estimatedTime))]),_vm._v(" "),_c('td',{staticClass:"contract-executedTime"},[_vm._v(_vm._s(item.executedTime))])])]}}])},[(!_vm.readonly)?_c('template',{slot:"afterReloadButton"},[_c('v-btn',{attrs:{"to":{ name: 'contractCreate' },"color":"primary"}},[_vm._v(_vm._s(_vm.$t('label.createContract')))])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ycSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isRoot)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","lg8":"","offset-xs1":"","offset-lg2":""}},[_c('v-card',{staticClass:"pa-2"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('p',{staticClass:"subheading ma-0",staticStyle:{"font-weight":"500"}},[_vm._v("Secretarias")]),_vm._v(" "),_c('p',{staticClass:"grey--text text--darken-1 ma-0"},[_vm._v("Adiciona ou altera secretarias.")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{staticStyle:{"margin-top":"15px"},on:{"click":_vm.manageOffices}},[_vm._v("\n                            Acessar\n                        ")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isRoot || _vm.isAdmin)?_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","lg8":"","offset-xs1":"","offset-lg2":""}},[_c('v-card',{staticClass:"pa-2"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('p',{staticClass:"subheading ma-0",staticStyle:{"font-weight":"500"}},[_vm._v("Áreas")]),_vm._v(" "),_c('p',{staticClass:"grey--text text--darken-1 ma-0"},[_vm._v("Adiciona ou altera áreas.")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{staticStyle:{"margin-top":"15px"},on:{"click":_vm.manageAreas}},[_vm._v("\n                            Acessar\n                        ")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isRoot || _vm.isAdmin || _vm.isHired)?_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","lg8":"","offset-xs1":"","offset-lg2":""}},[_c('v-card',{staticClass:"pa-2"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('p',{staticClass:"subheading ma-0",staticStyle:{"font-weight":"500"}},[_vm._v("Report")]),_vm._v(" "),_c('p',{staticClass:"grey--text text--darken-1 ma-0"},[_vm._v("Gerar relatórios de faturamento de demandas")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{staticStyle:{"margin-top":"15px"},on:{"click":_vm.createReport}},[_vm._v("\n                            Acessar\n                        ")])],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yeq2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_CardLoader__ = __webpack_require__("JqcZ");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
            pagination: {
                descending: true,
                sortBy: 'code'
            },
            ownedHeaders: [{
                text: this.$t('label.code'),
                value: 'code',
                align: 'left'
            }, {
                text: this.$t('label.system'),
                value: 'system.acronym',
                align: 'left'
            }, {
                text: this.$t('label.status'),
                value: 'status.id',
                align: 'left'
            }, {
                text: this.$t('label.demandType'),
                value: 'type.name',
                align: 'left'
            }, {
                text: this.$t('label.receivedDate'),
                value: 'creator.name',
                align: 'left'
            }, {
                text: this.$t('label.name'),
                value: 'title',
                align: 'left'
            }],
            createdHeaders: [{
                text: this.$t('label.code'),
                value: 'code',
                align: 'left'
            }, {
                text: this.$t('label.system'),
                value: 'system.acronym',
                align: 'left'
            }, {
                text: this.$t('label.status'),
                value: 'status.id',
                align: 'left'
            }, {
                text: this.$t('label.owner'),
                value: 'owner.name',
                align: 'left'
            }, {
                text: this.$t('label.name'),
                value: 'title',
                align: 'left'
            }],
            requestedHeaders: [{
                text: this.$t('label.code'),
                value: 'code',
                align: 'left'
            }, {
                text: this.$t('label.system'),
                value: 'system.acronym',
                align: 'left'
            }, {
                text: this.$t('label.status'),
                value: 'status.id',
                align: 'left'
            }, {
                text: this.$t('label.requester'),
                value: 'requester.name',
                align: 'left'
            }, {
                text: this.$t('label.name'),
                value: 'title',
                align: 'left'
            }],
            requestedDemands: [],
            createdDemands: [],
            ownedDemands: [],
            loadingRequester: false,
            loadingOwner: false,
            loadingCreator: false,
            demands: this.$store.getters.demandsValueText,
            demandId: null
        };
    },


    computed: {
        owned: function owned() {
            var person = this.$store.getters.profile.person;

            var approvers = this.$store.getters.systems.map(function (_ref) {
                var approvers = _ref.approvers;
                return approvers;
            }).reduce(
            // agrupa em um array só todos os aprovadores
            function (arr, currValue) {
                return arr.concat(currValue);
            }, [])
            // filtra pelo usuario
            .filter(function (apr) {
                return apr.person.id === person.id;
            });
            // retorna as demandas que o usuário é aprovador na etapa que a demanda se encontra
            return this.$store.getters.demands.filter(function (demand) {
                return demand.status.id < __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_REJECTED && (demand.owner.id === person.id || approvers.findIndex(function (approver) {
                    return approver.system.id === demand.system.id && approver.type.id === demand.ownerType;
                }) !== -1);
            });
            // return this.$store.getters.demands.filter(demand =>
            //     demand.owner.id === person.id &&
            //     demand.status.id < constants.STATUS_REJECTED,
            //  );
        },
        created: function created() {
            var person = this.$store.getters.profile.person;
            return this.$store.getters.demands.filter(function (demand) {
                return demand.creator.id === person.id && demand.requester.id !== person.id && demand.status.id < __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_REJECTED;
            });
        },
        requested: function requested() {
            var person = this.$store.getters.profile.person;
            return this.$store.getters.demands.filter(function (demand) {
                return demand.requester.id === person.id && demand.status.id < __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_REJECTED;
            });
        }
    },
    components: {
        appCardLoader: __WEBPACK_IMPORTED_MODULE_3__components_shared_CardLoader__["a" /* default */]
    },
    methods: {
        demandasPorSolicitante: function demandasPorSolicitante() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var person, res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loadingRequester = true;
                                person = _this.$store.getters.profile.person;
                                _context.next = 4;
                                return _this.$store.dispatch('findDemandByRequest', person.id);

                            case 4:
                                res = _context.sent;

                                _this.requestedDemands = res.data.output;
                                _this.loadingRequester = false;

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        demandasPorCriador: function demandasPorCriador() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var person, res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.loadingCreator = true;
                                person = _this2.$store.getters.profile.person;
                                _context2.next = 4;
                                return _this2.$store.dispatch('findDemandByCreator', person.id);

                            case 4:
                                res = _context2.sent;

                                _this2.createdDemands = res.data.output;
                                _this2.loadingCreator = false;

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        demandasPorResponsavel: function demandasPorResponsavel() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var person, res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.loadingOwner = true;
                                person = _this3.$store.getters.profile.person;
                                _context3.next = 4;
                                return _this3.$store.dispatch('findDemandByOwner', person.id);

                            case 4:
                                res = _context3.sent;

                                _this3.ownedDemands = res.data.output;
                                _this3.loadingOwner = false;

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    },
    beforeMount: function beforeMount() {
        this.demandasPorSolicitante();
        this.demandasPorCriador();
        this.demandasPorResponsavel();
    }
});
'filehash wFSnnupbVremF1PyYxqkbLBBDIo=';

/***/ }),

/***/ "yhrj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_CardLoader__ = __webpack_require__("JqcZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_entities_DemandOwnerSubstitution__ = __webpack_require__("nQlK");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_4__helpers_validation__["a" /* default */],

            saving: false,
            loading: true,
            removing: false,

            persons: this.$store.getters.personsValueText,
            demands: this.$store.getters.demandsNotCanceledOrClosedValueText,
            form: __WEBPACK_IMPORTED_MODULE_6__helpers_entities_DemandOwnerSubstitution__["a" /* default */].build()
        };
    },


    computed: {
        disabled: function disabled() {
            return !this.$store.getters.isAdmin;
        },
        filteredPersons: function filteredPersons() {
            var _this = this;

            var originalOwner = this.$store.getters.personsDictionary[this.form.originalOwner.id];
            var substitute = this.$store.getters.personsDictionary[this.form.substituteOwner.id];

            // If the new original owner is of a different type (contracted/not contracted)
            //  than the current substitute, remove the substitute
            if (originalOwner.isHired !== (substitute || {}).isHired) {
                this.form.substituteOwner.id = 0;
            }

            var persons = [];
            if (originalOwner.isHired) {
                persons = this.$store.getters.personsHired;
            } else {
                persons = this.$store.getters.personsNotHired;
            }

            if (originalOwner.office && originalOwner.office.id > 0) {
                persons = persons.filter(function (person) {
                    return person.office && person.office.id === originalOwner.office.id;
                });
            }

            if (originalOwner.isOutsourced) {
                persons = persons.filter(function (person) {
                    return person.area && person.area.id === originalOwner.area.id;
                });
            }

            persons = persons.filter(function (person) {
                return person.isActive;
            }).map(function (_ref) {
                var id = _ref.id,
                    username = _ref.username,
                    name = _ref.name;
                return {
                    value: id,
                    text: username + " - " + name
                };
            });

            return persons.filter(function (i) {
                return _this.form.originalOwner.id !== i.value;
            });
        },
        transient: function transient() {
            return !this.form.id;
        }
    },

    components: {
        appCardLoader: __WEBPACK_IMPORTED_MODULE_5__components_shared_CardLoader__["a" /* default */]
    },

    watch: {
        $route: "fetch"
    },

    created: function created() {
        this.fetch();
    },


    methods: {
        fetch: function fetch() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var id, demandCode, demandId, demandExistsInList;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this2.loading = true;

                                id = _this2.$route.params.id;
                                demandCode = _this2.$route.params.demandCode;
                                demandId = _this2.$route.params.demandId;
                                demandExistsInList = _this2.demands.find(function (i) {
                                    return i.value === demandId;
                                });

                                if (__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isEmptyOrZero(id)) {
                                    _context.next = 12;
                                    break;
                                }

                                if (!(demandExistsInList === undefined)) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 9;
                                return _this2.search(demandCode);

                            case 9:
                                _context.next = 11;
                                return _this2.$store.dispatch("fetchDemandOwnerSubstitution", id);

                            case 11:
                                _this2.form = __WEBPACK_IMPORTED_MODULE_6__helpers_entities_DemandOwnerSubstitution__["a" /* default */].toForm(_this2.$store.getters.demandOwnerSubstitution);

                            case 12:
                                _this2.loading = false;

                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        remove: function remove() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.removing = true;
                                _context2.next = 3;
                                return _this3.$store.dispatch("removeDemandOwnerSubstitution", __WEBPACK_IMPORTED_MODULE_6__helpers_entities_DemandOwnerSubstitution__["a" /* default */].toPayload(_this3.form));

                            case 3:
                                _this3.$router.push({ name: "demandOwnerSubstitutionIndex" });

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        save: function save() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (_this4.$refs.form.validate()) {
                                    _context3.next = 2;
                                    break;
                                }

                                return _context3.abrupt("return");

                            case 2:
                                _context3.prev = 2;

                                _this4.saving = true;

                                _context3.next = 6;
                                return _this4.$store.dispatch("saveOrUpdateDemandOwnerSubstitution", __WEBPACK_IMPORTED_MODULE_6__helpers_entities_DemandOwnerSubstitution__["a" /* default */].toPayload(_this4.form));

                            case 6:
                                _this4.$router.push({ name: "demandOwnerSubstitutionIndex" });
                                _context3.next = 16;
                                break;

                            case 9:
                                _context3.prev = 9;
                                _context3.t0 = _context3["catch"](2);

                                if (!(_context3.t0.data && _context3.t0.data.code === "generic_error")) {
                                    _context3.next = 15;
                                    break;
                                }

                                _this4.saving = false;
                                _context3.next = 16;
                                break;

                            case 15:
                                throw _context3.t0;

                            case 16:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4, [[2, 9]]);
            }))();
        },
        search: function search(demandCode) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var demand;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this5.$store.dispatch("findDemandByCode", {
                                    code: demandCode
                                });

                            case 2:
                                demand = _this5.$store.getters.demand;

                                if (demand.code === demandCode) {
                                    _this5.demands = _this5.$store.getters.demandsValueText;
                                } else {
                                    _this5.$store.dispatch("showWarning", _this5.$t("message.info.demandNotFound"));
                                }

                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        }
    },
    mounted: function mounted() {}
});
"filehash CmzM/ajmJIleDxKS7dvP+CCSMxM=";

/***/ }),

/***/ "yqtT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zJdg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_constants__ = __webpack_require__("eHeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilities__ = __webpack_require__("ml+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_validation__ = __webpack_require__("6OHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_FileUpload__ = __webpack_require__("R2v+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_Files__ = __webpack_require__("AUsU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_MenuDatePicker__ = __webpack_require__("Z1KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_entities_Demand__ = __webpack_require__("R2Zp");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            constants: __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */],
            validation: __WEBPACK_IMPORTED_MODULE_4__helpers_validation__["a" /* default */],
            valid: true,
            saving: false,

            form: __WEBPACK_IMPORTED_MODULE_8__helpers_entities_Demand__["a" /* default */].delivery.build()
        };
    },


    computed: {
        demand: function demand() {
            return this.$store.getters.demand;
        },
        disabled: function disabled() {
            return !(this.demand.status.id === __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_DELIVERY) || !__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isDemandActionable(this.$store.getters.profile, this.demand.owner, this.demand.status, __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_DELIVERY);
        },
        desabilitaRequestApproval: function desabilitaRequestApproval() {
            return this.demand.status.id === __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_DELIVERY && this.demand.supplier.id === 1;
        },
        disabledExecutedTime: function disabledExecutedTime() {
            var hasDisabled = !(this.demand.status.id === __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_DELIVERY) || !__WEBPACK_IMPORTED_MODULE_3__helpers_utilities__["a" /* default */].isDemandActionable(this.$store.getters.profile, this.demand.owner, this.demand.status, __WEBPACK_IMPORTED_MODULE_2__helpers_constants__["a" /* default */].STATUS_DELIVERY);

            return hasDisabled;
        },
        unit: function unit() {
            var id = (this.demand.contract || {}).id;
            return !id ? "" : this.$store.getters.contractsDictionary[id].unit.name.toLowerCase();
        }
    },
    components: {
        appFileUpload: __WEBPACK_IMPORTED_MODULE_5__components_shared_FileUpload__["a" /* default */],
        appFiles: __WEBPACK_IMPORTED_MODULE_6__components_shared_Files__["a" /* default */],
        appMenuDatePicker: __WEBPACK_IMPORTED_MODULE_7__components_shared_MenuDatePicker__["a" /* default */]
    },
    watch: {
        demand: "copyToForm"
    },
    methods: {
        save: function save() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.$refs.form.validate()) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 2:

                                _this.saving = true;
                                _context.next = 5;
                                return _this.$store.dispatch("deliverDemand", __WEBPACK_IMPORTED_MODULE_8__helpers_entities_Demand__["a" /* default */].delivery.prepare(_this.form));

                            case 5:
                                _this.$router.push({ name: "dashboard" });

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        copyToForm: function copyToForm(demand) {
            this.form = __WEBPACK_IMPORTED_MODULE_8__helpers_entities_Demand__["a" /* default */].delivery.copy(demand);
            this.form.plannedTime = this.form.plannedTime || this.demand.estimatedTime;
        }
    }
});
"filehash CBCZC+ptQSTRL4QW5V04gT23Hn4=";

/***/ }),

/***/ "ziJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","md10":"","offset-md1":"","lg8":"","offset-lg2":""}},[_c('v-stepper',{model:{value:(_vm.currentStep),callback:function ($$v) {_vm.currentStep=$$v},expression:"currentStep"}},[_c('v-stepper-header',{staticClass:"elevation-0"},[_c('v-stepper-step',{attrs:{"step":"1","editable":_vm.isDemandEnabled,"complete":_vm.isDemandEnabled,"edit-icon":_vm.demandIcon}},[_vm._v(_vm._s(_vm.$t("label.request")))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","editable":_vm.isPlanningEnabled,"complete":_vm.isPlanningEnabled,"edit-icon":_vm.planningIcon}},[_vm._v(_vm._s(_vm.$t("label.planning")))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","editable":_vm.isValidationEnabled,"complete":_vm.isValidationEnabled,"edit-icon":_vm.validationIcon}},[_vm._v(_vm._s(_vm.$t("label.delivery")))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4","editable":_vm.isClosureEnabled,"complete":_vm.isClosureEnabled,"edit-icon":_vm.closureIcon}},[_vm._v(_vm._s(_vm.$t("label.closure")))])],1),_vm._v(" "),_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"ma-0",attrs:{"indeterminate":true}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-title',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('dl',{staticClass:"details-list"},[_c('dt',[_vm._v(_vm._s(_vm.$t("label.code")))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.code))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t("label.status")))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.status))]),_vm._v(" "),(!_vm.showOwner && _vm.currentStep == '1' && _vm.dtImplementation)?_c('dt',[_vm._v("\n                                            "+_vm._s(_vm.$t("label.dtImplementacao"))+"\n                                        ")]):_vm._e(),_vm._v(" "),(!_vm.showOwner && _vm.currentStep == '1' && _vm.dtImplementation)?_c('dd',[_vm._v("\n                                            "+_vm._s(_vm.formatDateAndSubtractDays(_vm.dtImplementation, _vm.qtdDays))+"\n                                        ")]):_vm._e(),_vm._v(" "),(!_vm.showOwner && _vm.currentStep == '4' && _vm.dtImplementation)?_c('dt',[_vm._v("\n                                            "+_vm._s(_vm.$t("label.implantacao"))+"\n                                        ")]):_vm._e(),_vm._v(" "),(!_vm.showOwner && _vm.currentStep == '4' && _vm.dtImplementation)?_c('dd',[_vm._v("\n                                            "+_vm._s(_vm.formatDate(_vm.dtImplementation))+"\n                                        ")]):_vm._e(),_vm._v(" "),(!_vm.showOwner && _vm.currentStep == '4' && _vm.dtImplementation)?_c('dt',[_vm._v("\n                                            "+_vm._s(_vm.$t("label.garantia"))+"\n                                        ")]):_vm._e(),_vm._v(" "),(!_vm.showOwner && _vm.currentStep == '4' && _vm.dtImplementation)?_c('dd',[_vm._v("\n                                            "+_vm._s(_vm.formatDateAndSubtractDays(_vm.dtImplementation, _vm.qtdDays))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.showOwner)?_c('dt',[_vm._v("\n                                            "+_vm._s(_vm.$t("label.owner"))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.showOwner)?_c('dd',[_vm._v("\n                                            "+_vm._s(_vm.owner)+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.showOwner && _vm.currentStep != '4' && _vm.currentStep != '2' && _vm.currentStep != '3' && _vm.dtImplementation)?_c('dt',[_vm._v("\n                                            "+_vm._s(_vm.$t("label.dtImplementacao"))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.showOwner && _vm.currentStep != '4' && _vm.currentStep != '2' && _vm.currentStep != '3' && _vm.dtImplementation)?_c('dd',[_vm._v("\n                                            "+_vm._s(_vm.formatDateAndSubtractDays(_vm.dtImplementation, _vm.qtdDays))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.showOwner && _vm.currentStep == '4' && _vm.dtImplementation)?_c('dt',[_vm._v("\n                                            "+_vm._s(_vm.$t("label.implantacao"))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.showOwner && _vm.currentStep == '4' && _vm.dtImplementation)?_c('dd',[_vm._v("\n                                            "+_vm._s(_vm.formatDate(_vm.dtImplementation))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.showOwner && _vm.currentStep == '4' && _vm.dtImplementation)?_c('dt',[_vm._v("\n                                            "+_vm._s(_vm.$t("label.garantia"))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.showOwner && _vm.currentStep == '4' && _vm.dtImplementation)?_c('dd',[_vm._v("\n                                            "+_vm._s(_vm.formatDateAndSubtractDays(_vm.dtImplementation, _vm.qtdDays))+"\n                                        ")]):_vm._e(),_vm._v(" "),(
                                            this.$store.getters.demand.status.id == 9 &&
                                            this.$store.getters.demand.scoreAverage !== 0)?_c('dt',{staticStyle:{"margin-left":"auto"}},[_vm._v("Média Avaliação")]):_vm._e(),_vm._v(" "),(
                                            this.$store.getters.demand.status.id == 9 &&
                                            this.$store.getters.demand.scoreAverage !== 0)?_c('dd',[_vm._v(_vm._s(this.$store.getters.demand.scoreAverage))]):_vm._e()])])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('app-creation')],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('app-planning')],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('app-delivery')],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.demand.id != 0 && _vm.demand.status.id == 6 && _vm.currentStep == 3)?_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('app-evaluation')],1)],1):_vm._e(),_vm._v(" "),(_vm.demand.id != 0)?_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('app-workflow-history',{attrs:{"items":_vm.workFlowHistoryForCurrentStep}})],1)],1):_vm._e(),_vm._v(" "),_c('transition',[(_vm.canApprove)?_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","lg8":"","offset-lg2":""}},[_c('app-approve',{attrs:{"message":_vm.approvalMessage}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8976a58e939690af553c.js